export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never
}
export type Incremental<T> =
  T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  DateTime: { input: any; output: any }
  JSON: { input: any; output: any }
  JSONObject: { input: any; output: any }
  Upload: { input: any; output: any }
  Void: { input: any; output: any }
}

export type AcceptLegalConsentInput = {
  identifier: Scalars['String']['input']
  proofText: Scalars['String']['input']
}

export type AcceptMarketingPlanOutlineInput = {
  planId: Scalars['ID']['input']
}

export enum Accessibility {
  NotRequired = 'NOT_REQUIRED',
  Optional = 'OPTIONAL',
  Required = 'REQUIRED',
}

export type Activity = {
  __typename?: 'Activity'
  company?: Maybe<Company>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id?: Maybe<Scalars['ID']['output']>
  invitation?: Maybe<ActivityInvitation>
  isBatch?: Maybe<Scalars['Boolean']['output']>
  marketingTopic?: Maybe<ActivityMarketingTopic>
  post?: Maybe<ActivityPost>
  scheduledAt?: Maybe<Scalars['DateTime']['output']>
  type?: Maybe<ActivityType>
}

export type ActivityInvitation = {
  __typename?: 'ActivityInvitation'
  leadsCount?: Maybe<Scalars['Int']['output']>
  text?: Maybe<Scalars['String']['output']>
}

export type ActivityMarketingTopic = {
  __typename?: 'ActivityMarketingTopic'
  description?: Maybe<Scalars['String']['output']>
  isAiGenerated?: Maybe<Scalars['Boolean']['output']>
  title?: Maybe<Scalars['String']['output']>
}

export type ActivityPost = {
  __typename?: 'ActivityPost'
  imagePath?: Maybe<Scalars['String']['output']>
  socialMediaPosts?: Maybe<Array<Maybe<ActivitySocialMediaPost>>>
  text?: Maybe<Scalars['String']['output']>
}

export type ActivitySocialMediaPost = {
  __typename?: 'ActivitySocialMediaPost'
  completedAt?: Maybe<Scalars['DateTime']['output']>
  failureReason?: Maybe<Scalars['String']['output']>
  hasFailed?: Maybe<Scalars['Boolean']['output']>
  permalink?: Maybe<Scalars['String']['output']>
  type?: Maybe<Scalars['String']['output']>
}

export enum ActivityType {
  Invitation = 'INVITATION',
  MarketingTopic = 'MARKETING_TOPIC',
  Post = 'POST',
}

export type AdMaterial = {
  __typename?: 'AdMaterial'
  assetType?: Maybe<AssetType>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  displayName?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  imageSource?: Maybe<ImageSources>
  previewUrl: Scalars['String']['output']
  topicId?: Maybe<Scalars['ID']['output']>
  topicName?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  url: Scalars['String']['output']
}

export type AdMaterialFilters = {
  __typename?: 'AdMaterialFilters'
  assetTypes?: Maybe<Array<Maybe<AssetTypeFilter>>>
  imageSources?: Maybe<Array<Maybe<ImageSourceFilter>>>
  topics?: Maybe<Array<Maybe<TopicFilter>>>
}

export type AdMaterialsFilterInput = {
  /** Filter by asset types (SOCIAL_IMAGE, VIDEO, DOCUMENT) */
  assetTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Filter by image sources (USER, AI, MATERIAL) */
  imageSources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** Items per page for pagination (default: 40) */
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>
  /** Page number for pagination (default: 1) */
  page?: InputMaybe<Scalars['Int']['input']>
  /** Search term to filter by name */
  search?: InputMaybe<Scalars['String']['input']>
  /** Sort order (new, old) */
  sortOrder?: InputMaybe<Scalars['String']['input']>
  /** Filter by topic IDs */
  topicIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

export type AdMaterialsResponse = {
  __typename?: 'AdMaterialsResponse'
  adMaterials: Array<AdMaterial>
  filters?: Maybe<AdMaterialFilters>
  meta?: Maybe<PaginationMeta>
}

export type AddCompanyImageInput = {
  companyId: Scalars['String']['input']
  image: SingleFileAddInput
  type: Scalars['String']['input']
}

export type AddDocumentToContractInput = {
  contractId: Scalars['ID']['input']
  document: ContractDocumentUploadInput
}

export type AddDocumentToOnboardingInput = {
  companyId: Scalars['String']['input']
  document: ContractDocumentUploadInput
}

export type AddFacebookPageInput = {
  pageId: Scalars['String']['input']
}

export type AddFreeSignUpTokensInput = {
  partner: Scalars['String']['input']
  tokens: Array<InputMaybe<Scalars['String']['input']>>
}

export type AddLeadsPipelineStatusInput = {
  name: Scalars['String']['input']
  position: Scalars['Int']['input']
}

export type AddLinkedinPageInput = {
  organizationUrn: Scalars['String']['input']
}

export type AddMarketingPlanSlotInput = {
  date: Scalars['String']['input']
  planId: Scalars['ID']['input']
  platform: SocialMediaType
  time: Scalars['String']['input']
}

export type AddProductsToContractInput = {
  contractId: Scalars['ID']['input']
  products: Array<CreateProductInput>
}

export type AddVouchersInput = {
  codes: Array<Scalars['String']['input']>
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>
  type: VoucherType
}

export type Address = {
  __typename?: 'Address'
  city?: Maybe<Scalars['String']['output']>
  country?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['String']['output']>
  street?: Maybe<Scalars['String']['output']>
  zip?: Maybe<Scalars['String']['output']>
}

export type AiSettings = {
  __typename?: 'AiSettings'
  contentCreatorSettings?: Maybe<ContentCreatorSettings>
  formality?: Maybe<Formality>
  language?: Maybe<Scalars['String']['output']>
  perspective?: Maybe<Perspective>
  targetGroup?: Maybe<Scalars['String']['output']>
  tonality?: Maybe<Tonality>
}

export type AiSettingsInput = {
  contentCreatorSettings?: InputMaybe<ContentCreatorSettingsInput>
  formality?: InputMaybe<Formality>
  language?: InputMaybe<Scalars['String']['input']>
  perspective?: InputMaybe<Perspective>
  targetGroup?: InputMaybe<Scalars['String']['input']>
  tonality?: InputMaybe<Tonality>
}

export type AiSummary = {
  __typename?: 'AiSummary'
  generatedAt?: Maybe<Scalars['DateTime']['output']>
  summary?: Maybe<Scalars['String']['output']>
}

export type AllActivities = {
  __typename?: 'AllActivities'
  activities?: Maybe<Array<Maybe<Activity>>>
  page?: Maybe<Scalars['Int']['output']>
  perPage?: Maybe<Scalars['Int']['output']>
  total?: Maybe<Scalars['Int']['output']>
}

export type AllLeadActivities = {
  __typename?: 'AllLeadActivities'
  activities?: Maybe<Array<Maybe<LeadFeedActivity>>>
  page?: Maybe<Scalars['Int']['output']>
  perPage?: Maybe<Scalars['Int']['output']>
  total?: Maybe<Scalars['Int']['output']>
}

export type Ambassador = {
  __typename?: 'Ambassador'
  contactSlogan?: Maybe<Scalars['String']['output']>
  contactText?: Maybe<Scalars['String']['output']>
  email?: Maybe<Scalars['String']['output']>
  facebook?: Maybe<Scalars['String']['output']>
  firstname?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  image?: Maybe<File>
  instagram?: Maybe<Scalars['String']['output']>
  lastname?: Maybe<Scalars['String']['output']>
  linkedin?: Maybe<Scalars['String']['output']>
  mobile?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
  role?: Maybe<Scalars['String']['output']>
  salutation?: Maybe<Scalars['String']['output']>
  signature?: Maybe<Signature>
  twitter?: Maybe<Scalars['String']['output']>
}

export type AmbassadorMobileArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>
}

export type AmbassadorPhoneArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>
}

export type AmbassadorBaseDataInput = {
  email?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
}

export type ApproveAndPublishMaterialBundleInput = {
  candidates: Array<MaterialBundleApprovalCandidateInput>
  companyId: Scalars['ID']['input']
  landingpageId: Scalars['ID']['input']
}

export type ApproveSlotsInput = {
  planId: Scalars['ID']['input']
  slotIds: Array<Scalars['ID']['input']>
}

export enum AssetType {
  Ad = 'AD',
  Banner = 'BANNER',
  Checklist = 'CHECKLIST',
  Coaster = 'COASTER',
  Document = 'DOCUMENT',
  Flyer = 'FLYER',
  FlyerA5 = 'FLYER_A5',
  Guide = 'GUIDE',
  Newspaper = 'NEWSPAPER',
  PostcardBlank = 'POSTCARD_BLANK',
  PostcardText = 'POSTCARD_TEXT',
  Poster = 'POSTER',
  ShoppingCart = 'SHOPPING_CART',
  SocialImage = 'SOCIAL_IMAGE',
  SocialStory = 'SOCIAL_STORY',
  Unknown = 'UNKNOWN',
  Video = 'VIDEO',
}

export type AssetTypeFilter = {
  __typename?: 'AssetTypeFilter'
  count: Scalars['Int']['output']
  type?: Maybe<AssetType>
}

export type AssignLeadsInput = {
  leadIds: Array<InputMaybe<Scalars['ID']['input']>>
  userId: Scalars['ID']['input']
}

export type AssignOnboardingBillingOrderIdInput = {
  orderId: Scalars['String']['input']
}

export type AssignValuationToLeadInput = {
  leadId: Scalars['ID']['input']
  valuationId: Scalars['ID']['input']
}

export type AssistantChatInput = {
  agentId?: InputMaybe<Scalars['String']['input']>
  context?: InputMaybe<AssistantUiContextInput>
  history?: InputMaybe<Array<AssistantHistoryMessageInput>>
  message: Scalars['String']['input']
}

export type AssistantConversation = {
  __typename?: 'AssistantConversation'
  messages: Array<AssistantConversationMessage>
}

export type AssistantConversationMessage = {
  __typename?: 'AssistantConversationMessage'
  content: Scalars['String']['output']
  display?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['String']['output']
  isBootstrap?: Maybe<Scalars['Boolean']['output']>
  kind?: Maybe<Scalars['String']['output']>
  meta?: Maybe<Scalars['JSON']['output']>
  role: Scalars['String']['output']
}

export type AssistantHistoryMessageInput = {
  content: Scalars['String']['input']
  id: Scalars['String']['input']
  role: Scalars['String']['input']
}

export type AssistantOnboardingBootstrapInput = {
  afterWebsiteScrape?: InputMaybe<Scalars['Boolean']['input']>
  /** When true, wizard includes CONTRACT billing step after enter-data */
  billingStepRequired?: InputMaybe<Scalars['Boolean']['input']>
  crmIsConnected?: InputMaybe<Scalars['Boolean']['input']>
  /** Makler enter-data layout: chat | chat+form | form */
  enterDataMode?: InputMaybe<Scalars['String']['input']>
  fetchingWebsiteDetails?: InputMaybe<Scalars['Boolean']['input']>
  /** User explicitly selected "I don't have a website" — genaisis skips the website intake prompt and the scrape. */
  hasNoWebsite?: InputMaybe<Scalars['Boolean']['input']>
  /** UI locale (e.g. "de", "pl") — localizes the assistant's replies. */
  locale?: InputMaybe<Scalars['String']['input']>
  missingFields?: InputMaybe<Array<Scalars['String']['input']>>
  websiteUrl?: InputMaybe<Scalars['String']['input']>
}

export type AssistantOnboardingCreateSessionInput = {
  companyName?: InputMaybe<Scalars['String']['input']>
  /** UI locale (e.g. "de", "pl") — localizes the assistant's replies. */
  locale?: InputMaybe<Scalars['String']['input']>
  websiteUrl?: InputMaybe<Scalars['String']['input']>
}

export type AssistantOnboardingMessageInput = {
  /** Optional enter-data form snapshot — syncs values already filled in the UI. */
  formFields?: InputMaybe<Scalars['JSON']['input']>
  /** UI locale — refreshes the session locale if the user changed language. */
  locale?: InputMaybe<Scalars['String']['input']>
  message: Scalars['String']['input']
}

export type AssistantOnboardingToolInput = {
  data?: InputMaybe<Scalars['JSON']['input']>
  tool: Scalars['String']['input']
}

export type AssistantPendingAction = {
  __typename?: 'AssistantPendingAction'
  current_value?: Maybe<Scalars['JSON']['output']>
  field: Scalars['String']['output']
  id: Scalars['String']['output']
  label: Scalars['String']['output']
  label_key: Scalars['String']['output']
  mutation: Scalars['String']['output']
  proposed_value?: Maybe<Scalars['JSON']['output']>
  status: Scalars['String']['output']
  target_step: Scalars['String']['output']
}

export type AssistantResponse = {
  __typename?: 'AssistantResponse'
  action?: Maybe<AssistantPendingAction>
  assistant_message?: Maybe<Scalars['String']['output']>
  content?: Maybe<Scalars['String']['output']>
  queued_actions?: Maybe<Array<AssistantPendingAction>>
  type: Scalars['String']['output']
}

export type AssistantUiContextInput = {
  active_step_id?: InputMaybe<Scalars['String']['input']>
  agent_id?: InputMaybe<Scalars['String']['input']>
  current_route?: InputMaybe<Scalars['String']['input']>
  current_values?: InputMaybe<Scalars['JSON']['input']>
  step_index?: InputMaybe<Scalars['Int']['input']>
  step_title?: InputMaybe<Scalars['String']['input']>
  visible_fields?: InputMaybe<Array<Scalars['String']['input']>>
}

export enum AvailableStartDate {
  DependingOnOffer = 'DEPENDING_ON_OFFER',
  DependingOnSale = 'DEPENDING_ON_SALE',
  Earliest = 'EARLIEST',
  LessThan_6Month = 'LESS_THAN_6_MONTH',
  MoreThan_6Month = 'MORE_THAN_6_MONTH',
}

export type Avv = {
  __typename?: 'Avv'
  acceptedAt?: Maybe<Scalars['DateTime']['output']>
  acceptedByUserId?: Maybe<Scalars['String']['output']>
}

export type Billing = {
  __typename?: 'Billing'
  address?: Maybe<BillingAddress>
  bic?: Maybe<Scalars['String']['output']>
  contact?: Maybe<BillingContact>
  hasSeparateBillingAddress?: Maybe<Scalars['Boolean']['output']>
  iban?: Maybe<Scalars['String']['output']>
  paymentMethod?: Maybe<PaymentMethod>
  sepaValidAsOf?: Maybe<Scalars['DateTime']['output']>
  taxNumber?: Maybe<Scalars['String']['output']>
  vatId?: Maybe<Scalars['String']['output']>
  vatIdRequestDate?: Maybe<Scalars['DateTime']['output']>
}

export type BillingAddress = {
  __typename?: 'BillingAddress'
  city?: Maybe<Scalars['String']['output']>
  street?: Maybe<Scalars['String']['output']>
  zip?: Maybe<Scalars['String']['output']>
}

export type BillingAddressInput = {
  city: Scalars['String']['input']
  street: Scalars['String']['input']
  zip: Scalars['String']['input']
}

export type BillingAdminDetails = {
  __typename?: 'BillingAdminDetails'
  contractAdminUrl?: Maybe<Scalars['String']['output']>
  customerAdminUrl?: Maybe<Scalars['String']['output']>
}

export type BillingContact = {
  __typename?: 'BillingContact'
  companyName?: Maybe<Scalars['String']['output']>
  companyNameAddition?: Maybe<Scalars['String']['output']>
  email?: Maybe<Scalars['String']['output']>
  firstname?: Maybe<Scalars['String']['output']>
  lastname?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
}

export type BillingContactPhoneArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>
}

export type BillingContactInput = {
  companyName?: InputMaybe<Scalars['String']['input']>
  companyNameAddition?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  firstname?: InputMaybe<Scalars['String']['input']>
  lastname?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
}

export type BillingDetails = {
  __typename?: 'BillingDetails'
  Token?: Maybe<Scalars['String']['output']>
  Url?: Maybe<Scalars['String']['output']>
  status?: Maybe<Scalars['String']['output']>
  trialEndDate?: Maybe<Scalars['DateTime']['output']>
  trialStartDate?: Maybe<Scalars['DateTime']['output']>
}

export type BillingOnboardingDetails = {
  __typename?: 'BillingOnboardingDetails'
  isSignupComplete?: Maybe<Scalars['Boolean']['output']>
  paymentProviderRole?: Maybe<PaymentProviderRole>
}

export type BlockedLandingpageTemplatesForInvitationInput = {
  companyId: Scalars['ID']['input']
  leadId: Scalars['ID']['input']
}

export type BookCampaignInput = {
  companyId: Scalars['ID']['input']
  slug: Scalars['String']['input']
}

export type BookLandingpageInput = {
  companyId: Scalars['ID']['input']
  slug: Scalars['String']['input']
  type: LandingpageType
}

export type BookableSalesPlanComponents = {
  __typename?: 'BookableSalesPlanComponents'
  componentId?: Maybe<Scalars['String']['output']>
  endAfterMonths?: Maybe<Scalars['Int']['output']>
  id?: Maybe<Scalars['ID']['output']>
  name?: Maybe<Scalars['String']['output']>
}

export type BookableSalesPlanDiscounts = {
  __typename?: 'BookableSalesPlanDiscounts'
  id?: Maybe<Scalars['ID']['output']>
  name?: Maybe<Scalars['String']['output']>
}

export type BookableSalesPlanVariants = {
  __typename?: 'BookableSalesPlanVariants'
  components?: Maybe<Array<Maybe<BookableSalesPlanComponents>>>
  discounts?: Maybe<Array<Maybe<BookableSalesPlanDiscounts>>>
  id?: Maybe<Scalars['ID']['output']>
  name?: Maybe<Scalars['String']['output']>
}

export type BookableSalesPlans = {
  __typename?: 'BookableSalesPlans'
  id?: Maybe<Scalars['ID']['output']>
  name?: Maybe<Scalars['String']['output']>
  variants?: Maybe<Array<Maybe<BookableSalesPlanVariants>>>
}

export type Bounces = {
  __typename?: 'Bounces'
  date?: Maybe<Scalars['String']['output']>
  type?: Maybe<Scalars['String']['output']>
}

export enum BrandEasyTarget {
  Print = 'PRINT',
  Screen = 'SCREEN',
  WebJpg = 'WEB_JPG',
}

export type CalendarSyncSettings = {
  __typename?: 'CalendarSyncSettings'
  followUpDelayDays: Scalars['Int']['output']
  googleCalendarConnected: Scalars['Boolean']['output']
  googleCalendarReconnectRequired: Scalars['Boolean']['output']
  syncAiCalls: Scalars['Boolean']['output']
  syncDueDates: Scalars['Boolean']['output']
  syncFollowUpCalls: Scalars['Boolean']['output']
  syncGoogleCalendar: Scalars['Boolean']['output']
  syncScheduledPosts: Scalars['Boolean']['output']
  syncTraditionalCalls: Scalars['Boolean']['output']
}

export type CalendarSyncSettingsPerUser = {
  __typename?: 'CalendarSyncSettingsPerUser'
  settings?: Maybe<CalendarSyncSettings>
  userName: Scalars['String']['output']
}

export type Campaign = {
  __typename?: 'Campaign'
  campaignId?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  description?: Maybe<Scalars['String']['output']>
  href?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['ID']['output']>
  isActive?: Maybe<Scalars['Boolean']['output']>
  landingpages?: Maybe<Array<Maybe<CampaignLandingpage>>>
  languageCode?: Maybe<Scalars['String']['output']>
  materialTemplates?: Maybe<Array<Maybe<MaterialTemplate>>>
  name?: Maybe<Scalars['String']['output']>
  slug?: Maybe<Scalars['String']['output']>
  techName?: Maybe<Scalars['String']['output']>
  type?: Maybe<CampaignType>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type CampaignDocument = {
  __typename?: 'CampaignDocument'
  file?: Maybe<File>
  id?: Maybe<Scalars['ID']['output']>
  name?: Maybe<Scalars['String']['output']>
  variants?: Maybe<Array<Maybe<Variant>>>
}

export type CampaignJobCount = {
  __typename?: 'CampaignJobCount'
  CANCELLED?: Maybe<Scalars['String']['output']>
  COMPLETED?: Maybe<Scalars['String']['output']>
  CREATED?: Maybe<Scalars['String']['output']>
  FAILED?: Maybe<Scalars['String']['output']>
  RUNNING?: Maybe<Scalars['String']['output']>
}

export type CampaignLandingpage = {
  __typename?: 'CampaignLandingpage'
  country?: Maybe<CountryCode>
  landingpageSlug?: Maybe<Scalars['String']['output']>
}

export type CampaignLandingpageInput = {
  country?: InputMaybe<CountryCode>
  landingpageSlug?: InputMaybe<Scalars['String']['input']>
}

export type CampaignMaterial = {
  __typename?: 'CampaignMaterial'
  companyId?: Maybe<Scalars['ID']['output']>
  companyName?: Maybe<Scalars['String']['output']>
  displayName?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['ID']['output']>
  prettyFileName?: Maybe<Scalars['String']['output']>
  status?: Maybe<Scalars['String']['output']>
}

export type CampaignStep = {
  __typename?: 'CampaignStep'
  campaign?: Maybe<Campaign>
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
}

export enum CampaignType {
  Default = 'DEFAULT',
  Engagement = 'ENGAGEMENT',
  Newsflash = 'NEWSFLASH',
  Newsletter = 'NEWSLETTER',
  Static = 'STATIC',
}

export type CancelProductInput = {
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>
  comment?: InputMaybe<Scalars['String']['input']>
  contractId: Scalars['ID']['input']
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  productId: Scalars['ID']['input']
  reason: CancellationReason
}

export enum CancelationReason {
  HighPricing = 'HIGH_PRICING',
  MissingFeatures = 'MISSING_FEATURES',
  NoNeed = 'NO_NEED',
  NoSuccess = 'NO_SUCCESS',
  Other = 'OTHER',
  ServiceAndHelp = 'SERVICE_AND_HELP',
  TechnicalIssues = 'TECHNICAL_ISSUES',
}

export type Cancellation = {
  __typename?: 'Cancellation'
  comment?: Maybe<Scalars['String']['output']>
  reason?: Maybe<CancellationReason>
}

export enum CancellationReason {
  Badleadquality = 'BADLEADQUALITY',
  Bankrupt = 'BANKRUPT',
  ConditionChange = 'CONDITION_CHANGE',
  Nosuccess = 'NOSUCCESS',
  Notunderstood = 'NOTUNDERSTOOD',
  Other = 'OTHER',
  Proforma = 'PROFORMA',
  Supplierchange = 'SUPPLIERCHANGE',
  Unhappy = 'UNHAPPY',
}

export type CasaoneConfig = {
  __typename?: 'CasaoneConfig'
  isTokenVerified?: Maybe<Scalars['Boolean']['output']>
  token?: Maybe<Scalars['String']['output']>
}

export type CasaoneCredentialsInput = {
  token?: InputMaybe<Scalars['String']['input']>
}

export type ChangeContractInput = {
  companyId: Scalars['ID']['input']
  contractId: Scalars['String']['input']
  customerId: Scalars['String']['input']
}

export type ChangePlanInput = {
  couponCode?: InputMaybe<Scalars['String']['input']>
  planVariantId: Scalars['String']['input']
  priceListId: Scalars['String']['input']
}

export type ChildCompanyLocation = {
  __typename?: 'ChildCompanyLocation'
  ambassador?: Maybe<Ambassador>
  city?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['String']['output']>
  zipCode?: Maybe<Scalars['String']['output']>
}

export type ClientAdvisor = {
  __typename?: 'ClientAdvisor'
  calendlyUsername?: Maybe<Scalars['String']['output']>
  email?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  isActive?: Maybe<Scalars['Boolean']['output']>
  name?: Maybe<Scalars['String']['output']>
  phone?: Maybe<ClientAdvisorPhone>
  photo?: Maybe<Scalars['String']['output']>
  whatsappNumber?: Maybe<Scalars['String']['output']>
}

export type ClientAdvisorPhone = {
  __typename?: 'ClientAdvisorPhone'
  at?: Maybe<Scalars['String']['output']>
  ch?: Maybe<Scalars['String']['output']>
  de?: Maybe<Scalars['String']['output']>
}

export type CmsOrganization = {
  __typename?: 'CmsOrganization'
  defaultLocale?: Maybe<Scalars['String']['output']>
  domain?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['ID']['output']>
  isAilanderLandingpagesActive?: Maybe<Scalars['Boolean']['output']>
  widgetType?: Maybe<CmsWidgetType>
  widgetUrl?: Maybe<Scalars['String']['output']>
}

export type CmsPageUpdate = {
  __typename?: 'CmsPageUpdate'
  created?: Maybe<Array<Maybe<Scalars['ID']['output']>>>
  deleted?: Maybe<Array<Maybe<Scalars['ID']['output']>>>
  updated?: Maybe<Array<Maybe<Scalars['ID']['output']>>>
}

export enum CmsWidgetType {
  Iframe = 'IFRAME',
  Widget = 'WIDGET',
}

export type Colors = {
  __typename?: 'Colors'
  primary?: Maybe<Scalars['String']['output']>
  secondary?: Maybe<Scalars['String']['output']>
}

export type Commentary = {
  __typename?: 'Commentary'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id?: Maybe<Scalars['String']['output']>
  text?: Maybe<Scalars['String']['output']>
  userId?: Maybe<Scalars['String']['output']>
  userName?: Maybe<Scalars['String']['output']>
}

export type CompaniesPostingInfo = {
  __typename?: 'CompaniesPostingInfo'
  address?: Maybe<Address>
  ambassador?: Maybe<Ambassador>
  connectedSocialMediaTypes?: Maybe<SocialMediaConnections>
  id?: Maybe<Scalars['ID']['output']>
  landingpageUrl?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  website?: Maybe<Scalars['String']['output']>
}

export type CompaniesPostingInfoInput = {
  parentId: Scalars['ID']['input']
  topicId?: InputMaybe<Scalars['ID']['input']>
}

export type Company = {
  __typename?: 'Company'
  address?: Maybe<Address>
  advertisementId?: Maybe<Scalars['String']['output']>
  ambassador?: Maybe<Ambassador>
  automaticIntegration?: Maybe<Scalars['Boolean']['output']>
  avv?: Maybe<Avv>
  billing?: Maybe<Billing>
  bookedLandingpageSlugs?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  brokerageName?: Maybe<Scalars['String']['output']>
  brokerageNameSameAsName?: Maybe<Scalars['Boolean']['output']>
  clientAdvisor?: Maybe<ClientAdvisor>
  commission?: Maybe<Scalars['String']['output']>
  components?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  contactPersons?: Maybe<Array<Maybe<CompanyContactPerson>>>
  contracts?: Maybe<Array<Maybe<Contract>>>
  country?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  currentContract?: Maybe<Contract>
  customWording?: Maybe<CustomWording>
  customerNumber?: Maybe<Scalars['String']['output']>
  debtorId?: Maybe<Scalars['String']['output']>
  deleteOn?: Maybe<Scalars['DateTime']['output']>
  externalCrmId?: Maybe<Scalars['String']['output']>
  fbBusinessManagerId?: Maybe<Scalars['String']['output']>
  fbPixelId?: Maybe<Scalars['String']['output']>
  googleDriveFolderId?: Maybe<Scalars['String']['output']>
  googlePerformanceReportId?: Maybe<Scalars['String']['output']>
  hasFbPixelAccessToken?: Maybe<Scalars['Boolean']['output']>
  hasFreeSignUp?: Maybe<Scalars['Boolean']['output']>
  hasNoInitialWebsite?: Maybe<Scalars['Boolean']['output']>
  id?: Maybe<Scalars['String']['output']>
  images?: Maybe<CompanyImages>
  isOnboardingDataComplete?: Maybe<Scalars['Boolean']['output']>
  isReferenceCustomer?: Maybe<Scalars['Boolean']['output']>
  landingpages?: Maybe<Array<Maybe<Landingpage>>>
  leadCorrespondenceBccEmail?: Maybe<Scalars['String']['output']>
  legalConsents: Array<LegalConsent>
  licenseAgreement?: Maybe<LicenseAgreement>
  licenseNumber?: Maybe<Scalars['String']['output']>
  licenseStatus?: Maybe<Scalars['String']['output']>
  links?: Maybe<Links>
  locale?: Maybe<Scalars['String']['output']>
  mailProvider?: Maybe<MailProvider>
  meta?: Maybe<Meta>
  name?: Maybe<Scalars['String']['output']>
  nextEvents?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  organizationType?: Maybe<CompanyOrganizationType>
  parentId?: Maybe<Scalars['ID']['output']>
  performance?: Maybe<CompanyPerformanceData>
  platform?: Maybe<Scalars['String']['output']>
  productType?: Maybe<CompanyProductType>
  regionName?: Maybe<Scalars['String']['output']>
  salesPerson?: Maybe<SalesPerson>
  /** @deprecated use Settings */
  settings?: Maybe<Settings>
  site?: Maybe<Site>
  slogan?: Maybe<Scalars['String']['output']>
  slug?: Maybe<Scalars['String']['output']>
  socials?: Maybe<Array<Maybe<Social>>>
  ssoProviders?: Maybe<Array<Maybe<SsoProviders>>>
  state?: Maybe<State>
  targetAudience?: Maybe<OnboardingTargetAudience>
  theme?: Maybe<Theme>
  variant?: Maybe<Scalars['String']['output']>
  vouchers?: Maybe<Array<Maybe<Voucher>>>
  zohoUrl?: Maybe<Scalars['String']['output']>
}

export type CompanyLandingpagesArgs = {
  statuses?: InputMaybe<Array<InputMaybe<LandingpageStatus>>>
}

export type CompanyAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  street?: InputMaybe<Scalars['String']['input']>
  zip?: InputMaybe<Scalars['String']['input']>
}

export type CompanyContactPerson = {
  __typename?: 'CompanyContactPerson'
  address?: Maybe<Address>
  companyName?: Maybe<Scalars['String']['output']>
  email?: Maybe<Scalars['String']['output']>
  firstname?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['ID']['output']>
  lastname?: Maybe<Scalars['String']['output']>
  mobile?: Maybe<Scalars['String']['output']>
  note?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
  role?: Maybe<Scalars['String']['output']>
  salutation?: Maybe<Scalars['String']['output']>
  type?: Maybe<Scalars['String']['output']>
}

export type CompanyEmailAutoReply = {
  __typename?: 'CompanyEmailAutoReply'
  bounces?: Maybe<Array<Maybe<Bounces>>>
  totalCount?: Maybe<Scalars['Int']['output']>
}

export type CompanyEmailFunnelsBounceFilters = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  startDate?: InputMaybe<Scalars['DateTime']['input']>
}

export type CompanyEmailFunnelsBounceInput = {
  childCompanyId?: InputMaybe<Scalars['ID']['input']>
  companyId?: InputMaybe<Scalars['ID']['input']>
  filters?: InputMaybe<CompanyEmailFunnelsBounceFilters>
  isMasterView?: InputMaybe<Scalars['Boolean']['input']>
  lastThirtyDays?: InputMaybe<Scalars['Boolean']['input']>
}

export type CompanyEmailFunnelsBounceStatistics = {
  __typename?: 'CompanyEmailFunnelsBounceStatistics'
  days?: Maybe<Array<Maybe<FunnelsBounceStatistics>>>
  hardBounce?: Maybe<Scalars['Int']['output']>
  softBounce?: Maybe<Scalars['Int']['output']>
}

export type CompanyEmailFunnelsSentCountsStatistics = {
  __typename?: 'CompanyEmailFunnelsSentCountsStatistics'
  days?: Maybe<Array<Maybe<FunnelsSentCountsStatistics>>>
  lastThirtyDaysSent?: Maybe<Scalars['Int']['output']>
  sent: Scalars['Int']['output']
}

export type CompanyEmailFunnelsStatistics = {
  __typename?: 'CompanyEmailFunnelsStatistics'
  sent?: Maybe<Scalars['Int']['output']>
  uniqueLinksClicked?: Maybe<Scalars['Int']['output']>
  uniqueOpens?: Maybe<Scalars['Int']['output']>
}

export type CompanyImages = {
  __typename?: 'CompanyImages'
  logo?: Maybe<File>
  lpValuationHero?: Maybe<File>
  office?: Maybe<File>
  region?: Maybe<File>
  team?: Maybe<File>
}

export type CompanyLinksInput = {
  about?: InputMaybe<Scalars['String']['input']>
  imprint?: InputMaybe<Scalars['String']['input']>
  privacy?: InputMaybe<Scalars['String']['input']>
  website?: InputMaybe<Scalars['String']['input']>
}

export type CompanyName = {
  __typename?: 'CompanyName'
  id?: Maybe<Scalars['ID']['output']>
  name?: Maybe<Scalars['String']['output']>
}

export enum CompanyOrganizationType {
  Branch = 'BRANCH',
  Corporate = 'CORPORATE',
  MainCompany = 'MAIN_COMPANY',
}

export type CompanyPerformanceData = {
  __typename?: 'CompanyPerformanceData'
  facebook?: Maybe<PerformanceFacebook>
  google?: Maybe<PerformanceGoogle>
}

export type CompanyPrice = {
  __typename?: 'CompanyPrice'
  currency?: Maybe<Scalars['String']['output']>
  readableId?: Maybe<Scalars['String']['output']>
  value?: Maybe<Scalars['Float']['output']>
}

export enum CompanyProductType {
  Advanced = 'ADVANCED',
  AdvancedTrial = 'ADVANCED_TRIAL',
  Basic = 'BASIC',
  Beginner = 'BEGINNER',
  BeginnerTrial = 'BEGINNER_TRIAL',
  Expert = 'EXPERT',
  Light = 'LIGHT',
  Showcase = 'SHOWCASE',
}

export type CompanyScores = {
  __typename?: 'CompanyScores'
  emailAmount?: Maybe<Scalars['Int']['output']>
  emailScore?: Maybe<Scalars['Float']['output']>
  overall?: Maybe<Scalars['Float']['output']>
  phoneAmount?: Maybe<Scalars['Int']['output']>
  phoneScore?: Maybe<Scalars['Float']['output']>
  propertyRequestAmount?: Maybe<Scalars['Int']['output']>
  propertyRequestScore?: Maybe<Scalars['Float']['output']>
  valuationAmount?: Maybe<Scalars['Int']['output']>
  valuationScore?: Maybe<Scalars['Float']['output']>
}

export type CompanySettings = {
  __typename?: 'CompanySettings'
  enabledFirstNameVerification?: Maybe<EnabledVerification>
  enabledLastNameVerification?: Maybe<EnabledVerification>
  enabledMotivationVerification?: Maybe<EnabledVerification>
  enabledPhoneVerification?: Maybe<EnabledVerification>
  googleReviewLink?: Maybe<Scalars['String']['output']>
  isFirstNameOptional?: Maybe<Scalars['Boolean']['output']>
  isLastNameOptional?: Maybe<Scalars['Boolean']['output']>
  isMotivationOptional?: Maybe<Scalars['Boolean']['output']>
  isPhoneOptional?: Maybe<Scalars['Boolean']['output']>
  plotValuation?: Maybe<PlotValuationSettings>
  provenExpertLink?: Maybe<Scalars['String']['output']>
  showGoogleReviewOnLandingpage?: Maybe<Scalars['Boolean']['output']>
  showProvenExpertOnLandingpage?: Maybe<Scalars['Boolean']['output']>
}

export type CompanySiteTrackingInput = {
  gtm?: InputMaybe<Scalars['String']['input']>
}

export type CompanyState = {
  __typename?: 'CompanyState'
  companyId?: Maybe<Scalars['String']['output']>
  state?: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export type CompanyTargetOverview = {
  __typename?: 'CompanyTargetOverview'
  accounts?: Maybe<Array<Maybe<SocialMediaAccountRef>>>
  companyId: Scalars['ID']['output']
  platforms?: Maybe<Array<Maybe<SocialMediaType>>>
  resolvedUrl?: Maybe<Scalars['String']['output']>
}

export type CompanyThemeColorsInput = {
  primary: Scalars['String']['input']
  secondary: Scalars['String']['input']
}

export type CompleteGoogleCalendarOAuthInput = {
  code: Scalars['String']['input']
  state: Scalars['String']['input']
}

export type CompleteOnboardingStepWebsiteInput = {
  countryCode: CountryCode
  hasNoInitialWebsite?: InputMaybe<Scalars['Boolean']['input']>
  links?: InputMaybe<OnboardingWebsiteLinks>
}

export type CompleteToDoInput = {
  event?: InputMaybe<Scalars['String']['input']>
  todoTemplateSlug: Scalars['String']['input']
}

export type ComponentPrice = {
  __typename?: 'ComponentPrice'
  currency?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['ID']['output']>
  price?: Maybe<Scalars['Float']['output']>
}

export type Condition = {
  __typename?: 'Condition'
  minDuration?: Maybe<Duration>
  price?: Maybe<ProductPrice>
}

export type ConditionInput = {
  duration: DurationInput
  price: ProductPriceInput
}

export type ConfirmImageEditInput = {
  /** The ID of the image document to update. */
  imageId: Scalars['ID']['input']
  imageType: ImageType
  /** MIME type of the uploaded replacement image. */
  mimeType: Scalars['String']['input']
  /** Required when imageType is STOCK. */
  provider?: InputMaybe<Scalars['String']['input']>
  /** S3 key returned by requestImageEditUploadUrl. */
  s3Key: Scalars['String']['input']
  topicId?: InputMaybe<Scalars['ID']['input']>
}

export type ConfirmMaterialUploadInput = {
  /** Asset type override; inferred from mimeType if omitted. */
  assetType?: InputMaybe<AssetType>
  /** Optional; falls back to the authenticated user's company. */
  companyId?: InputMaybe<Scalars['ID']['input']>
  /** Display name for the material. */
  displayName?: InputMaybe<Scalars['String']['input']>
  /** Original filename (used for type determination). */
  filename?: InputMaybe<Scalars['String']['input']>
  /** MIME type of the uploaded file. */
  mimeType: Scalars['String']['input']
  /** S3 key returned by requestMaterialUploadUrl. */
  s3Key: Scalars['String']['input']
  topicId: Scalars['ID']['input']
}

export type ConfirmMultipleMaterialUploadsInput = {
  /** Optional; falls back to the authenticated user's company. */
  companyId?: InputMaybe<Scalars['ID']['input']>
  uploads: Array<ConfirmSingleMaterialUploadInput>
}

export type ConfirmSingleMaterialUploadInput = {
  assetType?: InputMaybe<AssetType>
  displayName?: InputMaybe<Scalars['String']['input']>
  filename?: InputMaybe<Scalars['String']['input']>
  mimeType: Scalars['String']['input']
  s3Key: Scalars['String']['input']
  topicId: Scalars['ID']['input']
}

export type ConfirmUserImageUploadInput = {
  /** MIME type of the uploaded image. */
  mimeType: Scalars['String']['input']
  /** S3 key returned by requestUserImageUploadUrl. */
  s3Key: Scalars['String']['input']
  topicId: Scalars['ID']['input']
}

export type ConnectGoogleBusinessInput = {
  /** URL bundle.social redirects back to after the user authorizes. */
  redirectUri: Scalars['String']['input']
}

export type ConnectOnofficeUserInput = {
  token: Scalars['String']['input']
}

export type ConnectSocialMediaInput = {
  accessToken?: InputMaybe<Scalars['String']['input']>
  redirectUri?: InputMaybe<Scalars['String']['input']>
  type: SocialMediaType
  userId?: InputMaybe<Scalars['String']['input']>
}

export type ConnectToOnofficeMarketplaceInput = {
  marketplaceIntegration?: InputMaybe<MarketplaceIntegration>
  secret?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type ContactDetails = {
  email?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export enum ContactPersonType {
  AdAgency = 'AD_AGENCY',
  Contract = 'CONTRACT',
  Facebook = 'FACEBOOK',
  General = 'GENERAL',
  Google = 'GOOGLE',
  Website = 'WEBSITE',
}

export type ContentCreatorSettings = {
  __typename?: 'ContentCreatorSettings'
  useHashtags?: Maybe<UseHashtags>
  useLinks?: Maybe<Scalars['Boolean']['output']>
}

export type ContentCreatorSettingsInput = {
  useHashtags?: InputMaybe<UseHashtags>
  useLinks?: InputMaybe<Scalars['Boolean']['input']>
}

export type Contract = {
  __typename?: 'Contract'
  cancelledAt?: Maybe<Scalars['DateTime']['output']>
  company?: Maybe<Company>
  documents?: Maybe<Array<Maybe<ContractDocument>>>
  endDate?: Maybe<Scalars['DateTime']['output']>
  id?: Maybe<Scalars['ID']['output']>
  isTrial?: Maybe<Scalars['Boolean']['output']>
  note?: Maybe<Scalars['String']['output']>
  priceListName?: Maybe<PriceListItemName>
  products?: Maybe<Array<Maybe<Product>>>
  startDate?: Maybe<Scalars['DateTime']['output']>
  trial?: Maybe<Scalars['Boolean']['output']>
}

export type ContractDocument = {
  __typename?: 'ContractDocument'
  comment?: Maybe<Scalars['String']['output']>
  file?: Maybe<File>
  type?: Maybe<ContractDocumentType>
}

export enum ContractDocumentType {
  Avv = 'AVV',
  Cancellation = 'CANCELLATION',
  Contract = 'CONTRACT',
  Obf = 'OBF',
  Other = 'OTHER',
  Sepa = 'SEPA',
}

export type ContractDocumentUploadInput = {
  comment?: InputMaybe<Scalars['String']['input']>
  file: Scalars['Upload']['input']
  type: ContractDocumentType
}

export type Conversion = {
  __typename?: 'Conversion'
  company?: Maybe<Company>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  customFields?: Maybe<Array<Maybe<ConversionCustomField>>>
  download?: Maybe<DownloadConversion>
  downloadMaterialUrl?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['ID']['output']>
  landingpage?: Maybe<Landingpage>
  lead?: Maybe<Lead>
  leadId?: Maybe<Scalars['ID']['output']>
  lifeAnnuity?: Maybe<LifeAnnuity>
  origin?: Maybe<ConversionOrigin>
  partialSale?: Maybe<PartialSale>
  personalData?: Maybe<ConversionPersonalData>
  plotValuation?: Maybe<PlotValuation>
  /** @deprecated user download.postalShipping */
  postalShipping?: Maybe<PostalShippingType>
  preConversion?: Maybe<PreConversion>
  preConversionId?: Maybe<Scalars['ID']['output']>
  propertyRequest?: Maybe<PropertyRequest>
  returnCall?: Maybe<ReturnCall>
  source?: Maybe<Scalars['String']['output']>
  type?: Maybe<ConversionType>
  utmParams?: Maybe<UtmParams>
  valuation?: Maybe<Valuation>
}

export type ConversionCountByType = {
  __typename?: 'ConversionCountByType'
  DOWNLOAD?: Maybe<Scalars['Int']['output']>
  IN_APP_VALUATION?: Maybe<Scalars['Int']['output']>
  LIFE_ANNUITY?: Maybe<Scalars['Int']['output']>
  PARTIAL_SALE?: Maybe<Scalars['Int']['output']>
  PLOT_VALUATION?: Maybe<Scalars['Int']['output']>
  PROPERTY_REQUEST?: Maybe<Scalars['Int']['output']>
  RETURN_CALL?: Maybe<Scalars['Int']['output']>
  VALUATION?: Maybe<Scalars['Int']['output']>
}

export type ConversionCustomField = {
  __typename?: 'ConversionCustomField'
  key?: Maybe<Scalars['String']['output']>
  label?: Maybe<Scalars['String']['output']>
  value?: Maybe<Scalars['String']['output']>
}

export enum ConversionOrigin {
  Embedded = 'EMBEDDED',
  FbLeadAds = 'FB_LEAD_ADS',
  PostConversion = 'POST_CONVERSION',
  Standalone = 'STANDALONE',
  StandaloneSecondary = 'STANDALONE_SECONDARY',
}

export type ConversionPersonalData = {
  __typename?: 'ConversionPersonalData'
  address?: Maybe<LeadAddress>
  email?: Maybe<Scalars['String']['output']>
  firstname?: Maybe<Scalars['String']['output']>
  gender?: Maybe<Scalars['String']['output']>
  lastname?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
  yearOfBirth?: Maybe<Scalars['Int']['output']>
}

export type ConversionPersonalDataPhoneArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>
}

export type ConversionPersonalDataInput = {
  address?: InputMaybe<LeadAddressInput>
  email: Scalars['String']['input']
  firstname?: InputMaybe<Scalars['String']['input']>
  gender?: InputMaybe<Gender>
  lastname?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  yearOfBirth?: InputMaybe<Scalars['Int']['input']>
}

export enum ConversionType {
  Download = 'DOWNLOAD',
  LifeAnnuity = 'LIFE_ANNUITY',
  PartialSale = 'PARTIAL_SALE',
  PlotValuation = 'PLOT_VALUATION',
  PropertyRequest = 'PROPERTY_REQUEST',
  ReturnCall = 'RETURN_CALL',
  Valuation = 'VALUATION',
}

export type Cookies = {
  _fbc?: InputMaybe<Scalars['String']['input']>
  _fbp?: InputMaybe<Scalars['String']['input']>
}

export type CountForSource = {
  __typename?: 'CountForSource'
  count?: Maybe<Scalars['Int']['output']>
  type?: Maybe<Scalars['String']['output']>
}

export enum CountryCode {
  Ad = 'ad',
  Ae = 'ae',
  Af = 'af',
  Ag = 'ag',
  Al = 'al',
  Am = 'am',
  Ao = 'ao',
  Ar = 'ar',
  At = 'at',
  Au = 'au',
  Az = 'az',
  Ba = 'ba',
  Bb = 'bb',
  Bd = 'bd',
  Be = 'be',
  Bf = 'bf',
  Bg = 'bg',
  Bh = 'bh',
  Bi = 'bi',
  Bj = 'bj',
  Bn = 'bn',
  Bo = 'bo',
  Br = 'br',
  Bs = 'bs',
  Bt = 'bt',
  Bw = 'bw',
  By = 'by',
  Bz = 'bz',
  Ca = 'ca',
  Cf = 'cf',
  Ch = 'ch',
  Ci = 'ci',
  Cl = 'cl',
  Cm = 'cm',
  Cn = 'cn',
  Co = 'co',
  Cr = 'cr',
  Cu = 'cu',
  Cv = 'cv',
  Cy = 'cy',
  Cz = 'cz',
  De = 'de',
  Dj = 'dj',
  Dk = 'dk',
  Dm = 'dm',
  Do = 'do',
  Dz = 'dz',
  Ec = 'ec',
  Ee = 'ee',
  Eg = 'eg',
  Er = 'er',
  Es = 'es',
  Et = 'et',
  Fi = 'fi',
  Fj = 'fj',
  Fm = 'fm',
  Fr = 'fr',
  Ga = 'ga',
  Gb = 'gb',
  Gd = 'gd',
  Ge = 'ge',
  Gh = 'gh',
  Gm = 'gm',
  Gn = 'gn',
  Gq = 'gq',
  Gr = 'gr',
  Gt = 'gt',
  Gw = 'gw',
  Gy = 'gy',
  Hn = 'hn',
  Hr = 'hr',
  Ht = 'ht',
  Hu = 'hu',
  Id = 'id',
  Ie = 'ie',
  Il = 'il',
  In = 'in',
  Iq = 'iq',
  Ir = 'ir',
  Is = 'is',
  It = 'it',
  Jm = 'jm',
  Jo = 'jo',
  Jp = 'jp',
  Ke = 'ke',
  Kg = 'kg',
  Kh = 'kh',
  Ki = 'ki',
  Km = 'km',
  Kn = 'kn',
  Kp = 'kp',
  Kr = 'kr',
  Kw = 'kw',
  Kz = 'kz',
  La = 'la',
  Lb = 'lb',
  Lc = 'lc',
  Li = 'li',
  Lk = 'lk',
  Lr = 'lr',
  Ls = 'ls',
  Lt = 'lt',
  Lu = 'lu',
  Lv = 'lv',
  Ly = 'ly',
  Ma = 'ma',
  Mc = 'mc',
  Md = 'md',
  Me = 'me',
  Mg = 'mg',
  Mh = 'mh',
  Mk = 'mk',
  Ml = 'ml',
  Mm = 'mm',
  Mn = 'mn',
  Mr = 'mr',
  Mt = 'mt',
  Mu = 'mu',
  Mv = 'mv',
  Mw = 'mw',
  Mx = 'mx',
  My = 'my',
  Mz = 'mz',
  Na = 'na',
  Ne = 'ne',
  Ng = 'ng',
  Ni = 'ni',
  Nl = 'nl',
  No = 'no',
  Np = 'np',
  Nr = 'nr',
  Nz = 'nz',
  Om = 'om',
  Pa = 'pa',
  Pe = 'pe',
  Pg = 'pg',
  Ph = 'ph',
  Pk = 'pk',
  Pl = 'pl',
  Ps = 'ps',
  Pt = 'pt',
  Pw = 'pw',
  Py = 'py',
  Qa = 'qa',
  Ro = 'ro',
  Rs = 'rs',
  Ru = 'ru',
  Rw = 'rw',
  Sa = 'sa',
  Sb = 'sb',
  Sc = 'sc',
  Se = 'se',
  Sg = 'sg',
  Si = 'si',
  Sk = 'sk',
  Sl = 'sl',
  Sm = 'sm',
  Sn = 'sn',
  So = 'so',
  Sr = 'sr',
  St = 'st',
  Sv = 'sv',
  Sy = 'sy',
  Sz = 'sz',
  Td = 'td',
  Th = 'th',
  Tj = 'tj',
  Tl = 'tl',
  Tm = 'tm',
  To = 'to',
  Tr = 'tr',
  Tt = 'tt',
  Tv = 'tv',
  Tw = 'tw',
  Ua = 'ua',
  Us = 'us',
  Uy = 'uy',
  Uz = 'uz',
  Va = 'va',
  Vc = 'vc',
  Ve = 've',
  Vn = 'vn',
  Vu = 'vu',
  Ws = 'ws',
  Ye = 'ye',
  Za = 'za',
}

export type CreateAdMaterialTopicInput = {
  /** The name of the topic to create */
  name: Scalars['String']['input']
}

export type CreateAdMaterialTopicResponse = {
  __typename?: 'CreateAdMaterialTopicResponse'
  error?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
  topic?: Maybe<Topic>
}

export type CreateBrandEasyMaterialTemplateForCampaignInput = {
  assetType: AssetType
  bleed?: InputMaybe<Scalars['String']['input']>
  campaignId: Scalars['ID']['input']
  name: Scalars['String']['input']
  target: BrandEasyTarget
  templateName: Scalars['String']['input']
}

export type CreateBrandEasyMaterialTemplateInput = {
  addToExistingLandingpages?: InputMaybe<Scalars['Boolean']['input']>
  assetType: AssetType
  brandEasyConfig: MaterialBrandEasyConfigInput
  campaignId?: InputMaybe<Scalars['ID']['input']>
  displayName: Scalars['String']['input']
  landingpageTemplateId?: InputMaybe<Scalars['ID']['input']>
  prettyFileName: Scalars['String']['input']
  type: MaterialType
}

export type CreateCampaignInput = {
  landingpages?: InputMaybe<Array<CampaignLandingpageInput>>
  name: Scalars['String']['input']
  slug: Scalars['String']['input']
  type: CampaignType
}

export type CreateCompanyAnamnesisInput = {
  businessDescription?: InputMaybe<Scalars['String']['input']>
  country: Scalars['String']['input']
  industry?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  websiteUrl?: InputMaybe<Scalars['String']['input']>
}

export type CreateCompanyBillingInput = {
  address?: InputMaybe<CompanyAddressInput>
  companyName?: InputMaybe<Scalars['String']['input']>
  components?: InputMaybe<Array<Scalars['String']['input']>>
  isYearly: Scalars['Boolean']['input']
  productType: CompanyProductType
}

export type CreateCompanyImagesInput = {
  logo: Scalars['Upload']['input']
}

export type CreateCompanyInput = {
  businessDescription?: InputMaybe<Scalars['String']['input']>
  clientAdvisor?: InputMaybe<Scalars['String']['input']>
  components?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  country: Scalars['String']['input']
  externalCrmId?: InputMaybe<Scalars['String']['input']>
  industry?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  parentId?: InputMaybe<Scalars['String']['input']>
  platform?: InputMaybe<Scalars['String']['input']>
  productType?: InputMaybe<CompanyProductType>
  salesPerson?: InputMaybe<Scalars['String']['input']>
  slug: Scalars['String']['input']
  ssoProviders?: InputMaybe<Array<InputMaybe<SsoProvidersInput>>>
  startDate?: InputMaybe<Scalars['String']['input']>
  variant: Scalars['String']['input']
}

export type CreateCompanyThemeInput = {
  colors: CompanyThemeColorsInput
}

export type CreateContractInput = {
  companyId: Scalars['ID']['input']
  isTrial?: InputMaybe<Scalars['Boolean']['input']>
  note?: InputMaybe<Scalars['String']['input']>
  priceListName: PriceListItemName
  products: Array<CreateProductInput>
  startDate: Scalars['DateTime']['input']
}

export type CreateEmailChangeRequestInput = {
  id: Scalars['ID']['input']
  newEmail: Scalars['String']['input']
}

export type CreateFeedbackTicketInput = {
  classification?: InputMaybe<Scalars['String']['input']>
  description: Scalars['String']['input']
  subject: Scalars['String']['input']
}

export type CreateHoppermationSenderInput = {
  companyId: Scalars['String']['input']
  fromEmail?: InputMaybe<Scalars['String']['input']>
  isDefault?: InputMaybe<Scalars['Boolean']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  replyToEmail?: InputMaybe<Scalars['String']['input']>
}

export type CreateLandingpageTemplatesInput = {
  countryCodes?: InputMaybe<Array<InputMaybe<CountryCode>>>
  name: Scalars['String']['input']
  slug: Scalars['String']['input']
  type: CreateLandingpageTemplatesTypes
}

export enum CreateLandingpageTemplatesTypes {
  Checklist = 'CHECKLIST',
  Guide = 'GUIDE',
  Quizzard = 'QUIZZARD',
}

export type CreateLandingpagesInput = {
  companyId: Scalars['ID']['input']
  slugs: Array<InputMaybe<Scalars['String']['input']>>
}

export type CreateLeadByUserInput = {
  isDataProcessingPermissionGranted: Scalars['Boolean']['input']
  isExistingCustomer: Scalars['Boolean']['input']
  personalData: LeadPersonalDataInput
}

export type CreateMaterialMakerTemplateInput = {
  addToExistingLandingpages?: InputMaybe<Scalars['Boolean']['input']>
  assetType: AssetType
  campaignId?: InputMaybe<Scalars['ID']['input']>
  displayName: Scalars['String']['input']
  landingpageTemplateId?: InputMaybe<Scalars['ID']['input']>
  materialMakerConfig: MaterialMakerConfigInput
  prettyFileName: Scalars['String']['input']
  type: MaterialType
}

export type CreateMaterialsForCampaignAndCompaniesInput = {
  campaignId: Scalars['ID']['input']
  companyIds: Array<Scalars['ID']['input']>
}

export type CreateOrUpdateCancelationInput = {
  companyId: Scalars['ID']['input']
  completedAt?: InputMaybe<Scalars['DateTime']['input']>
  other?: InputMaybe<Scalars['String']['input']>
  reasons?: InputMaybe<Array<InputMaybe<CancelationReason>>>
  revokedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type CreateOrderComponentInput = {
  componentId: Scalars['String']['input']
  endAfterMonths?: InputMaybe<Scalars['Int']['input']>
  quantity: Scalars['Int']['input']
}

export type CreateOrderInput = {
  companyId: Scalars['ID']['input']
  companyName: Scalars['String']['input']
  components?: InputMaybe<Array<InputMaybe<CreateOrderComponentInput>>>
  countryCode: Scalars['String']['input']
  discounts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  planVariantId: Scalars['String']['input']
  startDate: Scalars['DateTime']['input']
}

export type CreatePlotValuationConversionInput = {
  companyId: Scalars['ID']['input']
  cookies?: InputMaybe<Cookies>
  details: PlotValuationConversionDetailsInput
  origin: ConversionOrigin
  personalData: ConversionPersonalDataInput
  siteRequestQueryString?: InputMaybe<Scalars['String']['input']>
}

export type CreateProductInput = {
  discountPercentage?: InputMaybe<Scalars['Float']['input']>
  duration?: InputMaybe<DurationInput>
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  note?: InputMaybe<Scalars['String']['input']>
  startDate: Scalars['DateTime']['input']
  templateId: Scalars['ID']['input']
  wasPaidInAdvance?: InputMaybe<Scalars['Boolean']['input']>
}

export type CreateProductTemplateInput = {
  abacusId: Scalars['String']['input']
  minDuration?: InputMaybe<Array<InputMaybe<DurationInput>>>
  monthly: Scalars['Boolean']['input']
  name: Scalars['String']['input']
  prices: Array<InputMaybe<PriceListItemInput>>
  readableId: Scalars['String']['input']
  setupTemplateId?: InputMaybe<Scalars['ID']['input']>
  type: ProductType
}

export type CreatePropertyTrackerConversionInput = {
  accessCode: Scalars['String']['input']
  companyId: Scalars['String']['input']
  email: Scalars['String']['input']
  firstname: Scalars['String']['input']
  lastname: Scalars['String']['input']
  phone: Scalars['String']['input']
  property: PropertyInput
}

export type CreateS3VideoMaterialTemplateForCampaignInput = {
  campaignId: Scalars['ID']['input']
  directory: Scalars['String']['input']
}

export type CreateStaticMaterialTemplateForCampaignInput = {
  assetType: AssetType
  campaignId: Scalars['ID']['input']
  file: Scalars['Upload']['input']
  name: Scalars['String']['input']
  purpose: MaterialPurpose
  variants: Array<Variant>
}

export type CreateSubCompanyInput = {
  corporateCompanyId: Scalars['ID']['input']
  country: Scalars['String']['input']
  productType?: InputMaybe<CompanyProductType>
  propstackTeamId?: InputMaybe<Scalars['String']['input']>
  slug: Scalars['String']['input']
  variant: Scalars['String']['input']
}

export type CreateToDoTemplateInput = {
  buttonText: Scalars['String']['input']
  endConditionEvent?: InputMaybe<Scalars['String']['input']>
  endConditionManual?: InputMaybe<Scalars['Boolean']['input']>
  externalFlowId?: InputMaybe<Scalars['String']['input']>
  slug: Scalars['String']['input']
  startConditionEvent?: InputMaybe<Scalars['String']['input']>
  startConditionManual?: InputMaybe<Scalars['Boolean']['input']>
  text: Scalars['String']['input']
  title: Scalars['String']['input']
}

export type CreateTopicInput = {
  description: Scalars['String']['input']
  links?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  name: Scalars['String']['input']
  visibility?: InputMaybe<TopicVisibilityInput>
}

export type CreateUserInput = {
  companyId: Scalars['String']['input']
  email: Scalars['String']['input']
  firstname: Scalars['String']['input']
  isPassive?: InputMaybe<Scalars['Boolean']['input']>
  isSso?: InputMaybe<Scalars['Boolean']['input']>
  lastname: Scalars['String']['input']
  phone?: InputMaybe<Scalars['String']['input']>
  receiveNotificationEmails?: InputMaybe<UserReceiveNotificationEmailsInput>
  role?: InputMaybe<Scalars['ID']['input']>
  salutation?: InputMaybe<Scalars['String']['input']>
  ssoProviders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CreateUserUploadedMaterialInput = {
  /** The company ID (optional, will use authenticated user's company if not provided) */
  companyId?: InputMaybe<Scalars['ID']['input']>
  /** Optional display name for the uploaded material */
  displayName?: InputMaybe<Scalars['String']['input']>
  /** The file to upload */
  file: Scalars['Upload']['input']
  /** The topic ID to associate with the file */
  topicId: Scalars['ID']['input']
}

export type CreateValuationByAgentInput = {
  address: ValuationAddressInput
  annualRentIncome?: InputMaybe<Scalars['Float']['input']>
  balconyArea?: InputMaybe<Scalars['Float']['input']>
  buildingYear: Scalars['Int']['input']
  condition: ValuationCondition
  coordinates: PropertyCoordinatesInput
  floorNumber?: InputMaybe<Scalars['Int']['input']>
  landArea?: InputMaybe<Scalars['Float']['input']>
  livingArea: Scalars['Float']['input']
  numberOfRooms?: InputMaybe<Scalars['Float']['input']>
  numberOfUnits?: InputMaybe<Scalars['Float']['input']>
  quality: ValuationQuality
  subType?: InputMaybe<PropertySubType>
  type: PropertyType
}

export type CreateVideoMaterialTemplateForCampaignInput = {
  campaignId: Scalars['ID']['input']
  name: Scalars['String']['input']
  templateId: Scalars['String']['input']
  variants?: InputMaybe<Array<CreatifyTemplateVariantsInput>>
}

export type CreateVideoMaterialTemplateInput = {
  addToExistingLandingpages?: InputMaybe<Scalars['Boolean']['input']>
  assetType: AssetType
  creatifyConfig: MaterialVideoConfigInput
  displayName: Scalars['String']['input']
  landingpageTemplateId?: InputMaybe<Scalars['ID']['input']>
  prettyFileName: Scalars['String']['input']
  type: MaterialType
}

export type CreatedCompany = {
  __typename?: 'CreatedCompany'
  id?: Maybe<Scalars['String']['output']>
}

export type CreatedContentsStatistics = {
  __typename?: 'CreatedContentsStatistics'
  textKindStatistics?: Maybe<Array<Maybe<TextKindStatistics>>>
  topicStatistics?: Maybe<Array<Maybe<TopicStatistics>>>
}

export type CreatifyTemplateVariants = {
  __typename?: 'CreatifyTemplateVariants'
  templateId?: Maybe<Scalars['ID']['output']>
  variant?: Maybe<Variant>
}

export type CreatifyTemplateVariantsInput = {
  templateId: Scalars['ID']['input']
  variant: Variant
}

export type CrmChildCompanyConfig = {
  __typename?: 'CrmChildCompanyConfig'
  acceptedMasterConnection?: Maybe<Scalars['Boolean']['output']>
  enforceMasterConnection?: Maybe<Scalars['Boolean']['output']>
  id?: Maybe<Scalars['ID']['output']>
  name?: Maybe<Scalars['String']['output']>
}

export type CrmCompanyConfig = {
  __typename?: 'CrmCompanyConfig'
  acceptedMasterConnection?: Maybe<Scalars['Boolean']['output']>
  companyId?: Maybe<Scalars['ID']['output']>
  crmProvider?: Maybe<CrmProvider>
  enforceMasterConnection?: Maybe<Scalars['Boolean']['output']>
  hasBeenActivated?: Maybe<Scalars['Boolean']['output']>
  isActive?: Maybe<Scalars['Boolean']['output']>
  isUsedByUser?: Maybe<Scalars['Boolean']['output']>
  syncModus?: Maybe<CrmSyncModus>
}

export type CrmCompanyConfigInput = {
  companyId: Scalars['ID']['input']
  crmProvider?: InputMaybe<CrmProvider>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  isUsedByUser?: InputMaybe<Scalars['Boolean']['input']>
  syncModus?: InputMaybe<CrmSyncModus>
}

export enum CrmProvider {
  Casaone = 'CASAONE',
  Empro = 'EMPRO',
  Flowfact = 'FLOWFACT',
  Onoffice = 'ONOFFICE',
  Propstack = 'PROPSTACK',
}

export enum CrmSyncModus {
  Auto = 'AUTO',
  Export = 'EXPORT',
  Import = 'IMPORT',
  Manually = 'MANUALLY',
}

export enum Currency {
  Chf = 'CHF',
  Eur = 'EUR',
}

export type CustomField = {
  __typename?: 'CustomField'
  customFieldId?: Maybe<Scalars['String']['output']>
  fieldType?: Maybe<Scalars['String']['output']>
  format?: Maybe<Scalars['String']['output']>
  href?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  type?: Maybe<Scalars['String']['output']>
  values?: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export type CustomScheduleInput = {
  scheduledAt: Scalars['DateTime']['input']
  type: SocialMediaType
}

export type CustomWording = {
  __typename?: 'CustomWording'
  farewell?: Maybe<Scalars['String']['output']>
  salutation?: Maybe<Scalars['String']['output']>
}

/** The published, customer-safe view of one owned guide. */
export type CustomerGuide = {
  __typename?: 'CustomerGuide'
  /** True only when the caller can edit a private draft for this guide. */
  canEdit: Scalars['Boolean']['output']
  /** True only when the caller has guide-write permission and no active replacement. */
  canRegenerate: Scalars['Boolean']['output']
  failureState: CustomerGuideFailureState
  /** Stable Bottimmo Material ID for guide-specific actions. */
  materialId: Scalars['ID']['output']
  previewFile: File
  publishedFile: File
  publishedVersion: Scalars['Int']['output']
  replacementState: CustomerGuideReplacementState
  topic: CustomerGuideTopic
}

/** A customer-owned editable copy subset; locked fields never appear here. */
export type CustomerGuideDraft = {
  __typename?: 'CustomerGuideDraft'
  content: Scalars['JSONObject']['output']
  draftId: Scalars['ID']['output']
  materialId: Scalars['ID']['output']
  revision: Scalars['Int']['output']
  sourcePublishedVersion: Scalars['Int']['output']
  status: CustomerGuideDraftStatus
  updatedAt: Scalars['DateTime']['output']
}

export type CustomerGuideDraftInput = {
  content: Scalars['JSONObject']['input']
  expectedRevision: Scalars['Int']['input']
  materialId: Scalars['ID']['input']
}

export type CustomerGuideDraftMutation = {
  __typename?: 'CustomerGuideDraftMutation'
  conflict: Scalars['Boolean']['output']
  draft: CustomerGuideDraft
}

export type CustomerGuideDraftPreview = {
  __typename?: 'CustomerGuideDraftPreview'
  pdfDataUrl: Scalars['String']['output']
}

export type CustomerGuideDraftPreviewInput = {
  content: Scalars['JSONObject']['input']
  materialId: Scalars['ID']['input']
}

export enum CustomerGuideDraftStatus {
  Draft = 'DRAFT',
  Submitted = 'SUBMITTED',
}

export type CustomerGuideDraftSubmission = {
  __typename?: 'CustomerGuideDraftSubmission'
  conflict: Scalars['Boolean']['output']
  draft?: Maybe<CustomerGuideDraft>
  guide: CustomerGuide
  replacementInProgress: Scalars['Boolean']['output']
}

export type CustomerGuideDraftSubmitInput = {
  expectedRevision: Scalars['Int']['input']
  materialId: Scalars['ID']['input']
}

export enum CustomerGuideFailureState {
  None = 'NONE',
  ReplacementFailed = 'REPLACEMENT_FAILED',
}

export enum CustomerGuideReplacementState {
  AwaitingInternalApproval = 'AWAITING_INTERNAL_APPROVAL',
  Failed = 'FAILED',
  Generating = 'GENERATING',
  Idle = 'IDLE',
}

export type CustomerGuideTopic = {
  __typename?: 'CustomerGuideTopic'
  landingpageId?: Maybe<Scalars['ID']['output']>
  name?: Maybe<Scalars['String']['output']>
  slug?: Maybe<Scalars['String']['output']>
}

export type DeactivateLandingpageInput = {
  slug: Scalars['String']['input']
}

export type DeleteAiGeneratedMaterialInput = {
  /** The company ID (optional, will use authenticated user's company if not provided) */
  companyId?: InputMaybe<Scalars['ID']['input']>
  /** The material ID to delete */
  materialId: Scalars['ID']['input']
}

export type DeleteAiGeneratedMaterialResponse = {
  __typename?: 'DeleteAiGeneratedMaterialResponse'
  error?: Maybe<Scalars['String']['output']>
  materialId?: Maybe<Scalars['ID']['output']>
  success: Scalars['Boolean']['output']
}

export type DeleteCompanyImageInput = {
  companyId: Scalars['String']['input']
  type: Scalars['String']['input']
}

export type DeleteDocumentOnContractInput = {
  contractId: Scalars['ID']['input']
  documentId: Scalars['ID']['input']
}

export type DeleteDueDateInput = {
  leadId: Scalars['ID']['input']
}

export type DeleteHoppermationSenderInput = {
  senderId: Scalars['ID']['input']
}

export type DeleteLeadsInput = {
  leadIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

export type DeleteLeadsPipelineStatusInput = {
  id: Scalars['ID']['input']
}

export type DeleteLeadsToLandingpageInput = {
  savedContentId?: InputMaybe<Scalars['ID']['input']>
}

export type DeleteMaterialTemplateWithRelatedMaterialsResult = {
  __typename?: 'DeleteMaterialTemplateWithRelatedMaterialsResult'
  deletedMaterialTemplate?: Maybe<MaterialTemplate>
  deletedMaterialsCount?: Maybe<Scalars['Int']['output']>
}

export type DeletePlanInput = {
  planId: Scalars['ID']['input']
}

export type DeleteSavedContentBatchInput = {
  postingBatchId: Scalars['ID']['input']
}

export type DeleteSavedContentInput = {
  id: Scalars['ID']['input']
}

export type DeleteSlotsInput = {
  planId: Scalars['ID']['input']
  slotIds: Array<Scalars['ID']['input']>
}

export type DeleteSocialMediaPostsInput = {
  ids: Array<Scalars['ID']['input']>
}

export type DeleteUserUploadedMaterialInput = {
  /** The company ID (optional, will use authenticated user's company if not provided) */
  companyId?: InputMaybe<Scalars['ID']['input']>
  /** The material ID to delete */
  materialId: Scalars['ID']['input']
}

export type DeleteUserUploadedMaterialResponse = {
  __typename?: 'DeleteUserUploadedMaterialResponse'
  error?: Maybe<Scalars['String']['output']>
  materialId?: Maybe<Scalars['ID']['output']>
  success: Scalars['Boolean']['output']
}

export type DowngradeToBasicInput = {
  companyId: Scalars['ID']['input']
  isYearly: Scalars['Boolean']['input']
}

export type DowngradeToBeginnerInput = {
  companyId: Scalars['ID']['input']
  isYearly: Scalars['Boolean']['input']
}

export type DowngradeToFreeLightInput = {
  companyId: Scalars['ID']['input']
}

export type DowngradeToLightInput = {
  companyId: Scalars['ID']['input']
  isYearly: Scalars['Boolean']['input']
}

export type DownloadConversion = {
  __typename?: 'DownloadConversion'
  postalShipping?: Maybe<PostalShippingType>
}

export type Duration = {
  __typename?: 'Duration'
  unit?: Maybe<DurationUnit>
  value?: Maybe<Scalars['Int']['output']>
}

export type DurationInput = {
  unit?: InputMaybe<DurationUnit>
  value?: InputMaybe<Scalars['Int']['input']>
}

export enum DurationUnit {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
}

/**
 * Input for the editEmail mutation. It takes the original email (MJML and plaintext),
 * an edited plaintext version, and returns an improved email that incorporates the changes.
 */
export type EditEmailInput = {
  /** The original MJML email body. */
  MJMLBody: Scalars['String']['input']
  /** The edited plaintext email body containing the desired changes. */
  editedplaintextBody: Scalars['String']['input']
  /** Custom instructions or error message for email editing. Can be null if no specific instructions or errors. */
  error?: InputMaybe<Scalars['String']['input']>
  /** Whether the email is in MJML format (true) or plaintext (false). */
  isMJML: Scalars['Boolean']['input']
  /** Optional metadata for email generation. If not provided, will be auto-generated from company data. */
  metadata?: InputMaybe<EditEmailMetadataInput>
  /** The original plaintext email body. */
  plaintextBody: Scalars['String']['input']
}

/** Metadata input for email editing. Contains company and content generation settings. */
export type EditEmailMetadataInput = {
  /** Business description. */
  businessDescription?: InputMaybe<Scalars['String']['input']>
  /** Company name. */
  companyName?: InputMaybe<Scalars['String']['input']>
  /** Country name. */
  country?: InputMaybe<Scalars['String']['input']>
  /** Country code (ISO format). */
  countryCode?: InputMaybe<Scalars['String']['input']>
  /** Farewell. */
  farewell?: InputMaybe<Scalars['String']['input']>
  /** Formality level: formal or informal. */
  formality?: InputMaybe<Scalars['String']['input']>
  /** Industry. */
  industry?: InputMaybe<Scalars['String']['input']>
  /** Language code. */
  language?: InputMaybe<Scalars['String']['input']>
  /** Marketing goal. */
  marketingGoal?: InputMaybe<Scalars['String']['input']>
  /** Perspective: singular or plural. */
  perspective?: InputMaybe<Scalars['String']['input']>
  /** Region or city. */
  region?: InputMaybe<Scalars['String']['input']>
  /** Salutation. */
  salutation?: InputMaybe<Scalars['String']['input']>
  /** Company slogan. */
  slogan?: InputMaybe<Scalars['String']['input']>
  /** Target group. */
  targetGroup?: InputMaybe<Scalars['String']['input']>
  /** Tonality: professional or casual. */
  tonality?: InputMaybe<Scalars['String']['input']>
}

/** Represents an entry in the edit history of an image. */
export type EditHistoryEntry = {
  __typename?: 'EditHistoryEntry'
  dimensions?: Maybe<ImageDimensions>
  id?: Maybe<Scalars['ID']['output']>
  timestamp: Scalars['DateTime']['output']
  type: Scalars['String']['output']
  userId?: Maybe<Scalars['ID']['output']>
}

/**
 * Input for the editImage mutation. It takes the ID of the image to
 * replace and the new image file.
 */
export type EditImageInput = {
  /** The new, edited image file being uploaded. */
  image: Scalars['Upload']['input']
  /** The ID of the image document to find and modify. */
  imageId: Scalars['ID']['input']
  /** Specifies the source of the image (e.g., AI, custom) to locate the correct database document. */
  imageType: ImageType
  /** The provider of the stock photo (e.g., 'pexels', 'adobe-free'). Required when imageType is STOCK. */
  provider?: InputMaybe<Scalars['String']['input']>
  /** The topic ID of the image to edit. */
  topicId: Scalars['ID']['input']
}

export type EmailAttachment = {
  __typename?: 'EmailAttachment'
  content?: Maybe<Scalars['String']['output']>
  contentType: Scalars['String']['output']
  fileId?: Maybe<Scalars['ID']['output']>
  id?: Maybe<Scalars['ID']['output']>
  name: Scalars['String']['output']
  path?: Maybe<Scalars['String']['output']>
  size: Scalars['Int']['output']
  url?: Maybe<Scalars['String']['output']>
}

export type EmailAttachmentInput = {
  content?: InputMaybe<Scalars['String']['input']>
  contentType: Scalars['String']['input']
  fileId?: InputMaybe<Scalars['ID']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  name: Scalars['String']['input']
  size?: InputMaybe<Scalars['Int']['input']>
}

export type EmailMessage = {
  __typename?: 'EmailMessage'
  actions?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  attachments?: Maybe<Array<EmailAttachment>>
  automationId?: Maybe<Scalars['String']['output']>
  conversionCountByType?: Maybe<ConversionCountByType>
  editedHtmlBody?: Maybe<Scalars['String']['output']>
  editedMjmlBody?: Maybe<Scalars['String']['output']>
  editedTextBody?: Maybe<Scalars['String']['output']>
  email?: Maybe<Scalars['String']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  htmlBody?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['ID']['output']>
  isNewsletter?: Maybe<Scalars['Boolean']['output']>
  lastName?: Maybe<Scalars['String']['output']>
  mjmlBody?: Maybe<Scalars['String']['output']>
  runId?: Maybe<Scalars['String']['output']>
  savedContentId?: Maybe<Scalars['ID']['output']>
  scheduledAt?: Maybe<Scalars['DateTime']['output']>
  stepId?: Maybe<Scalars['String']['output']>
  subject?: Maybe<Scalars['String']['output']>
  textBody?: Maybe<Scalars['String']['output']>
}

export type EmailState = {
  __typename?: 'EmailState'
  state?: Maybe<EmailStateType>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export enum EmailStateType {
  Active = 'ACTIVE',
  HardBounce = 'HARD_BOUNCE',
  ManualSuppression = 'MANUAL_SUPPRESSION',
  SpamComplaint = 'SPAM_COMPLAINT',
}

export type EmproAuthCodeInput = {
  code: Scalars['String']['input']
}

export type EmproAuthPayload = {
  __typename?: 'EmproAuthPayload'
  accessToken: Scalars['String']['output']
  idToken: Scalars['String']['output']
  refreshToken?: Maybe<Scalars['String']['output']>
}

export type EmproConfig = {
  __typename?: 'EmproConfig'
  isTokenVerified?: Maybe<Scalars['Boolean']['output']>
  selectedContactStatusIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>
}

export type EmproContactCount = {
  __typename?: 'EmproContactCount'
  countPerStatus?: Maybe<Scalars['JSONObject']['output']>
}

export type EmproContactStatuses = {
  __typename?: 'EmproContactStatuses'
  contactMedium?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['ID']['output']>
  name?: Maybe<Scalars['String']['output']>
}

export type EmproContactTypes = {
  __typename?: 'EmproContactTypes'
  contactMedium?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['ID']['output']>
  name?: Maybe<Scalars['String']['output']>
}

export type EmproDelete = {
  __typename?: 'EmproDelete'
  success: Scalars['Boolean']['output']
}

export type EmproSelectedContactStatusesInput = {
  selectedContactStatusIds: Array<Scalars['ID']['input']>
}

export type EnabledPhoneVerification = {
  __typename?: 'EnabledPhoneVerification'
  VALUATION?: Maybe<Scalars['Boolean']['output']>
}

export type EnabledSource = {
  __typename?: 'EnabledSource'
  email?: Maybe<Scalars['Boolean']['output']>
  sms?: Maybe<Scalars['Boolean']['output']>
  whatsapp?: Maybe<Scalars['Boolean']['output']>
}

export type EnabledTypesInput = {
  APARTMENT?: InputMaybe<ValuationProvider>
  HOUSE?: InputMaybe<ValuationProvider>
  MULTI_FAMILY_HOUSE?: InputMaybe<ValuationProvider>
  PLOT?: InputMaybe<ValuationProvider>
}

export type EnabledVerification = {
  __typename?: 'EnabledVerification'
  VALUATION?: Maybe<Scalars['Boolean']['output']>
}

export type FacebookPage = {
  __typename?: 'FacebookPage'
  id?: Maybe<Scalars['ID']['output']>
  instagram_business_account?: Maybe<InstagramAccount>
  isActive?: Maybe<Scalars['Boolean']['output']>
  name?: Maybe<Scalars['String']['output']>
}

export type FailedPosts = {
  __typename?: 'FailedPosts'
  parentCompanyId: Scalars['ID']['output']
  postId?: Maybe<Scalars['ID']['output']>
  postingBatchId: Scalars['ID']['output']
  textKind?: Maybe<Scalars['String']['output']>
  url?: Maybe<Scalars['String']['output']>
}

export type FailedSocialMediaPosts = {
  __typename?: 'FailedSocialMediaPosts'
  parentCompanyId: Scalars['ID']['output']
  postingBatchId: Scalars['ID']['output']
  posts?: Maybe<Array<Maybe<FailedPosts>>>
}

export enum FbPixelEventSourceUrlType {
  CompanyWebsite = 'COMPANY_WEBSITE',
  Custom = 'CUSTOM',
  LandingpageDefault = 'LANDINGPAGE_DEFAULT',
}

export type Feature = {
  __typename?: 'Feature'
  config?: Maybe<Scalars['JSONObject']['output']>
  isActive?: Maybe<Scalars['Boolean']['output']>
  isDefaultActive?: Maybe<Scalars['Boolean']['output']>
  isEnabled?: Maybe<Scalars['Boolean']['output']>
  isUpsellingEnabled?: Maybe<Scalars['Boolean']['output']>
  name?: Maybe<Scalars['String']['output']>
  slug?: Maybe<Scalars['ID']['output']>
}

export enum FeatureName {
  LeadBulkImport = 'LEAD_BULK_IMPORT',
  LeadImport = 'LEAD_IMPORT',
}

export type FeaturePermission = {
  __typename?: 'FeaturePermission'
  hasPermission?: Maybe<Scalars['Boolean']['output']>
  name?: Maybe<FeatureName>
}

export type File = {
  __typename?: 'File'
  /** @deprecated Parameter 'named' is is not handled anymore */
  cdnUrl?: Maybe<Scalars['String']['output']>
  downloads?: Maybe<Scalars['Int']['output']>
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  type?: Maybe<Scalars['String']['output']>
  url?: Maybe<Scalars['String']['output']>
}

export type FileCdnUrlArgs = {
  named?: InputMaybe<Scalars['Boolean']['input']>
}

export enum FileImportColumnNameType {
  Email = 'EMAIL',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME',
  Phone = 'PHONE',
}

export type FileImportValidColumnName = {
  __typename?: 'FileImportValidColumnName'
  EMAIL?: Maybe<Scalars['String']['output']>
  FIRST_NAME?: Maybe<Scalars['String']['output']>
  LAST_NAME?: Maybe<Scalars['String']['output']>
  PHONE?: Maybe<Scalars['String']['output']>
}

export type FilterInput = {
  assignedUser?: InputMaybe<Scalars['String']['input']>
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  currentStatus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  downloadLandingpage?: InputMaybe<Scalars['String']['input']>
  downloads?: InputMaybe<Scalars['Boolean']['input']>
  dueDateNextMonth?: InputMaybe<Scalars['Boolean']['input']>
  dueDateNextWeek?: InputMaybe<Scalars['Boolean']['input']>
  dueDateOverdue?: InputMaybe<Scalars['Boolean']['input']>
  dueDateThisMonth?: InputMaybe<Scalars['Boolean']['input']>
  dueDateThisWeek?: InputMaybe<Scalars['Boolean']['input']>
  dueDateToday?: InputMaybe<Scalars['Boolean']['input']>
  hasConverted?: InputMaybe<Scalars['Boolean']['input']>
  invited?: InputMaybe<Scalars['String']['input']>
  leadOriginConversion?: InputMaybe<Scalars['Boolean']['input']>
  leadOriginCrm?: InputMaybe<Scalars['Boolean']['input']>
  leadOriginImport?: InputMaybe<Scalars['Boolean']['input']>
  lifeAnnuities?: InputMaybe<Scalars['Boolean']['input']>
  moveContacts?: InputMaybe<Scalars['Boolean']['input']>
  newsletter?: InputMaybe<Scalars['Boolean']['input']>
  noGuideChecklistDownload?: InputMaybe<Scalars['Boolean']['input']>
  partialSales?: InputMaybe<Scalars['Boolean']['input']>
  plotValuations?: InputMaybe<Scalars['Boolean']['input']>
  postalShipping?: InputMaybe<Scalars['Boolean']['input']>
  propertyRequests?: InputMaybe<Scalars['Boolean']['input']>
  quizPreConversion?: InputMaybe<Scalars['Boolean']['input']>
  returnCalls?: InputMaybe<Scalars['Boolean']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  source?: InputMaybe<Scalars['String']['input']>
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  utmCampaign?: InputMaybe<Scalars['String']['input']>
  utmContent?: InputMaybe<Scalars['String']['input']>
  utmMedium?: InputMaybe<Scalars['String']['input']>
  utmSource?: InputMaybe<Scalars['String']['input']>
  utmTerm?: InputMaybe<Scalars['String']['input']>
  valuations?: InputMaybe<Scalars['Boolean']['input']>
  withoutDueDate?: InputMaybe<Scalars['Boolean']['input']>
  zipcode?: InputMaybe<Scalars['String']['input']>
}

export type FilterOption = {
  __typename?: 'FilterOption'
  count: Scalars['Int']['output']
  id: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
  source?: Maybe<Scalars['String']['output']>
  type?: Maybe<Scalars['String']['output']>
}

export enum Financing {
  Clarification = 'CLARIFICATION',
  Clear = 'CLEAR',
  ConsultingNeeded = 'CONSULTING_NEEDED',
  Unclear = 'UNCLEAR',
}

export type FlowfactConfig = {
  __typename?: 'FlowfactConfig'
  isTokenVerified?: Maybe<Scalars['Boolean']['output']>
  selectedContactStatusIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>
  token?: Maybe<Scalars['String']['output']>
}

export type FlowfactContactCount = {
  __typename?: 'FlowfactContactCount'
  count?: Maybe<Scalars['Int']['output']>
  countPerStatus?: Maybe<Scalars['JSONObject']['output']>
  maxCount?: Maybe<Scalars['Int']['output']>
}

export type FlowfactContactTag = {
  __typename?: 'FlowfactContactTag'
  id?: Maybe<Scalars['ID']['output']>
  name?: Maybe<Scalars['String']['output']>
}

export type FlowfactCredentialsInput = {
  token?: InputMaybe<Scalars['String']['input']>
}

export type FlowfactSelectedContactStatusesInput = {
  companyId: Scalars['ID']['input']
  selectedContactStatusIds: Array<Scalars['ID']['input']>
}

export type FollowUp = {
  __typename?: 'FollowUp'
  boolean?: Maybe<Scalars['Boolean']['output']>
  reasoning?: Maybe<Scalars['String']['output']>
  when?: Maybe<When>
}

export enum Formality {
  Formal = 'formal',
  Informal = 'informal',
}

export type FunnelsBounceStatistics = {
  __typename?: 'FunnelsBounceStatistics'
  date?: Maybe<Scalars['String']['output']>
  hardBounce?: Maybe<Scalars['Int']['output']>
  softBounce?: Maybe<Scalars['Int']['output']>
}

export type FunnelsSentCountsStatistics = {
  __typename?: 'FunnelsSentCountsStatistics'
  date?: Maybe<Scalars['String']['output']>
  sent?: Maybe<Scalars['Int']['output']>
}

export enum Gender {
  Divers = 'DIVERS',
  Female = 'FEMALE',
  Male = 'MALE',
  Other = 'OTHER',
}

export type GenerateCampaignInput = {
  campaignId: Scalars['ID']['input']
  companyId?: InputMaybe<Scalars['ID']['input']>
  materialTemplates: Array<Scalars['ID']['input']>
  status?: InputMaybe<Array<InputMaybe<MaterialStatus>>>
  variant?: InputMaybe<Variant>
}

export type GenerateImageInput = {
  aspectRatio?: InputMaybe<Scalars['String']['input']>
  isMasterView?: InputMaybe<Scalars['Boolean']['input']>
  modelName?: InputMaybe<Scalars['String']['input']>
  topicId: Scalars['ID']['input']
  type?: InputMaybe<Scalars['String']['input']>
}

export type GenerateMarketingPlanInput = {
  /** First day of the planning window. Same-day posts are not allowed: omitted, today, and past dates are clamped to tomorrow in the company reference timezone. */
  startDate?: InputMaybe<Scalars['DateTime']['input']>
  /** Active marketing topic the plan is built around. When set, every slot uses this topic. Omitted keeps the previous behaviour of rotating all active topics. */
  topicId?: InputMaybe<Scalars['ID']['input']>
  /** Calendar days the plan covers: 7 (one week), 14 (two weeks), or 28 (four weeks). Omitted uses MARKETING_AGENT_PLAN_WINDOW_DAYS. */
  windowDays?: InputMaybe<Scalars['Int']['input']>
}

export type GenerateMarketingPlanResult = {
  __typename?: 'GenerateMarketingPlanResult'
  /** Null unless status is GENERATED. */
  plan?: Maybe<MarketingPlan>
  status: GenerateMarketingPlanStatus
}

export enum GenerateMarketingPlanStatus {
  Generated = 'GENERATED',
  NoPlatforms = 'NO_PLATFORMS',
  NoTopics = 'NO_TOPICS',
  PlanOverlap = 'PLAN_OVERLAP',
}

export type GenerateMaterialsForTemplateInput = {
  landingpageTemplateId?: InputMaybe<Scalars['ID']['input']>
  materialTemplateId?: InputMaybe<Scalars['ID']['input']>
  priority?: InputMaybe<Scalars['Int']['input']>
}

export type GenerateMaterialsInBulkInput = {
  landingpageSlugs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  priority?: InputMaybe<Scalars['Int']['input']>
  status?: InputMaybe<Array<InputMaybe<MaterialStatus>>>
  types?: InputMaybe<Array<InputMaybe<MaterialType>>>
  variants?: InputMaybe<Array<InputMaybe<Variant>>>
}

export type GenerateMaterialsInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>
  landingpageId?: InputMaybe<Scalars['ID']['input']>
  priority?: InputMaybe<Scalars['Int']['input']>
  types?: InputMaybe<Array<InputMaybe<MaterialType>>>
}

export type GenerateSocialTextFromFacebookInput = {
  facebookText: Scalars['String']['input']
  isMasterView?: InputMaybe<Scalars['Boolean']['input']>
  targetStyle: SocialMediaType
}

export type GenerateTextInput = {
  isMasterView?: InputMaybe<Scalars['Boolean']['input']>
  textKind: Scalars['String']['input']
  topicId: Scalars['ID']['input']
}

export type GeneratedImage = ImageInterface & {
  __typename?: 'GeneratedImage'
  companyId?: Maybe<Scalars['ID']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  fileId: Scalars['ID']['output']
  fileSize?: Maybe<Scalars['Int']['output']>
  height?: Maybe<Scalars['Int']['output']>
  history?: Maybe<Array<Maybe<EditHistoryEntry>>>
  id: Scalars['ID']['output']
  modelName?: Maybe<Scalars['String']['output']>
  originalImageUrl?: Maybe<Scalars['String']['output']>
  topicId?: Maybe<Scalars['ID']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  url?: Maybe<Scalars['String']['output']>
  width?: Maybe<Scalars['Int']['output']>
}

export type GeneratedImages = {
  __typename?: 'GeneratedImages'
  images?: Maybe<Array<Maybe<GeneratedImage>>>
  page?: Maybe<Scalars['Int']['output']>
  perPage?: Maybe<Scalars['Int']['output']>
  total?: Maybe<Scalars['Int']['output']>
}

export type GeneratedText = {
  __typename?: 'GeneratedText'
  choices?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  id?: Maybe<Scalars['ID']['output']>
}

/** One Makler App AI topic and the Material Maker outputs it requested. */
export type GeneratedTopicMaterialBundle = {
  __typename?: 'GeneratedTopicMaterialBundle'
  bundleStatus: MaterialMakerBundleStatus
  createdAt: Scalars['DateTime']['output']
  expectedCount: Scalars['Int']['output']
  materials: Array<Material>
  topicId: Scalars['ID']['output']
  topicName: Scalars['String']['output']
  topicStatus: TopicStatus
}

export enum GenerationService {
  BrandEasy = 'BRAND_EASY',
  Creatify = 'CREATIFY',
  MaterialMaker = 'MATERIAL_MAKER',
  S3Video = 'S3_VIDEO',
  Static = 'STATIC',
}

export type GenerationStats = {
  __typename?: 'GenerationStats'
  imageCount?: Maybe<Scalars['Int']['output']>
  textCount?: Maybe<Scalars['Int']['output']>
}

export type GetAcquisitionBoosterLeadIdsInput = {
  childCompanyId?: InputMaybe<Scalars['ID']['input']>
  companyId: Scalars['String']['input']
  filters?: InputMaybe<FilterInput>
  isMasterView?: InputMaybe<Scalars['Boolean']['input']>
  landingpageSlug?: InputMaybe<Scalars['String']['input']>
  onlyAssignedToMe?: InputMaybe<Scalars['Boolean']['input']>
  search?: InputMaybe<Scalars['String']['input']>
}

export type GetAdMaterialsInput = {
  assetTypes?: InputMaybe<Array<InputMaybe<AssetType>>>
  buyers?: InputMaybe<Scalars['Boolean']['input']>
  imageSources?: InputMaybe<Array<InputMaybe<ImageSources>>>
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  search?: InputMaybe<Scalars['String']['input']>
  sellers?: InputMaybe<Scalars['Boolean']['input']>
  sortOrder?: InputMaybe<Scalars['String']['input']>
  topicIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

export type GetAllActivitiesInput = {
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  page: Scalars['Int']['input']
  perPage?: InputMaybe<Scalars['Int']['input']>
  platform?: InputMaybe<Scalars['String']['input']>
  scheduled?: InputMaybe<Scalars['Boolean']['input']>
  type?: InputMaybe<ActivityType>
}

export type GetAllLeadActivitiesInput = {
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  page: Scalars['Int']['input']
  perPage?: InputMaybe<Scalars['Int']['input']>
  platform?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<LeadFeedActivityType>
}

export type GetAllSavedContentsInput = {
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
}

export type GetAnalyticsImpressionFiltersInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  startDate?: InputMaybe<Scalars['DateTime']['input']>
}

export type GetAnalyticsImpressionInput = {
  childCompanyId?: InputMaybe<Scalars['ID']['input']>
  companyId?: InputMaybe<Scalars['ID']['input']>
  filters?: InputMaybe<GetAnalyticsImpressionFiltersInput>
  isMasterView?: InputMaybe<Scalars['Boolean']['input']>
  specificDate?: InputMaybe<Scalars['String']['input']>
}

export type GetComponentSubscriptionsCountBySlugInput = {
  companyId: Scalars['ID']['input']
  slug: Scalars['String']['input']
}

export type GetCreatedContentStatisticsFilterInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  startDate?: InputMaybe<Scalars['DateTime']['input']>
}

export type GetCreatedContentsStatisticsInput = {
  childCompanyId?: InputMaybe<Scalars['ID']['input']>
  companyId?: InputMaybe<Scalars['ID']['input']>
  filters?: InputMaybe<GetCreatedContentStatisticsFilterInput>
  isMasterView?: InputMaybe<Scalars['Boolean']['input']>
}

export type GetDailyAnalyticsImpressionInput = {
  childCompanyId?: InputMaybe<Scalars['ID']['input']>
  companyId?: InputMaybe<Scalars['ID']['input']>
  filters?: InputMaybe<GetAnalyticsImpressionFiltersInput>
  isMasterView?: InputMaybe<Scalars['Boolean']['input']>
}

export type GetDeleteLeadsLeadIdsInput = {
  companyId: Scalars['String']['input']
  filters?: InputMaybe<FilterInput>
  onlyAssignedToMe?: InputMaybe<Scalars['Boolean']['input']>
  search?: InputMaybe<Scalars['String']['input']>
}

export type GetEmailFunnelsStatisticsFilters = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  startDate?: InputMaybe<Scalars['DateTime']['input']>
}

export type GetEmailFunnelsStatisticsInput = {
  childCompanyId?: InputMaybe<Scalars['ID']['input']>
  companyId?: InputMaybe<Scalars['ID']['input']>
  filters?: InputMaybe<GetEmailFunnelsStatisticsFilters>
  isMasterView?: InputMaybe<Scalars['Boolean']['input']>
}

export type GetFacebookPagesInput = {
  userId?: InputMaybe<Scalars['String']['input']>
}

export type GetFailedSocialMediaPostsInput = {
  isMasterView?: InputMaybe<Scalars['Boolean']['input']>
  postingBatchId?: InputMaybe<Scalars['ID']['input']>
}

export type GetFilteredLeadIdsWithOutstandingPropertyTrackerInput = {
  companyId?: InputMaybe<Scalars['String']['input']>
  filters?: InputMaybe<FilterInput>
  onlyAssignedToMe?: InputMaybe<Scalars['Boolean']['input']>
  search?: InputMaybe<Scalars['String']['input']>
}

export type GetFilteredLeadIdsWithOutstandingPropertyTrackerResult = {
  __typename?: 'GetFilteredLeadIdsWithOutstandingPropertyTrackerResult'
  leadIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>
}

export type GetGeneratedImagesInput = {
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  topicId: Scalars['ID']['input']
}

export type GetInvitationStatisticsInput = {
  childCompanyId?: InputMaybe<Scalars['ID']['input']>
  companyId?: InputMaybe<Scalars['ID']['input']>
  filters?: InputMaybe<GetInvitationStatisticsInputFilters>
  isMasterView?: InputMaybe<Scalars['Boolean']['input']>
}

export type GetInvitationStatisticsInputFilters = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  startDate?: InputMaybe<Scalars['DateTime']['input']>
}

export type GetLandingpageBySlugInput = {
  landingpageSlug: Scalars['String']['input']
}

export type GetLandingpageByTypeInput = {
  landingpageType: Scalars['String']['input']
}

export type GetLandingpageInput = {
  landingpageId: Scalars['ID']['input']
}

export type GetLandingpageTemplateInput = {
  landingpageTemplateId: Scalars['ID']['input']
}

export type GetLandingpageTemplatesInput = {
  slug: Scalars['String']['input']
}

export type GetLastGeneratedTextInput = {
  textKind: Scalars['String']['input']
  topicId: Scalars['ID']['input']
}

export type GetLeadSuggestionsInput = {
  search: Scalars['String']['input']
}

export type GetLeadsPipelineStatusesFiltersInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  startDate?: InputMaybe<Scalars['DateTime']['input']>
}

export type GetLeadsPipelineStatusesInput = {
  childCompanyId?: InputMaybe<Scalars['ID']['input']>
  companyId?: InputMaybe<Scalars['ID']['input']>
  filters?: InputMaybe<GetLeadsPipelineStatusesFiltersInput>
  isMasterView?: InputMaybe<Scalars['Boolean']['input']>
}

export type GetLeadsStatusesStatisticsFiltersInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  startDate?: InputMaybe<Scalars['DateTime']['input']>
}

export type GetLeadsStatusesStatisticsInput = {
  childCompanyId?: InputMaybe<Scalars['ID']['input']>
  companyId?: InputMaybe<Scalars['ID']['input']>
  filters?: InputMaybe<GetLeadsStatusesStatisticsFiltersInput>
  isMasterView?: InputMaybe<Scalars['Boolean']['input']>
}

export type GetLeadsWithLocationInput = {
  childCompanyId?: InputMaybe<Scalars['ID']['input']>
  isMasterView?: InputMaybe<Scalars['Boolean']['input']>
}

export type GetMasterBatchPostsInput = {
  postingBatchId: Scalars['ID']['input']
}

export type GetNewsletterDeliveryDetailsInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>
  isMasterView?: InputMaybe<Scalars['Boolean']['input']>
  savedContentId: Scalars['ID']['input']
}

export type GetNumberOfLandingpagesFilter = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  startDate?: InputMaybe<Scalars['DateTime']['input']>
}

export type GetNumberOfLandingpagesInput = {
  childCompanyId?: InputMaybe<Scalars['ID']['input']>
  companyId?: InputMaybe<Scalars['ID']['input']>
  filters?: InputMaybe<GetNumberOfLandingpagesFilter>
  isMasterView?: InputMaybe<Scalars['Boolean']['input']>
}

export type GetSavedContentInput = {
  savedContentId: Scalars['ID']['input']
}

export type GetSavedContentsFilter = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  startDate?: InputMaybe<Scalars['DateTime']['input']>
}

export type GetSavedContentsInput = {
  childCompanyId?: InputMaybe<Scalars['ID']['input']>
  companyId?: InputMaybe<Scalars['ID']['input']>
  filters?: InputMaybe<GetSavedContentsFilter>
  isMasterView?: InputMaybe<Scalars['Boolean']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  textKinds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  timeRange?: InputMaybe<SavedContentsFilterType>
  topics?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

export type GetScheduledContentsInput = {
  childCompanyId?: InputMaybe<Scalars['ID']['input']>
  isMasterView?: InputMaybe<Scalars['Boolean']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  textKinds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  timeRange?: InputMaybe<SavedContentsFilterType>
  topics?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

export type GetStockPhotosInput = {
  page: Scalars['Int']['input']
  per_page: Scalars['Int']['input']
  provider?: InputMaybe<Scalars['String']['input']>
  topic: Scalars['String']['input']
}

export type GetToDoInput = {
  companyId: Scalars['ID']['input']
}

export type GetUserImagesInput = {
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  topicId: Scalars['ID']['input']
}

export type GetUsersInput = {
  childCompanyId?: InputMaybe<Scalars['ID']['input']>
  companyId?: InputMaybe<Scalars['ID']['input']>
  isMasterView?: InputMaybe<Scalars['Boolean']['input']>
}

export type GetValuationInput = {
  childCompanyId?: InputMaybe<Scalars['ID']['input']>
  isMasterView?: InputMaybe<Scalars['Boolean']['input']>
  valuationId: Scalars['ID']['input']
}

export type GetValuationInputLimitsInput = {
  countryCode: CountryCode
  propertyType: PropertyType
}

export type GetValuationsPaginatedInput = {
  childCompanyId?: InputMaybe<Scalars['ID']['input']>
  createdByAgent?: InputMaybe<Scalars['Boolean']['input']>
  isMasterView?: InputMaybe<Scalars['Boolean']['input']>
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type GoogleBusinessConnectResult = {
  __typename?: 'GoogleBusinessConnectResult'
  locationId?: Maybe<Scalars['String']['output']>
  locationName?: Maybe<Scalars['String']['output']>
  /** One of PENDING, NEEDS_LOCATION or CONNECTED. */
  status?: Maybe<Scalars['String']['output']>
  /**
   * bundle.social OAuth URL the frontend should redirect the user to.
   * Null when the account is already connected and no authorization is needed —
   * check `status` in that case.
   */
  url?: Maybe<Scalars['String']['output']>
}

export type GoogleBusinessConnectionStatus = {
  __typename?: 'GoogleBusinessConnectionStatus'
  locationId?: Maybe<Scalars['String']['output']>
  locationName?: Maybe<Scalars['String']['output']>
  /** One of PENDING, NEEDS_LOCATION, CONNECTED, or null when not started. */
  status?: Maybe<Scalars['String']['output']>
}

export type GoogleBusinessLocation = {
  __typename?: 'GoogleBusinessLocation'
  id?: Maybe<Scalars['String']['output']>
  isActive?: Maybe<Scalars['Boolean']['output']>
  name?: Maybe<Scalars['String']['output']>
}

export type GoogleCalendarOAuthPreparePayload = {
  __typename?: 'GoogleCalendarOAuthPreparePayload'
  authUrl: Scalars['String']['output']
}

export type GooglePlace = {
  __typename?: 'GooglePlace'
  description?: Maybe<Scalars['String']['output']>
  placeId?: Maybe<Scalars['String']['output']>
}

export type GooglePlaceAddress = {
  __typename?: 'GooglePlaceAddress'
  city?: Maybe<Scalars['String']['output']>
  country?: Maybe<Scalars['String']['output']>
  countryCode?: Maybe<Scalars['String']['output']>
  houseNumber?: Maybe<Scalars['String']['output']>
  postcode?: Maybe<Scalars['String']['output']>
  street?: Maybe<Scalars['String']['output']>
}

export type GooglePlaceCoordinates = {
  __typename?: 'GooglePlaceCoordinates'
  lat?: Maybe<Scalars['String']['output']>
  lng?: Maybe<Scalars['String']['output']>
}

export type GooglePlaceDetails = {
  __typename?: 'GooglePlaceDetails'
  address?: Maybe<GooglePlaceAddress>
  coordinates?: Maybe<GooglePlaceCoordinates>
  formattedAddress?: Maybe<Scalars['String']['output']>
}

export type GooglePlaceDetailsInput = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  placeId: Scalars['ID']['input']
  sessionToken: Scalars['String']['input']
}

export type GooglePlacesInput = {
  country: Scalars['String']['input']
  language: Scalars['String']['input']
  search: Scalars['String']['input']
  sessionToken: Scalars['String']['input']
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type HandleOnboardingBillingDataInput = {
  customer: OnboardingBillingCustomerInput
}

export type HoppermationDomain = {
  __typename?: 'HoppermationDomain'
  dkimHost?: Maybe<Scalars['String']['output']>
  dkimText?: Maybe<Scalars['String']['output']>
  domain?: Maybe<Scalars['ID']['output']>
  isDKIMVerified?: Maybe<Scalars['Boolean']['output']>
  isReturnPathDomainVerified?: Maybe<Scalars['Boolean']['output']>
  returnPathDomain?: Maybe<Scalars['String']['output']>
  returnPathDomainCname?: Maybe<Scalars['String']['output']>
}

export type HoppermationOrganization = {
  __typename?: 'HoppermationOrganization'
  companyId?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['ID']['output']>
  status?: Maybe<OrganizationStatus>
}

export type HoppermationSender = {
  __typename?: 'HoppermationSender'
  companyId?: Maybe<Scalars['String']['output']>
  fromEmail?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['ID']['output']>
  isAcknowledged?: Maybe<Scalars['Boolean']['output']>
  isDefault?: Maybe<Scalars['Boolean']['output']>
  isVerified?: Maybe<Scalars['Boolean']['output']>
  name?: Maybe<Scalars['String']['output']>
  organizationId?: Maybe<Scalars['String']['output']>
  replyToEmail?: Maybe<Scalars['String']['output']>
}

export type HubspotUserIdentification = {
  __typename?: 'HubspotUserIdentification'
  email: Scalars['String']['output']
  token: Scalars['String']['output']
}

export type Identity = {
  __typename?: 'Identity'
  company?: Maybe<Company>
  user?: Maybe<User>
}

/**
 * Union type representing any image that can be edited.
 * This allows the editImage mutation to return any of the supported image types.
 */
export type Image = GeneratedImage | Material | StockImage | StockPhoto | UserImage

/** Represents the dimensions of an image. */
export type ImageDimensions = {
  __typename?: 'ImageDimensions'
  height: Scalars['Int']['output']
  width: Scalars['Int']['output']
}

/** Interface for common image fields that all image types must implement. */
export type ImageInterface = {
  companyId?: Maybe<Scalars['ID']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  fileId: Scalars['ID']['output']
  fileSize?: Maybe<Scalars['Int']['output']>
  height?: Maybe<Scalars['Int']['output']>
  history?: Maybe<Array<Maybe<EditHistoryEntry>>>
  id: Scalars['ID']['output']
  originalImageUrl?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  url?: Maybe<Scalars['String']['output']>
  width?: Maybe<Scalars['Int']['output']>
}

export enum ImageSource {
  Ai = 'AI',
  Material = 'MATERIAL',
  Stock = 'STOCK',
  User = 'USER',
}

export type ImageSourceFilter = {
  __typename?: 'ImageSourceFilter'
  count: Scalars['Int']['output']
  source?: Maybe<ImageSources>
}

export enum ImageSources {
  Ai = 'AI',
  Material = 'MATERIAL',
  Stock = 'STOCK',
  User = 'USER',
}

/** The type of an image, indicating its source collection. */
export enum ImageType {
  Ai = 'AI',
  Material = 'MATERIAL',
  Stock = 'STOCK',
  User = 'USER',
  Logo = 'logo',
  LpValuationHero = 'lpValuationHero',
  Office = 'office',
  Region = 'region',
  Team = 'team',
}

export type ImageWithType = {
  image: SingleFileUpdateInput
  type: ImageType
}

export type ImportFormInput = {
  formId: Scalars['String']['input']
  landingpageTemplateId: Scalars['String']['input']
}

export type ImportPersonalDataAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  houseNumber?: InputMaybe<Scalars['String']['input']>
  street?: InputMaybe<Scalars['String']['input']>
  zip?: InputMaybe<Scalars['String']['input']>
}

export type ImportPersonalDataInput = {
  address?: InputMaybe<ImportPersonalDataAddressInput>
  email: Scalars['String']['input']
  firstname: Scalars['String']['input']
  lastname: Scalars['String']['input']
  phone?: InputMaybe<Scalars['String']['input']>
}

export type InstagramAccount = {
  __typename?: 'InstagramAccount'
  id?: Maybe<Scalars['ID']['output']>
  isActive?: Maybe<Scalars['Boolean']['output']>
  profile_picture_url?: Maybe<Scalars['String']['output']>
  username?: Maybe<Scalars['String']['output']>
}

export type Invitation = {
  __typename?: 'Invitation'
  companyId?: Maybe<Scalars['ID']['output']>
  failedCount?: Maybe<Scalars['Int']['output']>
  failedDeliveryError?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  recipientCount?: Maybe<Scalars['Int']['output']>
  targetLink?: Maybe<Scalars['String']['output']>
}

export enum InvitationBlockedReason {
  AlreadyInvited = 'ALREADY_INVITED',
  Conversion = 'CONVERSION',
  InvitationLimit = 'INVITATION_LIMIT',
  InvitationQuota = 'INVITATION_QUOTA',
  NoDataProcessingPermission = 'NO_DATA_PROCESSING_PERMISSION',
  NoFurtherContact = 'NO_FURTHER_CONTACT',
  Unsubscribed = 'UNSUBSCRIBED',
}

export type InvitationStatisitcsForCompany = {
  __typename?: 'InvitationStatisitcsForCompany'
  conversions: Scalars['Int']['output']
  invitationsPerLandingpage?: Maybe<Array<Maybe<InvitationsPerLandingpage>>>
  total: Scalars['Int']['output']
}

export type InvitationsPerLandingpage = {
  __typename?: 'InvitationsPerLandingpage'
  conversions: Scalars['Int']['output']
  landingpageName: Scalars['String']['output']
  landingpageSlug: Scalars['String']['output']
  total: Scalars['Int']['output']
}

export type InviteLeadsToLandingpageInput = {
  individualLink?: InputMaybe<Scalars['String']['input']>
  invitationBody?: InputMaybe<Scalars['String']['input']>
  invitationSubject?: InputMaybe<Scalars['String']['input']>
  invitedAt?: InputMaybe<Scalars['DateTime']['input']>
  isMasterView?: InputMaybe<Scalars['Boolean']['input']>
  landingpageSlug?: InputMaybe<Scalars['String']['input']>
  leadIds: Array<Scalars['ID']['input']>
  savedContentId?: InputMaybe<Scalars['ID']['input']>
  targetLink?: InputMaybe<Scalars['String']['input']>
}

export type IsStockPhotoLicensedInput = {
  provider: Scalars['String']['input']
  stockPhotoId: Scalars['String']['input']
}

export type KonstantineConnection = {
  __typename?: 'KonstantineConnection'
  apiKey: Scalars['String']['output']
  companyId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  status: KonstantineConnectionStatus
}

export enum KonstantineConnectionStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Pending = 'PENDING',
}

export type KonstantineDeactivateConnection = {
  __typename?: 'KonstantineDeactivateConnection'
  companyId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  status: KonstantineConnectionStatus
}

export type KonstantineFollowUpPreview = {
  __typename?: 'KonstantineFollowUpPreview'
  leadId: Scalars['ID']['output']
  potential?: Maybe<Scalars['Int']['output']>
  reasoning?: Maybe<Scalars['String']['output']>
  sentiment?: Maybe<Scalars['String']['output']>
  summary: Array<Scalars['String']['output']>
  when?: Maybe<Scalars['String']['output']>
}

export type KonstantineMetrics = {
  __typename?: 'KonstantineMetrics'
  totalCalls: Scalars['Int']['output']
  totalScheduledCalls: Scalars['Int']['output']
}

export type KonstantineMutation = {
  __typename?: 'KonstantineMutation'
  createConnection: KonstantineConnection
  deactivateConnection: KonstantineDeactivateConnection
}

export type KonstantineQuery = {
  __typename?: 'KonstantineQuery'
  getAnalysisMetrics: KonstantineMetrics
  getAnalysisUpcoming: Array<KonstantineFollowUpPreview>
  getConnection: KonstantineConnection
}

export type KonstantineQueryGetConnectionArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>
}

export type Landingpage = {
  __typename?: 'Landingpage'
  company?: Maybe<Company>
  conversionCount?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  customUrl?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['ID']['output']>
  materials?: Maybe<Array<Maybe<Material>>>
  name?: Maybe<Scalars['String']['output']>
  originalUrl?: Maybe<Scalars['String']['output']>
  slug?: Maybe<Scalars['String']['output']>
  status?: Maybe<LandingpageStatus>
  template?: Maybe<LandingpageTemplate>
  topicId?: Maybe<Scalars['ID']['output']>
  type?: Maybe<LandingpageType>
  url?: Maybe<Scalars['String']['output']>
}

export type LandingpageImpression = {
  __typename?: 'LandingpageImpression'
  id?: Maybe<Scalars['ID']['output']>
  trackingId?: Maybe<Scalars['ID']['output']>
}

export enum LandingpageStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}

export type LandingpageTemplate = {
  __typename?: 'LandingpageTemplate'
  countryCode?: Maybe<CountryCode>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id?: Maybe<Scalars['ID']['output']>
  /** @deprecated No longer supported */
  mailCampaignId?: Maybe<Scalars['ID']['output']>
  materialTemplates?: Maybe<Array<Maybe<MaterialTemplate>>>
  name?: Maybe<Scalars['String']['output']>
  slug?: Maybe<Scalars['String']['output']>
  type?: Maybe<LandingpageType>
}

export type LandingpageTemplatesForCompanyInput = {
  companyId: Scalars['ID']['input']
  onlyDefault?: InputMaybe<Scalars['Boolean']['input']>
}

export enum LandingpageType {
  Checklist = 'CHECKLIST',
  Guide = 'GUIDE',
  LifeAnnuity = 'LIFE_ANNUITY',
  PartialSale = 'PARTIAL_SALE',
  PlotValuation = 'PLOT_VALUATION',
  PropertyRequest = 'PROPERTY_REQUEST',
  PropertyTracker = 'PROPERTY_TRACKER',
  Quizzard = 'QUIZZARD',
  ReturnCall = 'RETURN_CALL',
  Valuation = 'VALUATION',
}

export type Lead = {
  __typename?: 'Lead'
  activities?: Maybe<Array<Maybe<LeadActivity>>>
  aiSummary?: Maybe<AiSummary>
  assignedUser?: Maybe<User>
  channels?: Maybe<Array<Maybe<LeadChannel>>>
  commentaries?: Maybe<Array<Maybe<Commentary>>>
  communicationNotAccepted?: Maybe<Scalars['Boolean']['output']>
  company?: Maybe<Company>
  confirmedAt?: Maybe<Scalars['DateTime']['output']>
  conversionCountByType?: Maybe<ConversionCountByType>
  conversions?: Maybe<Array<Maybe<Conversion>>>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  crmLink?: Maybe<Scalars['String']['output']>
  currentStatus?: Maybe<Scalars['String']['output']>
  dueDate?: Maybe<Scalars['DateTime']['output']>
  email?: Maybe<Scalars['String']['output']>
  exportedAt?: Maybe<Scalars['DateTime']['output']>
  firstname?: Maybe<Scalars['String']['output']>
  gender?: Maybe<Gender>
  hasConverted?: Maybe<Scalars['Boolean']['output']>
  id?: Maybe<Scalars['String']['output']>
  invitationBlockedReason?: Maybe<InvitationBlockedReason>
  isDataProcessingPermissionGranted?: Maybe<Scalars['Boolean']['output']>
  isExistingCustomer?: Maybe<Scalars['Boolean']['output']>
  lastConversionAt?: Maybe<Scalars['DateTime']['output']>
  lastname?: Maybe<Scalars['String']['output']>
  messages?: Maybe<Array<Maybe<Message>>>
  origin?: Maybe<LeadOrigin>
  /** @deprecated `formatted` is ignored. */
  phone?: Maybe<Scalars['String']['output']>
  phoneCommunicationAccepted?: Maybe<Scalars['Boolean']['output']>
  phones?: Maybe<Array<Maybe<Phone>>>
  position?: Maybe<Scalars['Int']['output']>
  /** @deprecated No longer supported */
  purchaseProperty?: Maybe<PurchaseProperty>
  statusHistory?: Maybe<Array<Maybe<StatusHistory>>>
  subscriptions?: Maybe<Array<Maybe<Subscription>>>
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  valuations?: Maybe<Array<Maybe<Valuation>>>
  yearOfBirth?: Maybe<Scalars['Int']['output']>
}

export type LeadInvitationBlockedReasonArgs = {
  landingpageSlug?: InputMaybe<Scalars['String']['input']>
}

export type LeadPhoneArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>
}

export type LeadActivity = {
  __typename?: 'LeadActivity'
  company?: Maybe<Company>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  details?: Maybe<LeadActivityDetails>
  id?: Maybe<Scalars['ID']['output']>
  initiator?: Maybe<LeadActivityInitiator>
  lead?: Maybe<Lead>
  type?: Maybe<LeadActivityType>
  user?: Maybe<User>
}

export type LeadActivityDetails = {
  __typename?: 'LeadActivityDetails'
  CONVERSION?: Maybe<LeadActivityDetailsConversion>
  KONSTANTINE?: Maybe<LeadActivityDetailsKonstantine>
  PRE_CONVERSION?: Maybe<LeadActivityDetailsPreConversion>
  campaigns?: Maybe<Array<Maybe<LeadActivityDetailsCampaign>>>
  changes?: Maybe<LeadChanges>
  /** @deprecated no values, use email.channelName */
  channelName?: Maybe<Scalars['String']['output']>
  email?: Maybe<LeadActivityDetailsEmail>
  /** @deprecated no values, use email.type */
  emailType?: Maybe<Scalars['String']['output']>
  invitationTopic?: Maybe<Scalars['String']['output']>
  valuationId?: Maybe<Scalars['String']['output']>
}

export type LeadActivityDetailsCampaign = {
  __typename?: 'LeadActivityDetailsCampaign'
  id?: Maybe<Scalars['ID']['output']>
  name?: Maybe<Scalars['String']['output']>
}

export type LeadActivityDetailsConversion = {
  __typename?: 'LeadActivityDetailsConversion'
  conversionId?: Maybe<Scalars['ID']['output']>
  conversionType?: Maybe<ConversionType>
}

export type LeadActivityDetailsEmail = {
  __typename?: 'LeadActivityDetailsEmail'
  actionId?: Maybe<Scalars['String']['output']>
  channelName?: Maybe<Scalars['String']['output']>
  messageId?: Maybe<Scalars['String']['output']>
  type?: Maybe<Scalars['String']['output']>
}

export type LeadActivityDetailsKonstantine = {
  __typename?: 'LeadActivityDetailsKonstantine'
  followUp?: Maybe<FollowUp>
  interactive?: Maybe<Scalars['Boolean']['output']>
  potential?: Maybe<Scalars['Int']['output']>
  sentiment?: Maybe<Scalars['String']['output']>
  summary?: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export type LeadActivityDetailsPreConversion = {
  __typename?: 'LeadActivityDetailsPreConversion'
  conversionId?: Maybe<Scalars['ID']['output']>
  preConversionId?: Maybe<Scalars['ID']['output']>
  preConversionType?: Maybe<PreConversionType>
}

export enum LeadActivityInitiator {
  BackofficeUser = 'BACKOFFICE_USER',
  Lead = 'LEAD',
  Makler = 'MAKLER',
  System = 'SYSTEM',
}

export enum LeadActivityType {
  ChannelPaused = 'CHANNEL_PAUSED',
  ChannelResubscribed = 'CHANNEL_RESUBSCRIBED',
  ChannelResumed = 'CHANNEL_RESUMED',
  ChannelSubscribed = 'CHANNEL_SUBSCRIBED',
  ChannelUnsubscribed = 'CHANNEL_UNSUBSCRIBED',
  Conversion = 'CONVERSION',
  CrmLeadDeleted = 'CRM_LEAD_DELETED',
  CrmLeadImported = 'CRM_LEAD_IMPORTED',
  EmailBounced = 'EMAIL_BOUNCED',
  EmailOpened = 'EMAIL_OPENED',
  EmailSent = 'EMAIL_SENT',
  EmailSpamComplaint = 'EMAIL_SPAM_COMPLAINT',
  Export = 'EXPORT',
  ExportToCrm = 'EXPORT_TO_CRM',
  FunnelUnsubscribed = 'FUNNEL_UNSUBSCRIBED',
  Invitation = 'INVITATION',
  InAppValuation = 'IN_APP_VALUATION',
  Konstantine = 'KONSTANTINE',
  LeadDataUpdated = 'LEAD_DATA_UPDATED',
  LeadImported = 'LEAD_IMPORTED',
  LeadPropertyTrackerInvited = 'LEAD_PROPERTY_TRACKER_INVITED',
  NewsletterInvitation = 'NEWSLETTER_INVITATION',
  PreConversion = 'PRE_CONVERSION',
}

export type LeadAddress = {
  __typename?: 'LeadAddress'
  city?: Maybe<Scalars['String']['output']>
  /** @deprecated use countryCode instead – this was used for download conversions with postalShipping */
  country?: Maybe<CountryCode>
  countryCode?: Maybe<CountryCode>
  houseNumber?: Maybe<Scalars['String']['output']>
  street?: Maybe<Scalars['String']['output']>
  zip?: Maybe<Scalars['String']['output']>
}

export type LeadAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<CountryCode>
  countryCode?: InputMaybe<CountryCode>
  houseNumber?: InputMaybe<Scalars['String']['input']>
  street?: InputMaybe<Scalars['String']['input']>
  zip?: InputMaybe<Scalars['String']['input']>
}

export type LeadAiSummaryInput = {
  leadId: Scalars['ID']['input']
}

export enum LeadChangeOrigin {
  Conversion = 'CONVERSION',
  Crm = 'CRM',
  Import = 'IMPORT',
  User = 'USER',
}

export type LeadChanges = {
  __typename?: 'LeadChanges'
  after?: Maybe<Lead>
  before?: Maybe<Lead>
  origin?: Maybe<LeadChangeOrigin>
}

export type LeadChannel = {
  __typename?: 'LeadChannel'
  channelId?: Maybe<Scalars['ID']['output']>
  name?: Maybe<Scalars['String']['output']>
  pausedAt?: Maybe<Scalars['DateTime']['output']>
  subscribedAt?: Maybe<Scalars['DateTime']['output']>
  unsubscribedAt?: Maybe<Scalars['DateTime']['output']>
}

export type LeadFeedActivity = {
  __typename?: 'LeadFeedActivity'
  company?: Maybe<Company>
  conversion?: Maybe<LeadFeedActivityConversion>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id?: Maybe<Scalars['ID']['output']>
  lead?: Maybe<LeadFeedActivityLead>
  type?: Maybe<LeadFeedActivityType>
}

export type LeadFeedActivityConversion = {
  __typename?: 'LeadFeedActivityConversion'
  email?: Maybe<Scalars['String']['output']>
  firstname?: Maybe<Scalars['String']['output']>
  lastname?: Maybe<Scalars['String']['output']>
  origin?: Maybe<Scalars['String']['output']>
  type?: Maybe<Scalars['String']['output']>
}

export type LeadFeedActivityLead = {
  __typename?: 'LeadFeedActivityLead'
  email?: Maybe<Scalars['String']['output']>
  firstname?: Maybe<Scalars['String']['output']>
  lastname?: Maybe<Scalars['String']['output']>
  origin?: Maybe<Scalars['String']['output']>
}

export enum LeadFeedActivityType {
  Conversion = 'CONVERSION',
  NewLead = 'NEW_LEAD',
}

export type LeadIds = {
  __typename?: 'LeadIds'
  leadIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>
}

export type LeadIdsInput = {
  companyId: Scalars['String']['input']
  filters?: InputMaybe<FilterInput>
  onlyAssignedToMe?: InputMaybe<Scalars['Boolean']['input']>
  search?: InputMaybe<Scalars['String']['input']>
}

export type LeadInteractivityWeek = {
  __typename?: 'LeadInteractivityWeek'
  hours?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  weekday?: Maybe<Scalars['Int']['output']>
}

export enum LeadOrigin {
  Conversion = 'CONVERSION',
  Crm = 'CRM',
  Import = 'IMPORT',
  User = 'USER',
}

export type LeadPersonalDataInput = {
  address?: InputMaybe<LeadAddressInput>
  email: Scalars['String']['input']
  firstname?: InputMaybe<Scalars['String']['input']>
  lastname?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
}

export type LeadSettings = {
  __typename?: 'LeadSettings'
  postalShipping?: Maybe<PostalShipping>
}

export enum LeadSortByType {
  AssignedUser = 'assignedUser',
  City = 'city',
  CreatedAt = 'createdAt',
  DueDate = 'dueDate',
  ExportedAt = 'exportedAt',
  LastConversionAt = 'lastConversionAt',
  UpdatedAt = 'updatedAt',
  Zip = 'zip',
}

export type LeadSummary = {
  __typename?: 'LeadSummary'
  generatedAt?: Maybe<Scalars['DateTime']['output']>
  summary?: Maybe<Scalars['String']['output']>
}

export type LeadsInput = {
  childCompanyId?: InputMaybe<Scalars['ID']['input']>
  companyId?: InputMaybe<Scalars['String']['input']>
  filters?: InputMaybe<FilterInput>
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>
  landingpageSlugFilter?: InputMaybe<Scalars['String']['input']>
  onlyAssignedToMe?: InputMaybe<Scalars['Boolean']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  search?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<LeadSortByType>
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>
  view?: InputMaybe<Scalars['String']['input']>
}

export type LeadsPipelineStatus = {
  __typename?: 'LeadsPipelineStatus'
  companyId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  position: Scalars['Int']['output']
}

export type LeadsPipelineStatuses = {
  __typename?: 'LeadsPipelineStatuses'
  newStatusId: Scalars['ID']['output']
  statuses: Array<Maybe<LeadsPipelineStatus>>
}

export type LeadsStatusesStatistics = {
  __typename?: 'LeadsStatusesStatistics'
  companyId?: Maybe<Scalars['String']['output']>
  companyName?: Maybe<Scalars['String']['output']>
  statuses?: Maybe<Array<Maybe<StatusesTotals>>>
}

export type LegalConsent = {
  __typename?: 'LegalConsent'
  acceptedAt: Scalars['DateTime']['output']
  acceptedByUserId: Scalars['String']['output']
  identifier: Scalars['String']['output']
  proofText: Scalars['String']['output']
}

export type LicenseAgreement = {
  __typename?: 'LicenseAgreement'
  acceptedAt?: Maybe<Scalars['DateTime']['output']>
  acceptedByUserId?: Maybe<Scalars['String']['output']>
}

export type LicenseStockPhotoInput = {
  provider: Scalars['String']['input']
  stockPhotoId: Scalars['String']['input']
}

export type LicensedStockPhoto = {
  __typename?: 'LicensedStockPhoto'
  isLicensed?: Maybe<Scalars['Boolean']['output']>
  license?: Maybe<Scalars['String']['output']>
  url?: Maybe<Scalars['String']['output']>
}

export type LifeAnnuity = {
  __typename?: 'LifeAnnuity'
  callbackTimeOfDay?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  payoutType?: Maybe<Scalars['String']['output']>
  property?: Maybe<LifeAnnuityProperty>
}

export type LifeAnnuityProperty = {
  __typename?: 'LifeAnnuityProperty'
  buildingYear: Scalars['Int']['output']
  garageAmount?: Maybe<Scalars['Int']['output']>
  livingArea: Scalars['Int']['output']
  postcode: Scalars['String']['output']
  selfOccupied: Scalars['Boolean']['output']
  type: Scalars['String']['output']
  value: Scalars['Int']['output']
}

export type LightCampaign = {
  __typename?: 'LightCampaign'
  materials: Array<LightCampaignMaterial>
  name: Scalars['String']['output']
}

export type LightCampaignFileInfo = {
  __typename?: 'LightCampaignFileInfo'
  cdnUrl: Scalars['String']['output']
}

export type LightCampaignMaterial = {
  __typename?: 'LightCampaignMaterial'
  displayName?: Maybe<Scalars['String']['output']>
  files: Array<LightCampaignMaterialFile>
  hasFile: Scalars['Boolean']['output']
}

export type LightCampaignMaterialFile = {
  __typename?: 'LightCampaignMaterialFile'
  file: LightCampaignFileInfo
  previewFile: LightCampaignFileInfo
}

export type LinkedinOrganization = {
  __typename?: 'LinkedinOrganization'
  isActive?: Maybe<Scalars['Boolean']['output']>
  name?: Maybe<Scalars['String']['output']>
  urn?: Maybe<Scalars['String']['output']>
}

export type Links = {
  __typename?: 'Links'
  about?: Maybe<Scalars['String']['output']>
  imprint?: Maybe<Scalars['String']['output']>
  privacy?: Maybe<Scalars['String']['output']>
  website?: Maybe<Scalars['String']['output']>
}

export enum LivingSituation {
  Owner = 'OWNER',
  Rent = 'RENT',
  RentFree = 'RENT_FREE',
}

export type Location = {
  __typename?: 'Location'
  coordinates: PropertyCoordinates
  description: Scalars['String']['output']
  radius: Scalars['Int']['output']
}

export type LpLinkList = {
  __typename?: 'LpLinkList'
  landingpageSlug?: Maybe<Scalars['String']['output']>
  text?: Maybe<Scalars['String']['output']>
  trackingParams?: Maybe<Scalars['String']['output']>
}

export enum MailProvider {
  Hoppermation = 'HOPPERMATION',
  MailService = 'MAIL_SERVICE',
}

export type MarketingPlan = {
  __typename?: 'MarketingPlan'
  id: Scalars['ID']['output']
  locale?: Maybe<Scalars['String']['output']>
  market: Scalars['String']['output']
  planType: MarketingPlanType
  /** Number of posts in the plan. */
  postCount: Scalars['Int']['output']
  presetLayoutId: Scalars['String']['output']
  referenceTimezone: Scalars['String']['output']
  /** Set when schedule generation failed. Null while slots are still being written. */
  scheduleError?: Maybe<Scalars['String']['output']>
  slots: Array<MarketingPlanSlot>
  startDate: Scalars['DateTime']['output']
  status: MarketingPlanStatus
  /** Distinct topic names on this plan. Several names are joined when the slots do not share one topic. */
  topicName?: Maybe<Scalars['String']['output']>
}

export type MarketingPlanScheduledLocal = {
  __typename?: 'MarketingPlanScheduledLocal'
  /** Wall-clock date in the plan's referenceTimezone, 'YYYY-MM-DD' */
  date: Scalars['String']['output']
  /** Wall-clock time in the plan's referenceTimezone, 'HH:mm' */
  time: Scalars['String']['output']
}

export type MarketingPlanSlot = {
  __typename?: 'MarketingPlanSlot'
  generatedText?: Maybe<Scalars['String']['output']>
  generationError?: Maybe<Scalars['String']['output']>
  hint?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  /** Null on outline drafts, before an image request exists. */
  imageStatus?: Maybe<MarketingPlanSlotImageStatus>
  /** Preview image generated on demand before approval. */
  imageUrl?: Maybe<Scalars['String']['output']>
  platform: SocialMediaType
  savedContentId?: Maybe<Scalars['ID']['output']>
  scheduledLocal: MarketingPlanScheduledLocal
  status: MarketingPlanSlotStatus
  textChoices?: Maybe<Array<Scalars['String']['output']>>
  textStatus: MarketingPlanSlotTextStatus
  /** Post title from the genaisis schedule. Empty on slots added by hand. */
  title?: Maybe<Scalars['String']['output']>
  topicId: Scalars['ID']['output']
  topicName?: Maybe<Scalars['String']['output']>
}

export enum MarketingPlanSlotImageStatus {
  Failed = 'FAILED',
  /** Image request is in flight. Approval stays hidden. */
  Pending = 'PENDING',
  Ready = 'READY',
  TimedOut = 'TIMED_OUT',
}

export enum MarketingPlanSlotStatus {
  Approved = 'APPROVED',
  Discarded = 'DISCARDED',
  Pending = 'PENDING',
}

export enum MarketingPlanSlotTextStatus {
  /** Schedule only. Text and image generation start after the outline is accepted. */
  Draft = 'DRAFT',
  Failed = 'FAILED',
  Generating = 'GENERATING',
  Ready = 'READY',
}

export enum MarketingPlanStatus {
  Archived = 'ARCHIVED',
  Proposed = 'PROPOSED',
  Superseded = 'SUPERSEDED',
}

/** How a plan is grouped in the manage-plans list. */
export enum MarketingPlanType {
  /** At least one post is approved, and nothing is still generating. */
  Approved = 'APPROVED',
  /** Text or images are still being created. */
  Executing = 'EXECUTING',
  /** Outline or generated plan that has not been approved. */
  Planned = 'PLANNED',
}

export enum MarketplaceIntegration {
  App = 'APP',
  Synchronisation = 'SYNCHRONISATION',
}

export type MasterCrmCompanyConfigInput = {
  acceptedMasterConnection?: InputMaybe<Scalars['Boolean']['input']>
  childCompanyId?: InputMaybe<Scalars['ID']['input']>
  enforceMasterConnection?: InputMaybe<Scalars['Boolean']['input']>
  isMasterView?: InputMaybe<Scalars['Boolean']['input']>
}

export type Material = ImageInterface & {
  __typename?: 'Material'
  assetType?: Maybe<AssetType>
  campaignId?: Maybe<Scalars['ID']['output']>
  companyId?: Maybe<Scalars['ID']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  displayName?: Maybe<Scalars['String']['output']>
  file?: Maybe<File>
  fileId: Scalars['ID']['output']
  fileSize?: Maybe<Scalars['Int']['output']>
  files?: Maybe<Array<Maybe<MaterialFiles>>>
  filesCount?: Maybe<Scalars['Int']['output']>
  hasFile?: Maybe<Scalars['Boolean']['output']>
  height?: Maybe<Scalars['Int']['output']>
  history?: Maybe<Array<Maybe<EditHistoryEntry>>>
  id: Scalars['ID']['output']
  landingpageId?: Maybe<Scalars['ID']['output']>
  /** Set membership. Present only on a Material Maker social image variant. */
  materialMakerSetId?: Maybe<Scalars['String']['output']>
  materialMakerSetStatus?: Maybe<MaterialMakerSetStatus>
  materialMakerVariantIndex?: Maybe<Scalars['Int']['output']>
  mode?: Maybe<MaterialMode>
  originalImageUrl?: Maybe<Scalars['String']['output']>
  prettyFileName?: Maybe<Scalars['String']['output']>
  previewFile?: Maybe<File>
  publishedVersion?: Maybe<Scalars['Int']['output']>
  purpose?: Maybe<MaterialPurpose>
  status?: Maybe<MaterialStatus>
  topicId?: Maybe<Scalars['ID']['output']>
  type?: Maybe<MaterialType>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  url?: Maybe<Scalars['String']['output']>
  version?: Maybe<Scalars['Int']['output']>
  versions: Array<MaterialVersion>
  width?: Maybe<Scalars['Int']['output']>
}

export type MaterialBrandEasyConfig = {
  __typename?: 'MaterialBrandEasyConfig'
  bleed?: Maybe<Scalars['String']['output']>
  target?: Maybe<Scalars['String']['output']>
  template?: Maybe<Scalars['String']['output']>
}

export type MaterialBrandEasyConfigInput = {
  bleed?: InputMaybe<Scalars['String']['input']>
  target: Scalars['String']['input']
  template: Scalars['String']['input']
}

/**
 * The exact version/checksum pairs an operator reviewed for initial publication.
 *
 * The checksum is deliberate: a version number on its own can be reused after a
 * render retry, while the checksum pins this approval to the reviewed bytes.
 */
export type MaterialBundleApprovalCandidateInput = {
  checksumSha256: Scalars['String']['input']
  materialId: Scalars['ID']['input']
  versionNumber: Scalars['Int']['input']
}

export type MaterialCreatifyConfig = {
  __typename?: 'MaterialCreatifyConfig'
  templateId?: Maybe<Scalars['String']['output']>
  variants?: Maybe<Array<Maybe<CreatifyTemplateVariants>>>
}

export type MaterialDocumentConfig = {
  __typename?: 'MaterialDocumentConfig'
  file?: Maybe<File>
  variants?: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export type MaterialFiles = {
  __typename?: 'MaterialFiles'
  file?: Maybe<File>
  previewFile?: Maybe<File>
}

export type MaterialGenerationProgress = {
  __typename?: 'MaterialGenerationProgress'
  CANCELLED: Scalars['Int']['output']
  COMPLETED: Scalars['Int']['output']
  CREATED: Scalars['Int']['output']
  FAILED: Scalars['Int']['output']
  RUNNING: Scalars['Int']['output']
}

export enum MaterialMakerBundleStatus {
  Failed = 'FAILED',
  Ineligible = 'INELIGIBLE',
  Provisioned = 'PROVISIONED',
  Requested = 'REQUESTED',
}

export type MaterialMakerConfig = {
  __typename?: 'MaterialMakerConfig'
  recipeId?: Maybe<Scalars['ID']['output']>
  recipeRevisionId?: Maybe<Scalars['ID']['output']>
}

export type MaterialMakerConfigInput = {
  recipeId: Scalars['ID']['input']
  recipeRevisionId: Scalars['ID']['input']
}

export type MaterialMakerGenerationRecipe = {
  __typename?: 'MaterialMakerGenerationRecipe'
  approvedRevisionId?: Maybe<Scalars['ID']['output']>
  id: Scalars['ID']['output']
  locale: Scalars['String']['output']
  materialType: Scalars['String']['output']
  status: Scalars['String']['output']
  title: Scalars['String']['output']
}

export enum MaterialMakerSetStatus {
  Blocked = 'BLOCKED',
  Failed = 'FAILED',
  Generating = 'GENERATING',
  Pending = 'PENDING',
  Published = 'PUBLISHED',
  Ready = 'READY',
}

export enum MaterialMode {
  Generated = 'GENERATED',
  Manual = 'MANUAL',
  Static = 'STATIC',
}

export type MaterialPreview = {
  __typename?: 'MaterialPreview'
  file?: Maybe<Scalars['String']['output']>
  landingpageSlug?: Maybe<Scalars['String']['output']>
  preview?: Maybe<Scalars['String']['output']>
}

export enum MaterialPurpose {
  Print = 'PRINT',
  Screen = 'SCREEN',
}

export type MaterialS3VideoConfig = {
  __typename?: 'MaterialS3VideoConfig'
  directory?: Maybe<Scalars['String']['output']>
}

/**
 * One social image set, as the internal admin surface needs to see it.
 *
 * The five images are five separate materials, so the state that decides whether
 * they may go public is reported at set level only.
 */
export type MaterialSet = {
  __typename?: 'MaterialSet'
  attemptCount: Scalars['Int']['output']
  companyId: Scalars['ID']['output']
  /** False when Material Maker did not answer; the variants below are still correct. */
  diagnosticsAvailable: Scalars['Boolean']['output']
  /** Material Maker's own judgement. Null when it did not answer. */
  evaluationState?: Maybe<MaterialMakerSetStatus>
  failedVariantIndexes: Array<Scalars['Int']['output']>
  failureReason?: Maybe<Scalars['String']['output']>
  lastAttemptAt?: Maybe<Scalars['DateTime']['output']>
  lastFailureCode?: Maybe<Scalars['String']['output']>
  lastFailureMessage?: Maybe<Scalars['String']['output']>
  materialSetId: Scalars['String']['output']
  /** Company fields that must be filled before generation can run. */
  missingFields: Array<Scalars['String']['output']>
  publishable: Scalars['Boolean']['output']
  status?: Maybe<MaterialMakerSetStatus>
  variants: Array<MaterialSetVariant>
}

export type MaterialSetRetryResult = {
  __typename?: 'MaterialSetRetryResult'
  materialSetId: Scalars['String']['output']
  queuedCount: Scalars['Int']['output']
}

export type MaterialSetVariant = {
  __typename?: 'MaterialSetVariant'
  blockedReasons: Array<Scalars['String']['output']>
  displayName?: Maybe<Scalars['String']['output']>
  materialId: Scalars['ID']['output']
  publishedVersion?: Maybe<Scalars['Int']['output']>
  quality?: Maybe<MaterialVersionQuality>
  status?: Maybe<MaterialStatus>
  /** Stable position 1 to 5. */
  variantIndex?: Maybe<Scalars['Int']['output']>
}

export enum MaterialStatus {
  Generating = 'GENERATING',
  GenerationFailed = 'GENERATION_FAILED',
  Pending = 'PENDING',
  Queued = 'QUEUED',
  Ready = 'READY',
}

export type MaterialTemplate = {
  __typename?: 'MaterialTemplate'
  brandEasyConfig?: Maybe<MaterialBrandEasyConfig>
  creatifyConfig?: Maybe<MaterialCreatifyConfig>
  displayName?: Maybe<Scalars['String']['output']>
  generationService?: Maybe<GenerationService>
  id?: Maybe<Scalars['ID']['output']>
  materialMakerConfig?: Maybe<MaterialMakerConfig>
  prettyFileName?: Maybe<Scalars['String']['output']>
  purpose?: Maybe<MaterialPurpose>
  s3VideoConfig?: Maybe<MaterialS3VideoConfig>
  staticConfig?: Maybe<MaterialDocumentConfig>
  type?: Maybe<MaterialType>
}

/** Identifier for the live diagnostic authority; it does not duplicate its status. */
export type MaterialTraceDiagnostic = {
  __typename?: 'MaterialTraceDiagnostic'
  authority: Scalars['String']['output']
  materialMakerMaterialId?: Maybe<Scalars['String']['output']>
  materialMakerVersionNumber?: Maybe<Scalars['Int']['output']>
}

/** One append-only event; source copy and customer contact data are never included. */
export type MaterialTraceEvent = {
  __typename?: 'MaterialTraceEvent'
  actorId?: Maybe<Scalars['ID']['output']>
  bottimmoVersionNumber?: Maybe<Scalars['Int']['output']>
  bundleApprovalId?: Maybe<Scalars['String']['output']>
  checksumSha256?: Maybe<Scalars['String']['output']>
  companyId: Scalars['ID']['output']
  diagnostic?: Maybe<MaterialTraceDiagnostic>
  eventType: MaterialTraceEventType
  failureCode?: Maybe<Scalars['String']['output']>
  generationJobId?: Maybe<Scalars['ID']['output']>
  id: Scalars['ID']['output']
  landingpageId?: Maybe<Scalars['ID']['output']>
  materialId: Scalars['ID']['output']
  materialMakerMaterialId?: Maybe<Scalars['String']['output']>
  materialMakerVersionNumber?: Maybe<Scalars['Int']['output']>
  occurredAt: Scalars['DateTime']['output']
  quality?: Maybe<MaterialVersionQuality>
  recipeId?: Maybe<Scalars['String']['output']>
  recipeRevisionId?: Maybe<Scalars['String']['output']>
  requestId?: Maybe<Scalars['String']['output']>
  topicSlug?: Maybe<Scalars['String']['output']>
}

export enum MaterialTraceEventType {
  DraftSubmitted = 'DRAFT_SUBMITTED',
  GenerationCompleted = 'GENERATION_COMPLETED',
  GenerationFailed = 'GENERATION_FAILED',
  GenerationRequested = 'GENERATION_REQUESTED',
  GenerationRetried = 'GENERATION_RETRIED',
  TargetedRefreshRequested = 'TARGETED_REFRESH_REQUESTED',
  VersionApproved = 'VERSION_APPROVED',
  VersionPublished = 'VERSION_PUBLISHED',
  VersionUnpublished = 'VERSION_UNPUBLISHED',
}

export enum MaterialType {
  BasicAd = 'BASIC_AD',
  Campaign = 'CAMPAIGN',
  Download = 'DOWNLOAD',
}

export type MaterialVersion = {
  __typename?: 'MaterialVersion'
  approvedAt?: Maybe<Scalars['DateTime']['output']>
  approvedBy?: Maybe<Scalars['ID']['output']>
  file?: Maybe<File>
  quality?: Maybe<MaterialVersionQuality>
  state: MaterialVersionState
  versionNumber: Scalars['Int']['output']
}

export type MaterialVersionQuality = {
  __typename?: 'MaterialVersionQuality'
  errorCount: Scalars['Int']['output']
  passed: Scalars['Boolean']['output']
  warningCount: Scalars['Int']['output']
}

export enum MaterialVersionState {
  Approved = 'APPROVED',
  PendingReview = 'PENDING_REVIEW',
}

export type MaterialVideoConfigInput = {
  templateId: Scalars['String']['input']
  variants?: InputMaybe<Array<CreatifyTemplateVariantsInput>>
}

export type MaterialsFilteredInput = {
  campaignIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  companyId?: InputMaybe<Scalars['ID']['input']>
  landingpageIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  mode?: InputMaybe<MaterialMode>
  purpose?: InputMaybe<MaterialPurpose>
  status?: InputMaybe<MaterialStatus>
  types?: InputMaybe<Array<InputMaybe<MaterialType>>>
}

export type MaterialsForContentCreatorInput = {
  landingpageId?: InputMaybe<Scalars['ID']['input']>
}

export type Message = {
  __typename?: 'Message'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id?: Maybe<Scalars['String']['output']>
  step?: Maybe<CampaignStep>
}

export type Meta = {
  __typename?: 'Meta'
  businessDescription?: Maybe<Scalars['String']['output']>
  hasWebsiteCrawledSuccessfully?: Maybe<Scalars['Boolean']['output']>
  industry?: Maybe<Scalars['String']['output']>
  markAiGeneratedContent?: Maybe<Scalars['Boolean']['output']>
  markAiGeneratedImageContent?: Maybe<Scalars['Boolean']['output']>
  markAiGeneratedTextContent?: Maybe<Scalars['Boolean']['output']>
}

export type MoveLeadToCompanyInput = {
  leadIds: Array<Scalars['ID']['input']>
  targetCompanyId: Scalars['ID']['input']
}

export type Mutation = {
  __typename?: 'Mutation'
  acceptLegalConsents: Array<LegalConsent>
  /** Accept the outline and start text and image generation for every draft slot. */
  acceptMarketingPlanOutline?: Maybe<MarketingPlan>
  acknowledgeDefaultSenderVerification?: Maybe<HoppermationSender>
  activateAilanderLandingpages?: Maybe<Array<Maybe<CmsOrganization>>>
  activateAuthorization?: Maybe<Scalars['Void']['output']>
  activatePropstackChildSync?: Maybe<Scalars['Boolean']['output']>
  activateUser?: Maybe<Scalars['Boolean']['output']>
  addCommentary?: Maybe<Scalars['Boolean']['output']>
  addCompanyImage?: Maybe<File>
  addDocumentToContract?: Maybe<Contract>
  addDocumentToOnboarding?: Maybe<File>
  addFacebookPageToUser?: Maybe<Scalars['Void']['output']>
  addFreeSignUpTokens?: Maybe<Scalars['Void']['output']>
  addLeadsPipelineStatus?: Maybe<LeadsPipelineStatuses>
  addLinkedinOrganizationToUser?: Maybe<Scalars['Void']['output']>
  /** Add an outline slot before content generation. */
  addMarketingPlanSlot?: Maybe<MarketingPlanSlot>
  addProductsToContract?: Maybe<Contract>
  addVouchers?: Maybe<Array<Maybe<Voucher>>>
  approveAndPublishMaterialBundle: TopicMaterialBundleApproval
  approveMarketingPlanSlots: Array<SlotOperationResult>
  approveMaterialSet: Array<Material>
  approveMaterialVersion?: Maybe<Material>
  archiveTopic?: Maybe<Topic>
  assignLeads?: Maybe<Scalars['Void']['output']>
  assignOnboardingBillingOrderId?: Maybe<OnboardingStepResult>
  assignUserToLead?: Maybe<Scalars['Boolean']['output']>
  assignValuationToLead?: Maybe<Valuation>
  /**
   * Send a chat message to the AI assistant.
   * Proxies to the Genaisis onboarding session API and returns the assistant reply
   * as an AssistantResponse (text or tool_call shape).
   * Session is auto-created if it does not exist yet.
   */
  assistantChat?: Maybe<AssistantResponse>
  /**
   * Apply a structured tool action without the LLM (POST .../tool).
   * Body mirrors Genaisis: tool name plus optional data object.
   */
  assistantOnboardingApplyTool?: Maybe<Scalars['JSON']['output']>
  /**
   * Create onboarding session for the current company. session_id is the company ID.
   * Upstream returns 409 if a session already exists for this company.
   */
  assistantOnboardingCreateSession?: Maybe<Scalars['JSON']['output']>
  /** Send one user chat message; returns updated session payload (POST .../message). */
  assistantOnboardingSendMessage?: Maybe<Scalars['JSON']['output']>
  autoMapPropstackUsersToBrokers?: Maybe<Scalars['Boolean']['output']>
  bookAuthorization?: Maybe<Scalars['Void']['output']>
  bookCampaign?: Maybe<Scalars['Boolean']['output']>
  bookLandingpage?: Maybe<Scalars['Boolean']['output']>
  /**
   * Bootstrap the onboarding assistant for the current company.
   * Creates the Genaisis session (with company name + website URL) if needed
   * and returns the Makler enter-data welcome message. CRM/social connection
   * cards are collected later in the Makler enter-data flow (not auto-skipped).
   */
  bootstrapAssistantOnboardingChat?: Maybe<Scalars['String']['output']>
  cancelCampaignJobs?: Maybe<Scalars['String']['output']>
  cancelDowngrade?: Maybe<Scalars['Void']['output']>
  cancelProduct?: Maybe<Contract>
  changeContract?: Maybe<Scalars['Void']['output']>
  changePlan?: Maybe<Order>
  checkDefaultSenderVerification?: Maybe<HoppermationSender>
  checkSenderVerification?: Maybe<HoppermationSender>
  /**
   * Clear the assistant conversation for a given thread.
   * threadKey is accepted for API compatibility but ignored server-side.
   * Returns true on success.
   */
  clearAssistantConversation?: Maybe<Scalars['Boolean']['output']>
  clearFeatureCache?: Maybe<Scalars['Void']['output']>
  completeGoogleCalendarOAuth: CalendarSyncSettings
  completeOnboardingStepBilling?: Maybe<OnboardingStepResult>
  completeOnboardingStepCRMConfig?: Maybe<OnboardingStepResult>
  completeOnboardingStepWebsite?: Maybe<OnboardingStepResult>
  completeToDo?: Maybe<Scalars['Void']['output']>
  /** Confirm an edited image was uploaded via presigned URL and update the database record. */
  confirmImageEdit: ImageInterface
  /** Confirm a material was uploaded via presigned URL and register it in the database. */
  confirmMaterialUpload: UserUploadedMaterial
  /** Confirm multiple materials were uploaded via presigned URLs and register them in the database. */
  confirmMultipleMaterialUploads: UploadMultipleAdMaterialsResponse
  /** Confirm a user image was uploaded via presigned URL and register it in the database. */
  confirmUserImageUpload: UserImage
  connectGoogleBusiness?: Maybe<GoogleBusinessConnectResult>
  connectOnofficeUser?: Maybe<Scalars['Void']['output']>
  connectSocialMedia?: Maybe<Scalars['Void']['output']>
  connectToEmpro?: Maybe<EmproAuthPayload>
  connectToOnofficeMarketplace?: Maybe<Scalars['Void']['output']>
  createAdMaterialTopic?: Maybe<CreateAdMaterialTopicResponse>
  createAnamnesisFromWebsite?: Maybe<Company>
  createBrandEasyMaterialTemplate?: Maybe<MaterialTemplate>
  createBrandEasyMaterialTemplateForCampaign?: Maybe<MaterialTemplate>
  createCampaign?: Maybe<Campaign>
  createChildCompany?: Maybe<CreatedCompany>
  createCompany?: Maybe<CreatedCompany>
  createCompanyAnamnesis?: Maybe<RegistrationStepResult>
  createCompanyBilling?: Maybe<RegistrationStepResult>
  createCompanySiteBuild?: Maybe<Scalars['Boolean']['output']>
  createContract?: Maybe<Contract>
  createEmailChangeRequest?: Maybe<Scalars['String']['output']>
  createFeedbackTicket?: Maybe<Scalars['Boolean']['output']>
  createHoppermationSender?: Maybe<HoppermationSender>
  createLandingpageTemplates?: Maybe<Array<Maybe<LandingpageTemplate>>>
  createLandingpages?: Maybe<Array<Maybe<Landingpage>>>
  createLeadByUser?: Maybe<Lead>
  createMaterialMakerTemplate?: Maybe<MaterialTemplate>
  createMaterialsForCampaignAndCompanies?: Maybe<Scalars['Void']['output']>
  createMaterialsForMaterialTemplate?: Maybe<Scalars['Void']['output']>
  createOrUpdateCancelation?: Maybe<Scalars['Void']['output']>
  createOrUpdateCmsOrganizationPages?: Maybe<CmsPageUpdate>
  createOrUpdateCmsOrganizations?: Maybe<Array<Maybe<CmsOrganization>>>
  createOrUpdateCrmCompanyConfig?: Maybe<CrmCompanyConfig>
  createOrder?: Maybe<Scalars['Void']['output']>
  createProductTemplate?: Maybe<ProductTemplate>
  /** @deprecated No longer supported */
  createPropertyTrackerConversion?: Maybe<Conversion>
  createS3VideoMaterialTemplateForCampaign?: Maybe<MaterialTemplate>
  createStaticMaterialTemplateForCampaign?: Maybe<MaterialTemplate>
  createSubCompany?: Maybe<CreatedCompany>
  createToDoTemplate?: Maybe<ToDoTemplate>
  createTopic?: Maybe<Topic>
  createUser?: Maybe<User>
  createUserUploadedMaterial?: Maybe<UserUploadedMaterial>
  createValuationByAgent?: Maybe<Valuation>
  createVideoMaterialTemplate?: Maybe<MaterialTemplate>
  createVideoMaterialTemplateForCampaign?: Maybe<MaterialTemplate>
  deactivateAilanderLandingpages?: Maybe<Array<Maybe<CmsOrganization>>>
  deactivateAllLandingpagesWithSlug?: Maybe<Scalars['Boolean']['output']>
  deactivateUser?: Maybe<Scalars['Boolean']['output']>
  deleteAiGeneratedMaterial?: Maybe<DeleteAiGeneratedMaterialResponse>
  deleteCampaign?: Maybe<Scalars['Boolean']['output']>
  deleteCmsOrganizationAndPages?: Maybe<Scalars['Void']['output']>
  deleteCommentary?: Maybe<Scalars['Boolean']['output']>
  deleteCompany?: Maybe<Scalars['Void']['output']>
  deleteCompanyImage?: Maybe<Scalars['Boolean']['output']>
  deleteCompanyWithDelay?: Maybe<Scalars['Void']['output']>
  deleteContract?: Maybe<Scalars['ID']['output']>
  deleteDocumentOnContract?: Maybe<Contract>
  deleteDueDate?: Maybe<Lead>
  deleteEmproCompany?: Maybe<EmproDelete>
  deleteHoppermationSender?: Maybe<Scalars['Void']['output']>
  deleteInviteLeadToLandingpage?: Maybe<Scalars['ID']['output']>
  deleteLandingpage?: Maybe<Scalars['Boolean']['output']>
  deleteLead?: Maybe<Scalars['Boolean']['output']>
  deleteLeads?: Maybe<Scalars['Boolean']['output']>
  deleteLeadsPipelineStatus?: Maybe<LeadsPipelineStatus>
  deleteMarketingPlan?: Maybe<Scalars['Void']['output']>
  deleteMarketingPlanSlots: Array<SlotOperationResult>
  deleteMaterialTemplateForCampaign?: Maybe<MaterialTemplate>
  deleteMaterialTemplateWithRelatedMaterials?: Maybe<DeleteMaterialTemplateWithRelatedMaterialsResult>
  deleteProduct?: Maybe<Contract>
  deleteSavedContent?: Maybe<Scalars['Void']['output']>
  deleteSavedContentBatch?: Maybe<Scalars['Void']['output']>
  deleteSavedContentForNewsletter?: Maybe<Scalars['Void']['output']>
  deleteSocialMediaConnection?: Maybe<Scalars['Void']['output']>
  deleteSocialMediaPosts?: Maybe<Scalars['Void']['output']>
  deleteUser?: Maybe<Scalars['Boolean']['output']>
  deleteUserEmailSuppression?: Maybe<Scalars['Boolean']['output']>
  deleteUserUploadedMaterial?: Maybe<DeleteUserUploadedMaterialResponse>
  deleteValuation?: Maybe<Valuation>
  disconnectGoogleCalendar: CalendarSyncSettings
  downgradeCompanyManuallyToBasic?: Maybe<Scalars['Void']['output']>
  downgradeCompanyManuallyToLight?: Maybe<Scalars['Void']['output']>
  downgradeToBasic?: Maybe<Scalars['Void']['output']>
  downgradeToBeginner?: Maybe<Scalars['Void']['output']>
  downgradeToFreeLight?: Maybe<Scalars['Void']['output']>
  downgradeToLight?: Maybe<Scalars['Void']['output']>
  /**
   * Enhances/edits an email by applying AI-powered improvements based on an edited plaintext version.
   * Returns the improved email (MJML or plaintext format).
   */
  editEmail: Scalars['String']['output']
  /**
   * Replaces an existing image with a new, edited version provided as a file upload.
   * Returns the entire updated image object.
   */
  editImage: ImageInterface
  enqueuePdfGeneration?: Maybe<Scalars['String']['output']>
  exportCompaniesToCRM?: Maybe<Scalars['Boolean']['output']>
  exportCompanyUsersToCRM?: Maybe<Scalars['Boolean']['output']>
  exportLeadToCrm?: Maybe<Scalars['Boolean']['output']>
  exportUserToCRM?: Maybe<Scalars['Boolean']['output']>
  generateCampaign?: Maybe<Array<Maybe<Material>>>
  generateImage?: Maybe<GeneratedImage>
  generateInitialTopics?: Maybe<Array<Maybe<Topic>>>
  generateMarketingPlan?: Maybe<GenerateMarketingPlanResult>
  generateMaterial?: Maybe<Material>
  generateMaterialZipForAllCompanies?: Maybe<Scalars['Boolean']['output']>
  generateMaterialZipForCompany?: Maybe<Scalars['Boolean']['output']>
  generateMaterials?: Maybe<Array<Maybe<Material>>>
  generateMaterialsForTemplate?: Maybe<Scalars['Int']['output']>
  generateMaterialsInBulk?: Maybe<Scalars['Int']['output']>
  /** Generate a preview image for one slot (reused at approval time). */
  generateSlotImage?: Maybe<MarketingPlanSlot>
  generateSocialTextFromFacebook?: Maybe<Scalars['String']['output']>
  generateText?: Maybe<GeneratedText>
  generateTopic?: Maybe<Topic>
  handleOnboardingBillingData?: Maybe<OnboardingStepResult>
  ignoreChangesForRegeneration?: Maybe<Scalars['Boolean']['output']>
  importCampaign?: Maybe<Campaign>
  importForm?: Maybe<Scalars['Void']['output']>
  inviteLeadsToLandingpage?: Maybe<Array<Maybe<Scalars['ID']['output']>>>
  konstantine: KonstantineMutation
  leadAiSummary?: Maybe<LeadSummary>
  licenseStockPhoto?: Maybe<LicensedStockPhoto>
  markSavedContentAsDownloaded?: Maybe<SavedContent>
  moveLeadsToCompany?: Maybe<Array<Maybe<Scalars['ID']['output']>>>
  pauseChannelForLead?: Maybe<Scalars['Void']['output']>
  postToSocialMedia?: Maybe<PostToSocialMediaResult>
  postToSocialMediaForCompanies?: Maybe<PostToSocialMediaMultiCompany>
  prepareGoogleCalendarOAuth: GoogleCalendarOAuthPreparePayload
  prepareStockImageForEdit: PrepareStockImageForEditPayload
  previewCustomerGuideDraft: CustomerGuideDraftPreview
  recreateSlotText?: Maybe<MarketingPlanSlot>
  registerUser?: Maybe<RegistrationStepResult>
  removeCompanyFromOnofficeSharedConfig?: Maybe<OnofficeSharedConfig>
  requestGuideRegeneration: CustomerGuide
  /** Request a presigned S3 URL for direct browser-to-S3 upload of an edited image. */
  requestImageEditUploadUrl: PresignedUploadData
  /** Request a presigned S3 URL for direct browser-to-S3 upload of a single material. */
  requestMaterialUploadUrl: PresignedUploadData
  /** Request presigned S3 URLs for direct browser-to-S3 upload of multiple materials. */
  requestMultipleMaterialUploadUrls: Array<PresignedUploadData>
  /** Request a presigned S3 URL for direct browser-to-S3 upload of a user image. */
  requestUserImageUploadUrl: PresignedUploadData
  resendHoppermationDefaultSenderValidation?: Maybe<Scalars['Void']['output']>
  resendHoppermationSenderValidation?: Maybe<Scalars['Void']['output']>
  resendPendingSubscriptions?: Maybe<Scalars['Void']['output']>
  resumeChannelForLead?: Maybe<Scalars['Void']['output']>
  retryMaterialSet: MaterialSetRetryResult
  revertGeneratedImage: GeneratedImage
  revertStockImage: StockImage
  revertUserImage: UserImage
  revokeCancellation?: Maybe<Scalars['Void']['output']>
  revokeCompanyDeletionWithDelay?: Maybe<Scalars['Void']['output']>
  revokeProductCancellation?: Maybe<Contract>
  saveCasaoneCredentials?: Maybe<CasaoneConfig>
  saveContent?: Maybe<SavedContent>
  saveCustomerGuideDraft: CustomerGuideDraftMutation
  saveEmproSelectedContactStatuses?: Maybe<EmproConfig>
  saveFlowfactCredentials?: Maybe<FlowfactConfig>
  saveFlowfactSelectedContactStatuses?: Maybe<FlowfactConfig>
  saveOnofficeSelectedContactTypes?: Maybe<OnofficeConfig>
  saveOnofficeSharedConfig?: Maybe<OnofficeSharedConfig>
  saveOnofficeSharedConfigCompany?: Maybe<OnofficeSharedConfig>
  savePropstackChildTeamAssignment?: Maybe<PropstackChildMultiCompanyConfig>
  savePropstackCredentials?: Maybe<PropstackConfig>
  savePropstackDefaultExportBroker?: Maybe<PropstackChildMultiCompanyConfig>
  savePropstackSelectedContactStatuses?: Maybe<PropstackConfig>
  savePropstackSelectedGroupIds?: Maybe<PropstackConfig>
  savePropstackUserBrokerMapping?: Maybe<Array<Maybe<PropstackUserBrokerEntry>>>
  sendInvitationPreview?: Maybe<Scalars['Void']['output']>
  /**
   * Sends a newsletter preview email to the current user.
   * Appends company email signature to the newsletter body.
   */
  sendNewsletterPreview: Scalars['Boolean']['output']
  sendNextEmailForLead?: Maybe<Scalars['Void']['output']>
  sendPasswordResetMail?: Maybe<Scalars['Boolean']['output']>
  sendResetOrVerificationMail?: Maybe<SendResetOrVerificationMailResponse>
  sendVerifyEmailMail?: Maybe<Scalars['Void']['output']>
  setAsDefaultSender?: Maybe<HoppermationSender>
  setCompanyFeature?: Maybe<Array<Maybe<Feature>>>
  setComponentFeature?: Maybe<Array<Maybe<Feature>>>
  setCountryFeature?: Maybe<Array<Maybe<Feature>>>
  setDueDate?: Maybe<Lead>
  setGoogleBusinessLocation?: Maybe<Scalars['Void']['output']>
  setPlatformFeature?: Maybe<Array<Maybe<Feature>>>
  setProductFeature?: Maybe<Array<Maybe<Feature>>>
  setRolePermissions?: Maybe<Role>
  setUserRole?: Maybe<User>
  signUpUser?: Maybe<SignUpUser>
  startFileImport?: Maybe<StartFileImportResult>
  startHoppermationActivation?: Maybe<HoppermationOrganization>
  startRegeneration?: Maybe<Scalars['Boolean']['output']>
  startToDo?: Maybe<Scalars['Void']['output']>
  stopAllCampaignsForLead?: Maybe<Scalars['Boolean']['output']>
  stopAllCommunicationsForLead?: Maybe<Scalars['Boolean']['output']>
  stopChannelForLead?: Maybe<Scalars['Void']['output']>
  submitCustomerGuideDraft: CustomerGuideDraftSubmission
  submitOnboarding?: Maybe<CompanyState>
  subscribeToCampaign?: Maybe<Scalars['Void']['output']>
  trackLandingpageImpression?: Maybe<LandingpageImpression>
  /** @deprecated No longer supported */
  triggerPropertyTrackerInvitations?: Maybe<Scalars['Boolean']['output']>
  unarchiveTopic?: Maybe<Topic>
  unassignUserFromLead?: Maybe<Scalars['Boolean']['output']>
  unpublishMaterialSet: Array<Material>
  unpublishMaterialVersion?: Maybe<Material>
  unsubscribeFromCampaign?: Maybe<Scalars['Void']['output']>
  updateAiSettings?: Maybe<AiSettings>
  updateAvv?: Maybe<Scalars['DateTime']['output']>
  updateBookedLandingpages?: Maybe<Company>
  updateCalendarSyncSettings: CalendarSyncSettings
  updateCampaign?: Maybe<Campaign>
  updateCampaignIsActive?: Maybe<Campaign>
  updateCompanyAddress?: Maybe<Scalars['Void']['output']>
  updateCompanyAmbassador?: Maybe<Ambassador>
  updateCompanyAmbassadorData?: Maybe<Scalars['Void']['output']>
  updateCompanyAmbassadorPortrait?: Maybe<Scalars['Void']['output']>
  updateCompanyAmbassadorSignatureCustomTemplateSignature?: Maybe<Scalars['Void']['output']>
  updateCompanyAmbassadorSignatureExtra?: Maybe<Scalars['Void']['output']>
  updateCompanyAmbassadorSignatureHTML?: Maybe<Scalars['Void']['output']>
  updateCompanyAmbassadorSignatureIncludeGoogleReview?: Maybe<Scalars['Void']['output']>
  updateCompanyAmbassadorSignatureIncludeProvenExpert?: Maybe<Scalars['Void']['output']>
  updateCompanyAmbassadorSignatureText?: Maybe<Scalars['Void']['output']>
  updateCompanyBilling?: Maybe<Company>
  updateCompanyCommission?: Maybe<Scalars['Void']['output']>
  updateCompanyContactPerson?: Maybe<CompanyContactPerson>
  updateCompanyCustomWording?: Maybe<Company>
  updateCompanyDetails?: Maybe<Company>
  updateCompanyImage?: Maybe<File>
  updateCompanyLinks?: Maybe<Scalars['Void']['output']>
  updateCompanyLocale?: Maybe<Scalars['Void']['output']>
  updateCompanyLogo?: Maybe<Scalars['Void']['output']>
  updateCompanyMailProvider?: Maybe<Scalars['Void']['output']>
  updateCompanyMetaData?: Maybe<Company>
  updateCompanyName?: Maybe<Scalars['Void']['output']>
  updateCompanyPerformanceData?: Maybe<Company>
  updateCompanyPhoneVerificationSettingsForValuation?: Maybe<Settings>
  updateCompanyRegion?: Maybe<Scalars['Void']['output']>
  updateCompanySite?: Maybe<Site>
  updateCompanySlogan?: Maybe<Scalars['Void']['output']>
  updateCompanySlug?: Maybe<Company>
  updateCompanySlugByCompany?: Maybe<Company>
  updateCompanyState?: Maybe<Company>
  updateCompanyTheme?: Maybe<Theme>
  updateCompanyVariant?: Maybe<Company>
  updateContactDetails?: Maybe<Scalars['Void']['output']>
  updateContractNote?: Maybe<Contract>
  updateCustomUrls?: Maybe<Array<Maybe<Landingpage>>>
  updateFbPixelAccessToken?: Maybe<Scalars['Boolean']['output']>
  updateGoogleReviewLink?: Maybe<Settings>
  updateGoogleReviewOnLandingpage?: Maybe<Settings>
  updateHoppermationSender?: Maybe<HoppermationSender>
  updateInAppValuationProvider?: Maybe<Scalars['Void']['output']>
  updateInviteLeadToLandingpage?: Maybe<Scalars['ID']['output']>
  updateIsPhoneOptionalSettings?: Maybe<Settings>
  updateLandingpageImpressionCookieConsent?: Maybe<LandingpageImpression>
  updateLandingpageStatus?: Maybe<Landingpage>
  updateLeadPersonalData?: Maybe<Lead>
  updateLeadsPipelineStatus?: Maybe<LeadsPipelineStatus>
  updateLeadsPipelineStatusPosition?: Maybe<LeadsPipelineStatus>
  updateLicenseAgreement?: Maybe<Scalars['DateTime']['output']>
  /** Change date, time, or platform of an outline slot before content generation. */
  updateMarketingPlanSlotSchedule?: Maybe<MarketingPlanSlot>
  updateMasterCrmConfig?: Maybe<CrmCompanyConfig>
  updateMaterialMode?: Maybe<Material>
  updateNextMessage?: Maybe<EmailMessage>
  updateOnboardingCompanyAutomaticIntegration?: Maybe<Company>
  updateOnboardingCompanyDetails?: Maybe<Company>
  updateOnboardingCompanyImages?: Maybe<Company>
  updateOnboardingCompanyIsReferenceCustomer?: Maybe<Company>
  updateOnboardingCompanySlogan?: Maybe<Company>
  updateOptionalFields?: Maybe<Settings>
  updatePlotValuationSettings?: Maybe<Settings>
  updatePositions?: Maybe<Scalars['Void']['output']>
  updatePostalShippingSettings?: Maybe<Settings>
  updateProvenExpertLink?: Maybe<Settings>
  updateProvenExpertOnLandingpage?: Maybe<Settings>
  updateSavedContent?: Maybe<Scalars['Void']['output']>
  updateSavedContentBatch?: Maybe<Scalars['Void']['output']>
  updateSlotText?: Maybe<MarketingPlanSlot>
  updateSocialMediaPost?: Maybe<SocialMediaPost>
  updateStatus?: Maybe<Scalars['Boolean']['output']>
  updateTopic?: Maybe<Topic>
  updateUser?: Maybe<User>
  updateUserLocale?: Maybe<Scalars['Boolean']['output']>
  updateUserName?: Maybe<Scalars['Void']['output']>
  updateUserNotificationSettings?: Maybe<Scalars['Boolean']['output']>
  updateUserPhone?: Maybe<Scalars['Boolean']['output']>
  updateUserUploadedMaterial?: Maybe<UserUploadedMaterial>
  updateValuationProvider?: Maybe<Scalars['Void']['output']>
  updateWidgetType?: Maybe<CmsOrganization>
  upgradeCompanyManuallyToBasic?: Maybe<Scalars['Void']['output']>
  upgradeCompanyManuallyToExpert?: Maybe<Scalars['Void']['output']>
  upgradeToBasic?: Maybe<Scalars['Void']['output']>
  upgradeToExpert?: Maybe<Scalars['Void']['output']>
  uploadAdMaterial?: Maybe<UploadAdMaterialResponse>
  uploadMaterial?: Maybe<Material>
  uploadMultipleAdMaterials?: Maybe<UploadMultipleAdMaterialsResponse>
  uploadUserImage?: Maybe<UserImage>
  uploadUserMaterial?: Maybe<UploadAdMaterialResponse>
  uploadUserTopicMaterial?: Maybe<UserUploadedMaterial>
  validateCasaoneCredentials?: Maybe<CasaoneConfig>
  validateFileImportData?: Maybe<ValidateFileImportResult>
  validateFlowfactCredentials?: Maybe<FlowfactConfig>
  validatePropstackCredentials?: Maybe<PropstackConfig>
  validateSignUpToken?: Maybe<Scalars['String']['output']>
  verifyEmailChangeRequest?: Maybe<Scalars['Boolean']['output']>
  verifyHoppermationDomain?: Maybe<HoppermationDomain>
}

export type MutationAcceptLegalConsentsArgs = {
  companyId: Scalars['ID']['input']
  items: Array<AcceptLegalConsentInput>
}

export type MutationAcceptMarketingPlanOutlineArgs = {
  input: AcceptMarketingPlanOutlineInput
}

export type MutationAcknowledgeDefaultSenderVerificationArgs = {
  companyId: Scalars['ID']['input']
}

export type MutationActivateAilanderLandingpagesArgs = {
  companyIds: Array<InputMaybe<Scalars['ID']['input']>>
}

export type MutationActivateAuthorizationArgs = {
  companyId: Scalars['ID']['input']
}

export type MutationActivatePropstackChildSyncArgs = {
  companyId: Scalars['ID']['input']
}

export type MutationActivateUserArgs = {
  id: Scalars['ID']['input']
}

export type MutationAddCommentaryArgs = {
  leadId: Scalars['String']['input']
  text: Scalars['String']['input']
}

export type MutationAddCompanyImageArgs = {
  input: AddCompanyImageInput
}

export type MutationAddDocumentToContractArgs = {
  input: AddDocumentToContractInput
}

export type MutationAddDocumentToOnboardingArgs = {
  input: AddDocumentToOnboardingInput
}

export type MutationAddFacebookPageToUserArgs = {
  input: AddFacebookPageInput
}

export type MutationAddFreeSignUpTokensArgs = {
  input: AddFreeSignUpTokensInput
}

export type MutationAddLeadsPipelineStatusArgs = {
  input: AddLeadsPipelineStatusInput
}

export type MutationAddLinkedinOrganizationToUserArgs = {
  input: AddLinkedinPageInput
}

export type MutationAddMarketingPlanSlotArgs = {
  input: AddMarketingPlanSlotInput
}

export type MutationAddProductsToContractArgs = {
  input: AddProductsToContractInput
}

export type MutationAddVouchersArgs = {
  input: AddVouchersInput
}

export type MutationApproveAndPublishMaterialBundleArgs = {
  input: ApproveAndPublishMaterialBundleInput
}

export type MutationApproveMarketingPlanSlotsArgs = {
  input: ApproveSlotsInput
}

export type MutationApproveMaterialSetArgs = {
  companyId: Scalars['ID']['input']
  materialSetId: Scalars['String']['input']
}

export type MutationApproveMaterialVersionArgs = {
  companyId: Scalars['ID']['input']
  materialId: Scalars['ID']['input']
  versionNumber: Scalars['Int']['input']
}

export type MutationArchiveTopicArgs = {
  id: Scalars['ID']['input']
}

export type MutationAssignLeadsArgs = {
  input: AssignLeadsInput
}

export type MutationAssignOnboardingBillingOrderIdArgs = {
  input: AssignOnboardingBillingOrderIdInput
}

export type MutationAssignUserToLeadArgs = {
  leadId: Scalars['String']['input']
  userId: Scalars['String']['input']
}

export type MutationAssignValuationToLeadArgs = {
  input: AssignValuationToLeadInput
}

export type MutationAssistantChatArgs = {
  input: AssistantChatInput
}

export type MutationAssistantOnboardingApplyToolArgs = {
  input: AssistantOnboardingToolInput
}

export type MutationAssistantOnboardingCreateSessionArgs = {
  input: AssistantOnboardingCreateSessionInput
}

export type MutationAssistantOnboardingSendMessageArgs = {
  input: AssistantOnboardingMessageInput
}

export type MutationAutoMapPropstackUsersToBrokersArgs = {
  companyId: Scalars['ID']['input']
}

export type MutationBookCampaignArgs = {
  input: BookCampaignInput
}

export type MutationBookLandingpageArgs = {
  input: BookLandingpageInput
}

export type MutationBootstrapAssistantOnboardingChatArgs = {
  input?: InputMaybe<AssistantOnboardingBootstrapInput>
}

export type MutationCancelCampaignJobsArgs = {
  campaignId: Scalars['ID']['input']
}

export type MutationCancelDowngradeArgs = {
  companyId: Scalars['ID']['input']
}

export type MutationCancelProductArgs = {
  input: CancelProductInput
}

export type MutationChangeContractArgs = {
  input: ChangeContractInput
}

export type MutationChangePlanArgs = {
  input: ChangePlanInput
}

export type MutationCheckDefaultSenderVerificationArgs = {
  companyId: Scalars['ID']['input']
}

export type MutationCheckSenderVerificationArgs = {
  senderId: Scalars['ID']['input']
}

export type MutationClearAssistantConversationArgs = {
  threadKey?: InputMaybe<Scalars['String']['input']>
}

export type MutationCompleteGoogleCalendarOAuthArgs = {
  input: CompleteGoogleCalendarOAuthInput
}

export type MutationCompleteOnboardingStepWebsiteArgs = {
  input: CompleteOnboardingStepWebsiteInput
}

export type MutationCompleteToDoArgs = {
  input: CompleteToDoInput
}

export type MutationConfirmImageEditArgs = {
  input: ConfirmImageEditInput
}

export type MutationConfirmMaterialUploadArgs = {
  input: ConfirmMaterialUploadInput
}

export type MutationConfirmMultipleMaterialUploadsArgs = {
  input: ConfirmMultipleMaterialUploadsInput
}

export type MutationConfirmUserImageUploadArgs = {
  input: ConfirmUserImageUploadInput
}

export type MutationConnectGoogleBusinessArgs = {
  input: ConnectGoogleBusinessInput
}

export type MutationConnectOnofficeUserArgs = {
  input: ConnectOnofficeUserInput
}

export type MutationConnectSocialMediaArgs = {
  input: ConnectSocialMediaInput
}

export type MutationConnectToEmproArgs = {
  input: EmproAuthCodeInput
}

export type MutationConnectToOnofficeMarketplaceArgs = {
  input: ConnectToOnofficeMarketplaceInput
}

export type MutationCreateAdMaterialTopicArgs = {
  input: CreateAdMaterialTopicInput
}

export type MutationCreateAnamnesisFromWebsiteArgs = {
  url: Scalars['String']['input']
}

export type MutationCreateBrandEasyMaterialTemplateArgs = {
  input: CreateBrandEasyMaterialTemplateInput
}

export type MutationCreateBrandEasyMaterialTemplateForCampaignArgs = {
  input: CreateBrandEasyMaterialTemplateForCampaignInput
}

export type MutationCreateCampaignArgs = {
  input: CreateCampaignInput
}

export type MutationCreateChildCompanyArgs = {
  input: CreateCompanyInput
}

export type MutationCreateCompanyArgs = {
  input: CreateCompanyInput
}

export type MutationCreateCompanyAnamnesisArgs = {
  input: CreateCompanyAnamnesisInput
}

export type MutationCreateCompanyBillingArgs = {
  input: CreateCompanyBillingInput
}

export type MutationCreateCompanySiteBuildArgs = {
  companyId: Scalars['String']['input']
}

export type MutationCreateContractArgs = {
  input: CreateContractInput
}

export type MutationCreateEmailChangeRequestArgs = {
  input: CreateEmailChangeRequestInput
}

export type MutationCreateFeedbackTicketArgs = {
  input: CreateFeedbackTicketInput
}

export type MutationCreateHoppermationSenderArgs = {
  input: CreateHoppermationSenderInput
}

export type MutationCreateLandingpageTemplatesArgs = {
  input: CreateLandingpageTemplatesInput
}

export type MutationCreateLandingpagesArgs = {
  input: CreateLandingpagesInput
}

export type MutationCreateLeadByUserArgs = {
  input: CreateLeadByUserInput
}

export type MutationCreateMaterialMakerTemplateArgs = {
  input: CreateMaterialMakerTemplateInput
}

export type MutationCreateMaterialsForCampaignAndCompaniesArgs = {
  input: CreateMaterialsForCampaignAndCompaniesInput
}

export type MutationCreateMaterialsForMaterialTemplateArgs = {
  materialTemplateId: Scalars['ID']['input']
}

export type MutationCreateOrUpdateCancelationArgs = {
  input: CreateOrUpdateCancelationInput
}

export type MutationCreateOrUpdateCmsOrganizationPagesArgs = {
  organizationId: Scalars['ID']['input']
}

export type MutationCreateOrUpdateCmsOrganizationsArgs = {
  companyIds: Array<InputMaybe<Scalars['ID']['input']>>
}

export type MutationCreateOrUpdateCrmCompanyConfigArgs = {
  input?: InputMaybe<CrmCompanyConfigInput>
}

export type MutationCreateOrderArgs = {
  input: CreateOrderInput
}

export type MutationCreateProductTemplateArgs = {
  input: CreateProductTemplateInput
}

export type MutationCreatePropertyTrackerConversionArgs = {
  input: CreatePropertyTrackerConversionInput
}

export type MutationCreateS3VideoMaterialTemplateForCampaignArgs = {
  input?: InputMaybe<CreateS3VideoMaterialTemplateForCampaignInput>
}

export type MutationCreateStaticMaterialTemplateForCampaignArgs = {
  input: CreateStaticMaterialTemplateForCampaignInput
}

export type MutationCreateSubCompanyArgs = {
  input: CreateSubCompanyInput
}

export type MutationCreateToDoTemplateArgs = {
  input: CreateToDoTemplateInput
}

export type MutationCreateTopicArgs = {
  input: CreateTopicInput
}

export type MutationCreateUserArgs = {
  input: CreateUserInput
}

export type MutationCreateUserUploadedMaterialArgs = {
  input: CreateUserUploadedMaterialInput
}

export type MutationCreateValuationByAgentArgs = {
  input: CreateValuationByAgentInput
}

export type MutationCreateVideoMaterialTemplateArgs = {
  input: CreateVideoMaterialTemplateInput
}

export type MutationCreateVideoMaterialTemplateForCampaignArgs = {
  input: CreateVideoMaterialTemplateForCampaignInput
}

export type MutationDeactivateAilanderLandingpagesArgs = {
  companyIds: Array<InputMaybe<Scalars['ID']['input']>>
}

export type MutationDeactivateAllLandingpagesWithSlugArgs = {
  input: DeactivateLandingpageInput
}

export type MutationDeactivateUserArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteAiGeneratedMaterialArgs = {
  input: DeleteAiGeneratedMaterialInput
}

export type MutationDeleteCampaignArgs = {
  campaignId: Scalars['ID']['input']
}

export type MutationDeleteCmsOrganizationAndPagesArgs = {
  organizationId: Scalars['ID']['input']
}

export type MutationDeleteCommentaryArgs = {
  commentaryId: Scalars['String']['input']
  leadId: Scalars['String']['input']
}

export type MutationDeleteCompanyArgs = {
  id: Scalars['String']['input']
}

export type MutationDeleteCompanyImageArgs = {
  input: DeleteCompanyImageInput
}

export type MutationDeleteCompanyWithDelayArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteContractArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteDocumentOnContractArgs = {
  input: DeleteDocumentOnContractInput
}

export type MutationDeleteDueDateArgs = {
  input: DeleteDueDateInput
}

export type MutationDeleteHoppermationSenderArgs = {
  input: DeleteHoppermationSenderInput
}

export type MutationDeleteInviteLeadToLandingpageArgs = {
  input: DeleteLeadsToLandingpageInput
}

export type MutationDeleteLandingpageArgs = {
  landingpageId: Scalars['ID']['input']
}

export type MutationDeleteLeadArgs = {
  deletedBy?: InputMaybe<Scalars['String']['input']>
  id: Scalars['String']['input']
}

export type MutationDeleteLeadsArgs = {
  input: DeleteLeadsInput
}

export type MutationDeleteLeadsPipelineStatusArgs = {
  input: DeleteLeadsPipelineStatusInput
}

export type MutationDeleteMarketingPlanArgs = {
  input: DeletePlanInput
}

export type MutationDeleteMarketingPlanSlotsArgs = {
  input: DeleteSlotsInput
}

export type MutationDeleteMaterialTemplateForCampaignArgs = {
  materialTemplateId?: InputMaybe<Scalars['ID']['input']>
}

export type MutationDeleteMaterialTemplateWithRelatedMaterialsArgs = {
  materialTemplateId: Scalars['ID']['input']
}

export type MutationDeleteProductArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteSavedContentArgs = {
  input: DeleteSavedContentInput
}

export type MutationDeleteSavedContentBatchArgs = {
  input: DeleteSavedContentBatchInput
}

export type MutationDeleteSavedContentForNewsletterArgs = {
  input: DeleteSavedContentInput
}

export type MutationDeleteSocialMediaConnectionArgs = {
  input: SocialMediaType
}

export type MutationDeleteSocialMediaPostsArgs = {
  input: DeleteSocialMediaPostsInput
}

export type MutationDeleteUserArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteUserEmailSuppressionArgs = {
  email: Scalars['String']['input']
}

export type MutationDeleteUserUploadedMaterialArgs = {
  input: DeleteUserUploadedMaterialInput
}

export type MutationDeleteValuationArgs = {
  valuationId: Scalars['ID']['input']
}

export type MutationDowngradeCompanyManuallyToBasicArgs = {
  companyId: Scalars['ID']['input']
}

export type MutationDowngradeCompanyManuallyToLightArgs = {
  companyId: Scalars['ID']['input']
}

export type MutationDowngradeToBasicArgs = {
  input: DowngradeToBasicInput
}

export type MutationDowngradeToBeginnerArgs = {
  input: DowngradeToBeginnerInput
}

export type MutationDowngradeToFreeLightArgs = {
  input: DowngradeToFreeLightInput
}

export type MutationDowngradeToLightArgs = {
  input: DowngradeToLightInput
}

export type MutationEditEmailArgs = {
  input: EditEmailInput
}

export type MutationEditImageArgs = {
  input: EditImageInput
}

export type MutationEnqueuePdfGenerationArgs = {
  valuationId: Scalars['ID']['input']
}

export type MutationExportCompaniesToCrmArgs = {
  companyIds: Array<Scalars['ID']['input']>
}

export type MutationExportCompanyUsersToCrmArgs = {
  companyIds: Array<Scalars['ID']['input']>
}

export type MutationExportLeadToCrmArgs = {
  id: Scalars['ID']['input']
}

export type MutationExportUserToCrmArgs = {
  userId: Scalars['ID']['input']
}

export type MutationGenerateCampaignArgs = {
  input: GenerateCampaignInput
}

export type MutationGenerateImageArgs = {
  input: GenerateImageInput
}

export type MutationGenerateMarketingPlanArgs = {
  input: GenerateMarketingPlanInput
}

export type MutationGenerateMaterialArgs = {
  materialId: Scalars['ID']['input']
}

export type MutationGenerateMaterialZipForCompanyArgs = {
  companyId: Scalars['ID']['input']
}

export type MutationGenerateMaterialsArgs = {
  input: GenerateMaterialsInput
}

export type MutationGenerateMaterialsForTemplateArgs = {
  input: GenerateMaterialsForTemplateInput
}

export type MutationGenerateMaterialsInBulkArgs = {
  input: GenerateMaterialsInBulkInput
}

export type MutationGenerateSlotImageArgs = {
  input: SlotRefInput
}

export type MutationGenerateSocialTextFromFacebookArgs = {
  input: GenerateSocialTextFromFacebookInput
}

export type MutationGenerateTextArgs = {
  input: GenerateTextInput
}

export type MutationGenerateTopicArgs = {
  isMasterView?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationHandleOnboardingBillingDataArgs = {
  input: HandleOnboardingBillingDataInput
}

export type MutationIgnoreChangesForRegenerationArgs = {
  companyId: Scalars['ID']['input']
}

export type MutationImportCampaignArgs = {
  data: Scalars['JSONObject']['input']
}

export type MutationImportFormArgs = {
  input: ImportFormInput
}

export type MutationInviteLeadsToLandingpageArgs = {
  input: InviteLeadsToLandingpageInput
}

export type MutationLeadAiSummaryArgs = {
  input: LeadAiSummaryInput
}

export type MutationLicenseStockPhotoArgs = {
  input: LicenseStockPhotoInput
}

export type MutationMarkSavedContentAsDownloadedArgs = {
  id: Scalars['ID']['input']
}

export type MutationMoveLeadsToCompanyArgs = {
  input: MoveLeadToCompanyInput
}

export type MutationPauseChannelForLeadArgs = {
  input: PauseChannelForLeadInput
}

export type MutationPostToSocialMediaArgs = {
  input: PostToSocialMediaInput
}

export type MutationPostToSocialMediaForCompaniesArgs = {
  input: PostToSocialMediaMultiCompanyInput
}

export type MutationPrepareStockImageForEditArgs = {
  input: PrepareStockImageForEditInput
}

export type MutationPreviewCustomerGuideDraftArgs = {
  input: CustomerGuideDraftPreviewInput
}

export type MutationRecreateSlotTextArgs = {
  input: SlotRefInput
}

export type MutationRegisterUserArgs = {
  input: RegisterUserInput
}

export type MutationRemoveCompanyFromOnofficeSharedConfigArgs = {
  input: RemoveOnofficeSharedConfigCompanyInput
}

export type MutationRequestGuideRegenerationArgs = {
  materialId: Scalars['ID']['input']
}

export type MutationRequestImageEditUploadUrlArgs = {
  input: RequestImageEditUploadUrlInput
}

export type MutationRequestMaterialUploadUrlArgs = {
  input: RequestMaterialUploadUrlInput
}

export type MutationRequestMultipleMaterialUploadUrlsArgs = {
  input: RequestMultipleMaterialUploadUrlsInput
}

export type MutationRequestUserImageUploadUrlArgs = {
  input: RequestUserImageUploadUrlInput
}

export type MutationResendHoppermationDefaultSenderValidationArgs = {
  companyId: Scalars['ID']['input']
}

export type MutationResendHoppermationSenderValidationArgs = {
  senderId: Scalars['ID']['input']
}

export type MutationResendPendingSubscriptionsArgs = {
  input: ResendPendingSubscriptionsInput
}

export type MutationResumeChannelForLeadArgs = {
  input: ResumeChannelForLeadInput
}

export type MutationRetryMaterialSetArgs = {
  companyId: Scalars['ID']['input']
  materialSetId: Scalars['String']['input']
}

export type MutationRevertGeneratedImageArgs = {
  input: RevertGeneratedImageInput
}

export type MutationRevertStockImageArgs = {
  input: RevertStockImageInput
}

export type MutationRevertUserImageArgs = {
  input: RevertUserImageInput
}

export type MutationRevokeCancellationArgs = {
  companyId: Scalars['ID']['input']
}

export type MutationRevokeCompanyDeletionWithDelayArgs = {
  id: Scalars['ID']['input']
}

export type MutationRevokeProductCancellationArgs = {
  input: RevokeProductCancellationInput
}

export type MutationSaveCasaoneCredentialsArgs = {
  input: CasaoneCredentialsInput
}

export type MutationSaveContentArgs = {
  input: SaveContentInput
}

export type MutationSaveCustomerGuideDraftArgs = {
  input: CustomerGuideDraftInput
}

export type MutationSaveEmproSelectedContactStatusesArgs = {
  input: EmproSelectedContactStatusesInput
}

export type MutationSaveFlowfactCredentialsArgs = {
  input: FlowfactCredentialsInput
}

export type MutationSaveFlowfactSelectedContactStatusesArgs = {
  input: FlowfactSelectedContactStatusesInput
}

export type MutationSaveOnofficeSelectedContactTypesArgs = {
  input: OnofficeSelectedContactTypesInput
}

export type MutationSaveOnofficeSharedConfigArgs = {
  input: SaveOnofficeSharedConfigInput
}

export type MutationSaveOnofficeSharedConfigCompanyArgs = {
  input: SaveOnofficeSharedConfigCompanyInput
}

export type MutationSavePropstackChildTeamAssignmentArgs = {
  input: PropstackChildTeamAssignmentInput
}

export type MutationSavePropstackCredentialsArgs = {
  input: PropstackCredentialsInput
}

export type MutationSavePropstackDefaultExportBrokerArgs = {
  input: SavePropstackDefaultExportBrokerInput
}

export type MutationSavePropstackSelectedContactStatusesArgs = {
  input: PropstackSelectedContactStatusesInput
}

export type MutationSavePropstackSelectedGroupIdsArgs = {
  input: PropstackSelectedGroupIdsInput
}

export type MutationSavePropstackUserBrokerMappingArgs = {
  input: PropstackUserBrokerMappingInput
}

export type MutationSendInvitationPreviewArgs = {
  input: SendInvitationPreviewInput
}

export type MutationSendNewsletterPreviewArgs = {
  input: SendNewsletterPreviewInput
}

export type MutationSendNextEmailForLeadArgs = {
  input: SendNextEmailForLeadInput
}

export type MutationSendPasswordResetMailArgs = {
  userId: Scalars['String']['input']
}

export type MutationSendResetOrVerificationMailArgs = {
  input: SendResetOrVerificationMailInput
}

export type MutationSetAsDefaultSenderArgs = {
  senderId: Scalars['ID']['input']
}

export type MutationSetCompanyFeatureArgs = {
  input: SetCompanyFeatureInput
}

export type MutationSetComponentFeatureArgs = {
  input: SetComponentFeatureInput
}

export type MutationSetCountryFeatureArgs = {
  input: SetCountryFeatureInput
}

export type MutationSetDueDateArgs = {
  input: SetDueDateInput
}

export type MutationSetGoogleBusinessLocationArgs = {
  input: SetGoogleBusinessLocationInput
}

export type MutationSetPlatformFeatureArgs = {
  input: SetPlatformFeatureInput
}

export type MutationSetProductFeatureArgs = {
  input: SetProductFeatureInput
}

export type MutationSetRolePermissionsArgs = {
  input: SetRolePermissionsInput
}

export type MutationSetUserRoleArgs = {
  input: SetUserRoleInput
}

export type MutationSignUpUserArgs = {
  input: SignUpUserInput
}

export type MutationStartFileImportArgs = {
  importId: Scalars['ID']['input']
}

export type MutationStartHoppermationActivationArgs = {
  companyId: Scalars['ID']['input']
}

export type MutationStartRegenerationArgs = {
  companyId: Scalars['ID']['input']
}

export type MutationStartToDoArgs = {
  input: StartToDoInput
}

export type MutationStopAllCampaignsForLeadArgs = {
  input?: InputMaybe<StopAllCampaignsForLeadInput>
}

export type MutationStopAllCommunicationsForLeadArgs = {
  input?: InputMaybe<StopAllCampaignsForLeadInput>
}

export type MutationStopChannelForLeadArgs = {
  input: StopChannelForLeadInput
}

export type MutationSubmitCustomerGuideDraftArgs = {
  input: CustomerGuideDraftSubmitInput
}

export type MutationSubmitOnboardingArgs = {
  companyId: Scalars['ID']['input']
}

export type MutationSubscribeToCampaignArgs = {
  input: CampaignType
}

export type MutationTrackLandingpageImpressionArgs = {
  input: TrackLandingpageImpressionInput
}

export type MutationTriggerPropertyTrackerInvitationsArgs = {
  leadIds: Array<Scalars['ID']['input']>
}

export type MutationUnarchiveTopicArgs = {
  id: Scalars['ID']['input']
}

export type MutationUnassignUserFromLeadArgs = {
  leadId: Scalars['String']['input']
}

export type MutationUnpublishMaterialSetArgs = {
  companyId: Scalars['ID']['input']
  materialSetId: Scalars['String']['input']
}

export type MutationUnpublishMaterialVersionArgs = {
  companyId: Scalars['ID']['input']
  materialId: Scalars['ID']['input']
}

export type MutationUnsubscribeFromCampaignArgs = {
  input: CampaignType
}

export type MutationUpdateAiSettingsArgs = {
  input: AiSettingsInput
}

export type MutationUpdateAvvArgs = {
  companyId: Scalars['ID']['input']
}

export type MutationUpdateBookedLandingpagesArgs = {
  input: UpdateBookedLandingpagesInput
}

export type MutationUpdateCalendarSyncSettingsArgs = {
  input: UpdateCalendarSyncSettingsInput
}

export type MutationUpdateCampaignArgs = {
  input: UpdateCampaignInput
}

export type MutationUpdateCampaignIsActiveArgs = {
  input: UpdateCampaignIsActiveInput
}

export type MutationUpdateCompanyAddressArgs = {
  input: UpdateCompanyAddressInput
}

export type MutationUpdateCompanyAmbassadorArgs = {
  input: UpdateAmbassadorInput
}

export type MutationUpdateCompanyAmbassadorDataArgs = {
  input: UpdateCompanyAmbassadorDataInput
}

export type MutationUpdateCompanyAmbassadorPortraitArgs = {
  input: UpdateCompanyAmbassadorPortraitInput
}

export type MutationUpdateCompanyAmbassadorSignatureCustomTemplateSignatureArgs = {
  input: UpdateCompanyAmbassadorSignatureCustomTemplateSignatureInput
}

export type MutationUpdateCompanyAmbassadorSignatureExtraArgs = {
  input: UpdateCompanyAmbassadorSignatureExtraInput
}

export type MutationUpdateCompanyAmbassadorSignatureHtmlArgs = {
  input: UpdateCompanyAmbassadorSignatureHtmlInput
}

export type MutationUpdateCompanyAmbassadorSignatureIncludeGoogleReviewArgs = {
  input: UpdateCompanyAmbassadorSignatureIncludeGoogleReviewInput
}

export type MutationUpdateCompanyAmbassadorSignatureIncludeProvenExpertArgs = {
  input: UpdateCompanyAmbassadorSignatureIncludeProvenExpertInput
}

export type MutationUpdateCompanyAmbassadorSignatureTextArgs = {
  input: UpdateCompanyAmbassadorSignatureTextInput
}

export type MutationUpdateCompanyBillingArgs = {
  input: UpdateCompanyBillingInput
}

export type MutationUpdateCompanyCommissionArgs = {
  input: UpdateCompanyCommissionInput
}

export type MutationUpdateCompanyContactPersonArgs = {
  input: UpdateCompanyContactPersonInput
}

export type MutationUpdateCompanyCustomWordingArgs = {
  input: UpdateCompanyCustomWordingInput
}

export type MutationUpdateCompanyDetailsArgs = {
  input: UpdateCompanyDetailsInput
}

export type MutationUpdateCompanyImageArgs = {
  input: UpdateCompanyImageInput
}

export type MutationUpdateCompanyLinksArgs = {
  input: UpdateCompanyLinksInput
}

export type MutationUpdateCompanyLocaleArgs = {
  input: UpdateCompanyLocaleInput
}

export type MutationUpdateCompanyLogoArgs = {
  input: UpdateCompanyLogoInput
}

export type MutationUpdateCompanyMailProviderArgs = {
  input: UpdateCompanyMailProviderInput
}

export type MutationUpdateCompanyMetaDataArgs = {
  input: UpdateCompanyMetaDataInput
}

export type MutationUpdateCompanyNameArgs = {
  input: UpdateCompanyNameInput
}

export type MutationUpdateCompanyPerformanceDataArgs = {
  input: UpdateCompanyPerformanceDataInput
}

export type MutationUpdateCompanyPhoneVerificationSettingsForValuationArgs = {
  input: UpdateCompanyPhoneVerificationSettingsForValuationInput
}

export type MutationUpdateCompanyRegionArgs = {
  input: UpdateCompanyRegionInput
}

export type MutationUpdateCompanySiteArgs = {
  input: UpdateCompanySiteInput
}

export type MutationUpdateCompanySloganArgs = {
  input: UpdateCompanySloganInput
}

export type MutationUpdateCompanySlugArgs = {
  input: UpdateCompanySlugInput
}

export type MutationUpdateCompanySlugByCompanyArgs = {
  input: UpdateCompanySlugInput
}

export type MutationUpdateCompanyStateArgs = {
  input: UpdateCompanyStateInput
}

export type MutationUpdateCompanyThemeArgs = {
  input: UpdateCompanyThemeInput
}

export type MutationUpdateCompanyVariantArgs = {
  companyId: Scalars['String']['input']
  variant: Scalars['String']['input']
}

export type MutationUpdateContactDetailsArgs = {
  input: ContactDetails
}

export type MutationUpdateContractNoteArgs = {
  input: UpdateContractNoteInput
}

export type MutationUpdateCustomUrlsArgs = {
  input: Array<InputMaybe<UpdateCustomUrlInput>>
}

export type MutationUpdateFbPixelAccessTokenArgs = {
  input: UpdateFbPixelAccessTokenInput
}

export type MutationUpdateGoogleReviewLinkArgs = {
  input: UpdateGoogleReviewLinkInput
}

export type MutationUpdateGoogleReviewOnLandingpageArgs = {
  input: UpdateGoogleReviewOnLandingpageInput
}

export type MutationUpdateHoppermationSenderArgs = {
  input: UpdateHoppermationSenderInput
}

export type MutationUpdateInAppValuationProviderArgs = {
  input: UpdateValuationProviderInput
}

export type MutationUpdateInviteLeadToLandingpageArgs = {
  input: UpdateLeadsToLandingpageInput
}

export type MutationUpdateIsPhoneOptionalSettingsArgs = {
  input: UpdateIsPhoneOptionalSettingsInput
}

export type MutationUpdateLandingpageImpressionCookieConsentArgs = {
  input: UpdateLandingpageImpressionCookieConsentInput
}

export type MutationUpdateLandingpageStatusArgs = {
  input: UpdateLandingpageStatusInput
}

export type MutationUpdateLeadPersonalDataArgs = {
  input: UpdateLeadPersonalDataInput
}

export type MutationUpdateLeadsPipelineStatusArgs = {
  input: UpdateLeadsPipelineStatusInput
}

export type MutationUpdateLeadsPipelineStatusPositionArgs = {
  input: UpdateLeadsPipelineStatusPositionInput
}

export type MutationUpdateLicenseAgreementArgs = {
  companyId: Scalars['ID']['input']
}

export type MutationUpdateMarketingPlanSlotScheduleArgs = {
  input: UpdateMarketingPlanSlotScheduleInput
}

export type MutationUpdateMasterCrmConfigArgs = {
  input?: InputMaybe<MasterCrmCompanyConfigInput>
}

export type MutationUpdateMaterialModeArgs = {
  input: UpdateMaterialModeInput
}

export type MutationUpdateNextMessageArgs = {
  input: UpdateNextMessageInput
}

export type MutationUpdateOnboardingCompanyAutomaticIntegrationArgs = {
  input: UpdateOnboardingCompanyAutomaticIntegrationInput
}

export type MutationUpdateOnboardingCompanyDetailsArgs = {
  input: UpdateOnboardingCompanyDetails
}

export type MutationUpdateOnboardingCompanyImagesArgs = {
  input: UpdateOnboardingCompanyImagesInput
}

export type MutationUpdateOnboardingCompanyIsReferenceCustomerArgs = {
  input: UpdateOnboardingCompanyIsReferenceCustomer
}

export type MutationUpdateOnboardingCompanySloganArgs = {
  input: UpdateOnboardingCompanySlogan
}

export type MutationUpdateOptionalFieldsArgs = {
  input: UpdateOptionalFieldsInput
}

export type MutationUpdatePlotValuationSettingsArgs = {
  input: PlotValuationSettingsInput
}

export type MutationUpdatePositionsArgs = {
  leadIds: Array<InputMaybe<Scalars['ID']['input']>>
}

export type MutationUpdatePostalShippingSettingsArgs = {
  input: PostalShippingInput
}

export type MutationUpdateProvenExpertLinkArgs = {
  input: UpdateProvenExpertLinkInput
}

export type MutationUpdateProvenExpertOnLandingpageArgs = {
  input: UpdateProvenExpertOnLandingpageInput
}

export type MutationUpdateSavedContentArgs = {
  input: UpdateSavedContentInput
}

export type MutationUpdateSavedContentBatchArgs = {
  input: UpdateSavedContentBatchInput
}

export type MutationUpdateSlotTextArgs = {
  input: UpdateSlotTextInput
}

export type MutationUpdateSocialMediaPostArgs = {
  input: UpdateSocialMediaPostInput
}

export type MutationUpdateStatusArgs = {
  leadId: Scalars['String']['input']
  status: Scalars['String']['input']
}

export type MutationUpdateTopicArgs = {
  input: UpdateTopicInput
}

export type MutationUpdateUserArgs = {
  input: UpdateUserInput
}

export type MutationUpdateUserLocaleArgs = {
  input: UpdateUserLocaleInput
}

export type MutationUpdateUserNameArgs = {
  input: UpdateUserNameInput
}

export type MutationUpdateUserNotificationSettingsArgs = {
  input: UpdateUserNotificationSettingsInput
}

export type MutationUpdateUserPhoneArgs = {
  input: UpdateUserPhoneInput
}

export type MutationUpdateUserUploadedMaterialArgs = {
  input: UpdateUserUploadedMaterialInput
}

export type MutationUpdateValuationProviderArgs = {
  input: UpdateValuationProviderInput
}

export type MutationUpdateWidgetTypeArgs = {
  input: UpdateWidgetTypeInput
}

export type MutationUpgradeCompanyManuallyToBasicArgs = {
  companyId: Scalars['ID']['input']
}

export type MutationUpgradeCompanyManuallyToExpertArgs = {
  companyId: Scalars['ID']['input']
}

export type MutationUpgradeToBasicArgs = {
  input: UpgradeToBasicInput
}

export type MutationUpgradeToExpertArgs = {
  input: UpgradeToExpertInput
}

export type MutationUploadAdMaterialArgs = {
  input: UploadAdMaterialInput
}

export type MutationUploadMaterialArgs = {
  input: UploadMaterialInput
}

export type MutationUploadMultipleAdMaterialsArgs = {
  input: UploadMultipleAdMaterialsInput
}

export type MutationUploadUserImageArgs = {
  input: UploadUserImageInput
}

export type MutationUploadUserMaterialArgs = {
  input: UploadUserMaterialInput
}

export type MutationUploadUserTopicMaterialArgs = {
  input: UploadMaterialInput
}

export type MutationValidateCasaoneCredentialsArgs = {
  input: CasaoneCredentialsInput
}

export type MutationValidateFileImportDataArgs = {
  input: ValidateFileImportDataInput
}

export type MutationValidateFlowfactCredentialsArgs = {
  input: FlowfactCredentialsInput
}

export type MutationValidatePropstackCredentialsArgs = {
  input: PropstackCredentialsInput
}

export type MutationValidateSignUpTokenArgs = {
  input: ValidateSignUpTokenInput
}

export type MutationVerifyEmailChangeRequestArgs = {
  id: Scalars['ID']['input']
}

export type MutationVerifyHoppermationDomainArgs = {
  companyId: Scalars['ID']['input']
}

export type NewsletterDeliveryDetails = {
  __typename?: 'NewsletterDeliveryDetails'
  failed: Scalars['Int']['output']
  pending: Scalars['Int']['output']
  recipients: Array<NewsletterRecipient>
  sent: Scalars['Int']['output']
  total: Scalars['Int']['output']
}

/** Newsletter filters input (same structure as FilterInput in lead.gql). */
export type NewsletterFiltersInput = {
  companyIds?: InputMaybe<Array<Scalars['ID']['input']>>
  /** Filter by current lead status. */
  currentStatus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  individualLink?: InputMaybe<Scalars['String']['input']>
  /** Include leads from CRM origin. */
  leadOriginCrm?: InputMaybe<Scalars['Boolean']['input']>
  /** Include leads subscribed to newsletter. */
  newsletter: Scalars['Boolean']['input']
  /** Exclude leads with guide/checklist downloads. */
  noGuideChecklistDownload?: InputMaybe<Scalars['Boolean']['input']>
  /** Include leads with property requests. */
  propertyRequests?: InputMaybe<Scalars['Boolean']['input']>
  /** Include leads with return calls. */
  returnCalls?: InputMaybe<Scalars['Boolean']['input']>
  /** Specific slug filter. */
  slug?: InputMaybe<Scalars['String']['input']>
  targetLink?: InputMaybe<Scalars['String']['input']>
  /** Include leads with valuations. */
  valuations?: InputMaybe<Scalars['Boolean']['input']>
}

/** Individual office distribution data. */
export type NewsletterOffice = {
  __typename?: 'NewsletterOffice'
  /** Office name. */
  name: Scalars['String']['output']
  /** Number of recipients for this office. */
  recipientCount: Scalars['Int']['output']
  /** Target link for this office (landingpage URL). */
  targetLink: Scalars['String']['output']
}

/** Newsletter office distribution response. */
export type NewsletterOfficeDistribution = {
  __typename?: 'NewsletterOfficeDistribution'
  /** List of offices with recipient counts. */
  offices: Array<NewsletterOffice>
  /** Total number of offices with recipients. */
  totalOffices: Scalars['Int']['output']
  /** Total number of recipients across all offices. */
  totalRecipients: Scalars['Int']['output']
}

/** Input for newsletter office distribution query. */
export type NewsletterOfficeDistributionInput = {
  /** Master company ID. */
  companyId: Scalars['ID']['input']
  /** Newsletter filters (same as acquisition booster filters). */
  filters: NewsletterFiltersInput
  /** Topic identifier (e.g., 'immobilienbewertung'). */
  landingpageSlug: Scalars['String']['input']
}

export type NewsletterRecipient = {
  __typename?: 'NewsletterRecipient'
  companyId?: Maybe<Scalars['ID']['output']>
  companyName?: Maybe<Scalars['String']['output']>
  deliveryError?: Maybe<Scalars['String']['output']>
  deliveryStatus?: Maybe<Scalars['String']['output']>
  invitationId?: Maybe<Scalars['ID']['output']>
  invitedAt?: Maybe<Scalars['DateTime']['output']>
  leadEmail?: Maybe<Scalars['String']['output']>
  leadId?: Maybe<Scalars['ID']['output']>
  leadName?: Maybe<Scalars['String']['output']>
}

export type NextMessagesInput = {
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type NotificationSettings = {
  __typename?: 'NotificationSettings'
  contentDepletion?: Maybe<EnabledSource>
  dueDate?: Maybe<EnabledSource>
  leadAssigned?: Maybe<EnabledSource>
  newConversion?: Maybe<EnabledSource>
  news?: Maybe<EnabledSource>
  reminder?: Maybe<EnabledSource>
  socialMediaPostReminder?: Maybe<EnabledSource>
}

export type OnboardingBillingAddress = {
  __typename?: 'OnboardingBillingAddress'
  city?: Maybe<Scalars['String']['output']>
  countryCode?: Maybe<CountryCode>
  houseNumber?: Maybe<Scalars['String']['output']>
  street?: Maybe<Scalars['String']['output']>
  zip?: Maybe<Scalars['String']['output']>
}

export type OnboardingBillingAddressInput = {
  city: Scalars['String']['input']
  countryCode: CountryCode
  houseNumber: Scalars['String']['input']
  street: Scalars['String']['input']
  zip: Scalars['String']['input']
}

export type OnboardingBillingCustomer = {
  __typename?: 'OnboardingBillingCustomer'
  address: OnboardingBillingAddress
  companyName?: Maybe<Scalars['String']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  lastName?: Maybe<Scalars['String']['output']>
  taxNumber?: Maybe<Scalars['String']['output']>
  vatId?: Maybe<Scalars['String']['output']>
}

export type OnboardingBillingCustomerInput = {
  address: OnboardingBillingAddressInput
  companyName: Scalars['String']['input']
  firstName: Scalars['String']['input']
  lastName: Scalars['String']['input']
  taxNumber?: InputMaybe<Scalars['String']['input']>
  vatId?: InputMaybe<Scalars['String']['input']>
}

export type OnboardingBillingData = {
  __typename?: 'OnboardingBillingData'
  customer?: Maybe<OnboardingBillingCustomer>
}

export type OnboardingStep = {
  __typename?: 'OnboardingStep'
  name: SelfOnboardingStep
}

export type OnboardingStepResult = {
  __typename?: 'OnboardingStepResult'
  errorCode?: Maybe<Scalars['String']['output']>
  message?: Maybe<Scalars['String']['output']>
  status: OnboardingStepStatus
  stepName: SelfOnboardingStep
}

export enum OnboardingStepStatus {
  Error = 'ERROR',
  Success = 'SUCCESS',
}

export enum OnboardingTargetAudience {
  ExistingAndNewContacts = 'EXISTING_AND_NEW_CONTACTS',
  ExistingContacts = 'EXISTING_CONTACTS',
  NewContacts = 'NEW_CONTACTS',
}

export type OnboardingWebsiteLinks = {
  imprint: Scalars['String']['input']
  privacy: Scalars['String']['input']
  website: Scalars['String']['input']
}

export type OnofficeConfig = {
  __typename?: 'OnofficeConfig'
  defaultExportUserOnofficeId?: Maybe<Scalars['String']['output']>
  isManagedBySharedConfig?: Maybe<Scalars['Boolean']['output']>
  isTokenVerified?: Maybe<Scalars['Boolean']['output']>
  secret?: Maybe<Scalars['String']['output']>
  selectedContactTypes?: Maybe<Array<Maybe<Scalars['ID']['output']>>>
  token?: Maybe<Scalars['String']['output']>
}

export type OnofficeContactType = {
  __typename?: 'OnofficeContactType'
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
}

export type OnofficeContactsCountByType = {
  __typename?: 'OnofficeContactsCountByType'
  countPerStatus?: Maybe<Scalars['JSONObject']['output']>
}

export type OnofficeSelectedContactTypesInput = {
  companyId: Scalars['ID']['input']
  selectedContactTypes: Array<Scalars['String']['input']>
}

export type OnofficeSharedConfig = {
  __typename?: 'OnofficeSharedConfig'
  id: Scalars['ID']['output']
  isTokenVerified: Scalars['Boolean']['output']
  name: Scalars['String']['output']
}

export type OptionalAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  street?: InputMaybe<Scalars['String']['input']>
  zip?: InputMaybe<Scalars['String']['input']>
}

export type Order = {
  __typename?: 'Order'
  Currency?: Maybe<Scalars['String']['output']>
  GrossTotal?: Maybe<Scalars['Float']['output']>
  OrderId?: Maybe<Scalars['String']['output']>
}

export enum OrganizationStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Pending = 'PENDING',
}

export enum OutdoorArea {
  Balcony = 'BALCONY',
  Garden = 'GARDEN',
  Terrace = 'TERRACE',
  TerraceWithGarden = 'TERRACE_WITH_GARDEN',
}

export type PaginatedAdMaterial = {
  __typename?: 'PaginatedAdMaterial'
  adMaterials?: Maybe<Array<Maybe<AdMaterial>>>
  filters?: Maybe<AdMaterialFilters>
  meta?: Maybe<PaginationMeta>
}

export type PaginatedLeads = {
  __typename?: 'PaginatedLeads'
  entries: Array<Maybe<Lead>>
  hasMore: Scalars['Boolean']['output']
  total: Scalars['Int']['output']
  totalByStatus?: Maybe<Array<Maybe<TotalByStatus>>>
}

export type PaginationMeta = {
  __typename?: 'PaginationMeta'
  itemsPerPage: Scalars['Int']['output']
  page: Scalars['Int']['output']
  total: Scalars['Int']['output']
  totalPages: Scalars['Int']['output']
}

export type ParseDataFromWebsiteInput = {
  timeout?: InputMaybe<Scalars['Int']['input']>
  url: Scalars['String']['input']
}

export type ParsedWebsiteData = {
  __typename?: 'ParsedWebsiteData'
  city?: Maybe<Scalars['String']['output']>
  countryCode?: Maybe<CountryCode>
  houseNumber?: Maybe<Scalars['String']['output']>
  imprint?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  privacy?: Maybe<Scalars['String']['output']>
  street?: Maybe<Scalars['String']['output']>
  vatId?: Maybe<Scalars['String']['output']>
  zip?: Maybe<Scalars['String']['output']>
}

export type PartialSale = {
  __typename?: 'PartialSale'
  callbackTimeOfDay?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  property?: Maybe<PartialSaleProperty>
}

export type PartialSaleProperty = {
  __typename?: 'PartialSaleProperty'
  buildingYear: Scalars['Int']['output']
  garageAmount?: Maybe<Scalars['Int']['output']>
  livingArea: Scalars['Int']['output']
  postcode: Scalars['String']['output']
  selfOccupied: Scalars['Boolean']['output']
  type: Scalars['String']['output']
  value: Scalars['Int']['output']
}

export type PauseChannelForLeadInput = {
  channelId: Scalars['ID']['input']
  leadId: Scalars['ID']['input']
}

export enum PaymentMethod {
  Billwerk = 'BILLWERK',
  DirectDebit = 'DIRECT_DEBIT',
  Invoice = 'INVOICE',
  Prepayment = 'PREPAYMENT',
}

export enum PaymentProviderRole {
  ApplePay = 'ApplePay',
  BlackLabel = 'BlackLabel',
  CreditCard = 'CreditCard',
  Debit = 'Debit',
  None = 'None',
  OnAccount = 'OnAccount',
}

export enum PayoutType {
  Combined = 'COMBINED',
  Once = 'ONCE',
  Recurring = 'RECURRING',
}

export type PendingDowngrade = {
  __typename?: 'PendingDowngrade'
  downgradeAt?: Maybe<Scalars['DateTime']['output']>
  productType?: Maybe<CompanyProductType>
}

export type PerformanceFacebook = {
  __typename?: 'PerformanceFacebook'
  budget?: Maybe<Scalars['String']['output']>
  customPixelEventSourceUrl?: Maybe<Scalars['String']['output']>
  distributeBudget?: Maybe<Scalars['String']['output']>
  link?: Maybe<Scalars['String']['output']>
  onboarding?: Maybe<PerformanceFacebookOnboarding>
  pixelEventSourceUrlType?: Maybe<FbPixelEventSourceUrlType>
  zip?: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export type PerformanceFacebookInput = {
  budget?: InputMaybe<Scalars['String']['input']>
  distributeBudget?: InputMaybe<Scalars['String']['input']>
  link?: InputMaybe<Scalars['String']['input']>
  onboarding?: InputMaybe<PerformanceFacebookOnboardingInput>
  zip?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type PerformanceFacebookOnboarding = {
  __typename?: 'PerformanceFacebookOnboarding'
  adAccounts?: Maybe<Scalars['Boolean']['output']>
  leadgenTos?: Maybe<Scalars['Boolean']['output']>
  pages?: Maybe<Scalars['Boolean']['output']>
}

export type PerformanceFacebookOnboardingInput = {
  adAccounts?: InputMaybe<Scalars['Boolean']['input']>
  leadgenTos?: InputMaybe<Scalars['Boolean']['input']>
  pages?: InputMaybe<Scalars['Boolean']['input']>
}

export type PerformanceGoogle = {
  __typename?: 'PerformanceGoogle'
  budget?: Maybe<Scalars['String']['output']>
  distributeBudget?: Maybe<Scalars['String']['output']>
  email?: Maybe<Scalars['String']['output']>
  targetUrl?: Maybe<Scalars['String']['output']>
  zip?: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export type PerformanceGoogleInput = {
  budget?: InputMaybe<Scalars['String']['input']>
  distributeBudget?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  targetUrl?: InputMaybe<Scalars['String']['input']>
  zip?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type Permission = {
  __typename?: 'Permission'
  name?: Maybe<Scalars['String']['output']>
  slug?: Maybe<Scalars['String']['output']>
}

export enum Perspective {
  Plural = 'plural',
  Singular = 'singular',
}

export type Phone = {
  __typename?: 'Phone'
  origin?: Maybe<PhoneOrigin>
  phone?: Maybe<Scalars['String']['output']>
  verifiedAt?: Maybe<Scalars['DateTime']['output']>
}

export type PhoneInput = {
  origin?: InputMaybe<PhoneOrigin>
  phone?: InputMaybe<Scalars['String']['input']>
  verifiedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export enum PhoneOrigin {
  Conversion = 'CONVERSION',
  Crm = 'CRM',
  Import = 'IMPORT',
  User = 'USER',
}

export type Photo = {
  __typename?: 'Photo'
  alt?: Maybe<Scalars['String']['output']>
  avg_color?: Maybe<Scalars['String']['output']>
  canBeDownloaded?: Maybe<Scalars['Boolean']['output']>
  fileId?: Maybe<Scalars['ID']['output']>
  height?: Maybe<Scalars['Int']['output']>
  history?: Maybe<Array<Maybe<EditHistoryEntry>>>
  id?: Maybe<Scalars['ID']['output']>
  isLicenseRequired?: Maybe<Scalars['Boolean']['output']>
  src?: Maybe<PhotoSrc>
  url?: Maybe<Scalars['String']['output']>
  width?: Maybe<Scalars['Int']['output']>
}

export type PhotoList = {
  __typename?: 'PhotoList'
  next_page?: Maybe<Scalars['String']['output']>
  page?: Maybe<Scalars['Int']['output']>
  per_page?: Maybe<Scalars['Int']['output']>
  photos?: Maybe<Array<Maybe<Photo>>>
  total_results?: Maybe<Scalars['Int']['output']>
}

export type PhotoSrc = {
  __typename?: 'PhotoSrc'
  landscape?: Maybe<Scalars['String']['output']>
  large?: Maybe<Scalars['String']['output']>
  large2x?: Maybe<Scalars['String']['output']>
  medium?: Maybe<Scalars['String']['output']>
  original?: Maybe<Scalars['String']['output']>
  portrait?: Maybe<Scalars['String']['output']>
  small?: Maybe<Scalars['String']['output']>
  tiny?: Maybe<Scalars['String']['output']>
}

export type Photos = {
  __typename?: 'Photos'
  page?: Maybe<Scalars['Int']['output']>
  per_page?: Maybe<Scalars['Int']['output']>
  photos?: Maybe<Array<Maybe<Photo>>>
  total_results?: Maybe<Scalars['Int']['output']>
}

export enum Platform {
  Bottimmo = 'BOTTIMMO',
  Falc = 'FALC',
  Smg = 'SMG',
  Turkoglu = 'TURKOGLU',
}

export type PlatformTexts = {
  __typename?: 'PlatformTexts'
  INSTAGRAM?: Maybe<Scalars['String']['output']>
  LINKEDIN?: Maybe<Scalars['String']['output']>
}

export type PlotConditions = {
  __typename?: 'PlotConditions'
  power?: Maybe<Scalars['Boolean']['output']>
  road?: Maybe<Scalars['Boolean']['output']>
  water?: Maybe<Scalars['Boolean']['output']>
}

export type PlotConditionsInput = {
  power: Scalars['Boolean']['input']
  road: Scalars['Boolean']['input']
  water: Scalars['Boolean']['input']
}

export enum PlotDevelopment {
  CoveredArea = 'COVERED_AREA',
  NearFuture = 'NEAR_FUTURE',
  None = 'NONE',
  Now = 'NOW',
  Restricted = 'RESTRICTED',
  Unknown = 'UNKNOWN',
}

export type PlotValuation = {
  __typename?: 'PlotValuation'
  address: PropertyAddress
  callbackTimeOfDay?: Maybe<Array<ReturnCallTimeOfDay>>
  conditions: PlotConditions
  development: PlotDevelopment
  landArea: Scalars['Int']['output']
  type: PlotValuationType
}

export type PlotValuationConversionDetailsInput = {
  address: PropertyAddressInput
  callbackTimeOfDay: Array<ReturnCallTimeOfDay>
  conditions: PlotConditionsInput
  development: PlotDevelopment
  landArea: Scalars['Int']['input']
  type: PlotValuationType
}

export type PlotValuationSettings = {
  __typename?: 'PlotValuationSettings'
  showInPropertyValuation?: Maybe<Scalars['Boolean']['output']>
}

export type PlotValuationSettingsInput = {
  companyId: Scalars['ID']['input']
  showInPropertyValuation: Scalars['Boolean']['input']
}

export enum PlotValuationType {
  Business = 'BUSINESS',
  Construction = 'CONSTRUCTION',
  Expected = 'EXPECTED',
}

export type PostToSocialMediaInput = {
  carouselImages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  imageLink?: InputMaybe<Scalars['String']['input']>
  imageSource?: InputMaybe<ImageSource>
  isVideo?: InputMaybe<Scalars['Boolean']['input']>
  mediaType?: InputMaybe<Scalars['String']['input']>
  message: Scalars['String']['input']
  platforms: Array<SocialMediaType>
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>
  textKind: Scalars['String']['input']
  topicId: Scalars['ID']['input']
  url?: InputMaybe<Scalars['String']['input']>
}

export type PostToSocialMediaMultiCompany = {
  __typename?: 'PostToSocialMediaMultiCompany'
  postingBatchId?: Maybe<Scalars['ID']['output']>
  postingOperationId?: Maybe<Scalars['ID']['output']>
  posts?: Maybe<Array<Maybe<SocialMediaPost>>>
  savedContentId?: Maybe<Scalars['ID']['output']>
  scheduledAt?: Maybe<Scalars['DateTime']['output']>
  targetOverview?: Maybe<Array<Maybe<CompanyTargetOverview>>>
}

export type PostToSocialMediaMultiCompanyInput = {
  carouselImages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  customLink?: InputMaybe<Scalars['String']['input']>
  /** When set, each platform uses its own time; scheduledAt is ignored for per-platform delays. */
  customSchedules?: InputMaybe<Array<CustomScheduleInput>>
  imageLink?: InputMaybe<Scalars['String']['input']>
  imageSource?: InputMaybe<ImageSource>
  instagramText?: InputMaybe<Scalars['String']['input']>
  isMasterView?: InputMaybe<Scalars['Boolean']['input']>
  isVideo?: InputMaybe<Scalars['Boolean']['input']>
  linkedinText?: InputMaybe<Scalars['String']['input']>
  mediaType?: InputMaybe<Scalars['String']['input']>
  message: Scalars['String']['input']
  modelName?: InputMaybe<Scalars['String']['input']>
  notConnectedCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  platforms: Array<SocialMediaType>
  postToAllCompanies?: InputMaybe<Scalars['Boolean']['input']>
  postToMaster?: InputMaybe<Scalars['Boolean']['input']>
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>
  targetLinkOption: TargetLinkOption
  textKind: Scalars['String']['input']
  topicId: Scalars['ID']['input']
}

export type PostToSocialMediaResult = {
  __typename?: 'PostToSocialMediaResult'
  postingOperationId?: Maybe<Scalars['ID']['output']>
}

export enum PostType {
  Download = 'download',
  FacebookPost = 'facebookPost',
  GoogleBusinessNewspost = 'googleBusinessNewspost',
  InstagramPost = 'instagramPost',
  LinkedinPost = 'linkedinPost',
}

export type PostalShipping = {
  __typename?: 'PostalShipping'
  activeLandingpages?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  allGuides?: Maybe<Scalars['Boolean']['output']>
  type?: Maybe<PostalShippingType>
}

export type PostalShippingInput = {
  activeLandingpages: Array<InputMaybe<Scalars['String']['input']>>
  allGuides?: InputMaybe<Scalars['Boolean']['input']>
  companyId: Scalars['ID']['input']
  type: PostalShippingType
}

export enum PostalShippingType {
  Automatic = 'AUTOMATIC',
  Manual = 'MANUAL',
  None = 'NONE',
}

export type PotentialMaterialGenerationCount = {
  __typename?: 'PotentialMaterialGenerationCount'
  BRAND_EASY?: Maybe<Scalars['String']['output']>
  CREATIFY?: Maybe<Scalars['String']['output']>
  S3_VIDEO?: Maybe<Scalars['String']['output']>
  STATIC?: Maybe<Scalars['String']['output']>
}

export type PreConversion = {
  __typename?: 'PreConversion'
  companyId?: Maybe<Scalars['ID']['output']>
  id?: Maybe<Scalars['ID']['output']>
  landingpage?: Maybe<Landingpage>
  landingpageId?: Maybe<Scalars['ID']['output']>
  type?: Maybe<PreConversionType>
}

export enum PreConversionType {
  Quiz = 'QUIZ',
}

export type PrepareStockImageForEditInput = {
  externalId: Scalars['String']['input']
  provider: Scalars['String']['input']
  topicId: Scalars['ID']['input']
}

export type PrepareStockImageForEditPayload = {
  __typename?: 'PrepareStockImageForEditPayload'
  canEdit: Scalars['Boolean']['output']
  isAlreadyLicensed: Scalars['Boolean']['output']
  originalImageUrl: Scalars['String']['output']
  stockImage: StockImage
}

/** Presigned S3 upload URL data returned by request*UploadUrl mutations. */
export type PresignedUploadData = {
  __typename?: 'PresignedUploadData'
  /** When the presigned URL expires (15 minutes from issuance). */
  expiresAt: Scalars['DateTime']['output']
  /** S3 object key to pass back in the corresponding confirm mutation. */
  s3Key: Scalars['String']['output']
  /** Presigned PUT URL. The FE must include the x-amz-acl: public-read header when uploading. */
  uploadUrl: Scalars['String']['output']
}

export type PreviewFile = {
  __typename?: 'PreviewFile'
  id: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
  url: Scalars['String']['output']
}

export type PriceHubbleDossier = {
  __typename?: 'PriceHubbleDossier'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id?: Maybe<Scalars['String']['output']>
  url?: Maybe<Scalars['String']['output']>
}

export type PriceListItem = {
  __typename?: 'PriceListItem'
  discountPercentage?: Maybe<Scalars['Float']['output']>
  name?: Maybe<PriceListItemName>
  price?: Maybe<ProductPrice>
}

export type PriceListItemInput = {
  discountPercentage?: InputMaybe<Scalars['Float']['input']>
  name: PriceListItemName
  price: ProductPriceInput
}

export enum PriceListItemName {
  At = 'AT',
  Ch = 'CH',
  Remax = 'REMAX',
  Standard = 'STANDARD',
  Voba = 'VOBA',
}

export type PricesForCompanyInput = {
  companyId: Scalars['ID']['input']
  readableIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type Product = {
  __typename?: 'Product'
  abacusId?: Maybe<Scalars['String']['output']>
  cancellation?: Maybe<Cancellation>
  cancelledAt?: Maybe<Scalars['DateTime']['output']>
  condition?: Maybe<Condition>
  contract?: Maybe<Contract>
  discountPercentage?: Maybe<Scalars['Float']['output']>
  endDate?: Maybe<Scalars['DateTime']['output']>
  id?: Maybe<Scalars['ID']['output']>
  minUntilDate?: Maybe<Scalars['DateTime']['output']>
  monthly?: Maybe<Scalars['Boolean']['output']>
  name?: Maybe<Scalars['String']['output']>
  note?: Maybe<Scalars['String']['output']>
  readableId?: Maybe<Scalars['String']['output']>
  startDate?: Maybe<Scalars['DateTime']['output']>
  template?: Maybe<ProductTemplate>
  type?: Maybe<ProductType>
  wasPaidInAdvance?: Maybe<Scalars['Boolean']['output']>
}

export type ProductPrice = {
  __typename?: 'ProductPrice'
  currency?: Maybe<Currency>
  value?: Maybe<Scalars['String']['output']>
}

export type ProductPriceInput = {
  currency: Currency
  value: Scalars['String']['input']
}

export type ProductTemplate = {
  __typename?: 'ProductTemplate'
  abacusId?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['ID']['output']>
  minDuration?: Maybe<Array<Maybe<Duration>>>
  monthly?: Maybe<Scalars['Boolean']['output']>
  name?: Maybe<Scalars['String']['output']>
  prices?: Maybe<Array<Maybe<PriceListItem>>>
  readableId?: Maybe<Scalars['String']['output']>
  setupTemplate?: Maybe<Scalars['ID']['output']>
  type?: Maybe<ProductType>
}

export enum ProductType {
  Basic = 'BASIC',
  Credit = 'CREDIT',
  Expert = 'EXPERT',
  Extension = 'EXTENSION',
  Generation = 'GENERATION',
  Light = 'LIGHT',
  Performance = 'PERFORMANCE',
  ReminderFee = 'REMINDER_FEE',
  Setup = 'SETUP',
  Training = 'TRAINING',
  Website = 'WEBSITE',
}

export type PropertyAddress = {
  __typename?: 'PropertyAddress'
  city?: Maybe<Scalars['String']['output']>
  country?: Maybe<Scalars['String']['output']>
  lat?: Maybe<Scalars['Float']['output']>
  lng?: Maybe<Scalars['Float']['output']>
  postcode?: Maybe<Scalars['String']['output']>
  street?: Maybe<Scalars['String']['output']>
  streetNumber?: Maybe<Scalars['String']['output']>
}

export type PropertyAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  lat?: InputMaybe<Scalars['Float']['input']>
  lng?: InputMaybe<Scalars['Float']['input']>
  postcode?: InputMaybe<Scalars['String']['input']>
  street?: InputMaybe<Scalars['String']['input']>
  streetNumber?: InputMaybe<Scalars['String']['input']>
}

export type PropertyCoordinates = {
  __typename?: 'PropertyCoordinates'
  lat?: Maybe<Scalars['Float']['output']>
  lng?: Maybe<Scalars['Float']['output']>
}

export type PropertyCoordinatesInput = {
  lat?: InputMaybe<Scalars['Float']['input']>
  lng?: InputMaybe<Scalars['Float']['input']>
}

export type PropertyInput = {
  address?: InputMaybe<PropertyAddressInput>
  annualRentIncome?: InputMaybe<Scalars['Int']['input']>
  balconyArea?: InputMaybe<Scalars['Float']['input']>
  buildingYear?: InputMaybe<Scalars['Int']['input']>
  condition?: InputMaybe<Scalars['String']['input']>
  floorNumber?: InputMaybe<Scalars['Int']['input']>
  gardenArea?: InputMaybe<Scalars['Float']['input']>
  landArea?: InputMaybe<Scalars['Float']['input']>
  livingArea?: InputMaybe<Scalars['Float']['input']>
  numberOfUnits?: InputMaybe<Scalars['Int']['input']>
  quality?: InputMaybe<Scalars['String']['input']>
  rooms?: InputMaybe<Scalars['Float']['input']>
  subtype?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
}

export type PropertyRequest = {
  __typename?: 'PropertyRequest'
  availableStartDate: AvailableStartDate
  currentLivingSituation?: Maybe<LivingSituation>
  financing?: Maybe<Financing>
  property: PropertyRequestProperty
}

export type PropertyRequestProperty = {
  __typename?: 'PropertyRequestProperty'
  accessibility: Accessibility
  location: Location
  maxPrice: Scalars['Int']['output']
  minNumberOfBathrooms: Scalars['Int']['output']
  minNumberOfParkingSpaces: Scalars['Int']['output']
  minNumberOfRooms: Scalars['Int']['output']
  minPrice: Scalars['Int']['output']
  outdoorArea?: Maybe<OutdoorArea>
  residentialArea?: Maybe<ResidentialArea>
  subType?: Maybe<PropertySubType>
  surroundings: Array<Surroundings>
  type?: Maybe<PropertyType>
}

export enum PropertySubType {
  ApartmentAttic = 'APARTMENT_ATTIC',
  ApartmentMaisonette = 'APARTMENT_MAISONETTE',
  ApartmentNormal = 'APARTMENT_NORMAL',
  ApartmentPenthouse = 'APARTMENT_PENTHOUSE',
  ApartmentStudio = 'APARTMENT_STUDIO',
  ApartmentTerraced = 'APARTMENT_TERRACED',
  HouseDetached = 'HOUSE_DETACHED',
  HouseFarm = 'HOUSE_FARM',
  HouseRowCorner = 'HOUSE_ROW_CORNER',
  HouseRowMiddle = 'HOUSE_ROW_MIDDLE',
  HouseSemiDetached = 'HOUSE_SEMI_DETACHED',
}

export enum PropertyType {
  Apartment = 'APARTMENT',
  House = 'HOUSE',
  MultiFamilyHouse = 'MULTI_FAMILY_HOUSE',
}

export type PropstackBroker = {
  __typename?: 'PropstackBroker'
  email?: Maybe<Scalars['String']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  lastName?: Maybe<Scalars['String']['output']>
}

export type PropstackChildMultiCompanyConfig = {
  __typename?: 'PropstackChildMultiCompanyConfig'
  companyId: Scalars['ID']['output']
  defaultExportBrokerId?: Maybe<Scalars['Int']['output']>
  teamId?: Maybe<Scalars['String']['output']>
}

export type PropstackChildSyncStatus = {
  __typename?: 'PropstackChildSyncStatus'
  allUsersMapped: Scalars['Boolean']['output']
  defaultExportBrokerId?: Maybe<Scalars['Int']['output']>
  hasDefaultExportBroker: Scalars['Boolean']['output']
  unmappedUserCount: Scalars['Int']['output']
}

export type PropstackChildTeamAssignmentInput = {
  childCompanyId: Scalars['ID']['input']
  parentCompanyId: Scalars['ID']['input']
  teamId: Scalars['String']['input']
}

export type PropstackConfig = {
  __typename?: 'PropstackConfig'
  isManagedByParent?: Maybe<Scalars['Boolean']['output']>
  isMultiCompanyParent?: Maybe<Scalars['Boolean']['output']>
  isTokenVerified?: Maybe<Scalars['Boolean']['output']>
  selectedContactStatusIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>
  selectedGroupIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>
  teamId?: Maybe<Scalars['String']['output']>
  token?: Maybe<Scalars['String']['output']>
}

export type PropstackContactCount = {
  __typename?: 'PropstackContactCount'
  countPerStatus?: Maybe<Scalars['JSONObject']['output']>
}

export type PropstackContactStatus = {
  __typename?: 'PropstackContactStatus'
  id?: Maybe<Scalars['ID']['output']>
  name?: Maybe<Scalars['String']['output']>
}

export type PropstackCredentialsInput = {
  token?: InputMaybe<Scalars['String']['input']>
}

export type PropstackGroup = {
  __typename?: 'PropstackGroup'
  id?: Maybe<Scalars['ID']['output']>
  name?: Maybe<Scalars['String']['output']>
}

export type PropstackGroupCount = {
  __typename?: 'PropstackGroupCount'
  countPerGroup?: Maybe<Scalars['JSONObject']['output']>
}

export type PropstackSelectedContactStatusesInput = {
  companyId: Scalars['ID']['input']
  selectedContactStatusIds: Array<Scalars['ID']['input']>
}

export type PropstackSelectedGroupIdsInput = {
  companyId: Scalars['ID']['input']
  selectedGroupIds: Array<Scalars['ID']['input']>
}

export type PropstackTeam = {
  __typename?: 'PropstackTeam'
  id: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
}

export type PropstackUserBrokerEntry = {
  __typename?: 'PropstackUserBrokerEntry'
  isAutoMapped: Scalars['Boolean']['output']
  propstackBrokerIds: Array<Scalars['Int']['output']>
  userId: Scalars['ID']['output']
}

export type PropstackUserBrokerEntryInput = {
  propstackBrokerIds: Array<Scalars['Int']['input']>
  userId: Scalars['ID']['input']
}

export type PropstackUserBrokerMappingInput = {
  companyId: Scalars['ID']['input']
  userBrokerMapping: Array<PropstackUserBrokerEntryInput>
}

export type PurchaseProperty = {
  __typename?: 'PurchaseProperty'
  address?: Maybe<PurchasePropertyAddress>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  dossier?: Maybe<PriceHubbleDossier>
  id?: Maybe<Scalars['ID']['output']>
  landingpageAccessCode?: Maybe<Scalars['String']['output']>
  lead?: Maybe<Scalars['ID']['output']>
  purchaseDate?: Maybe<Scalars['DateTime']['output']>
  purchasePrice?: Maybe<Scalars['Int']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type PurchasePropertyAddress = {
  __typename?: 'PurchasePropertyAddress'
  city?: Maybe<Scalars['String']['output']>
  countryCode?: Maybe<CountryCode>
  houseNumber?: Maybe<Scalars['String']['output']>
  lat?: Maybe<Scalars['Float']['output']>
  lng?: Maybe<Scalars['Float']['output']>
  street?: Maybe<Scalars['String']['output']>
  zip?: Maybe<Scalars['String']['output']>
}

export type Query = {
  __typename?: 'Query'
  adMaterials?: Maybe<PaginatedAdMaterial>
  aiSettings?: Maybe<AiSettings>
  analyticsImpressionForCompany?: Maybe<AnalyticsImpressionForCompany>
  /**
   * Load the persisted conversation messages for a given thread.
   * threadKey is ignored server-side — the session is always keyed by company ID.
   * Returns null if no session exists yet.
   */
  assistantConversation?: Maybe<AssistantConversation>
  /**
   * Full onboarding session payload from Genaisis (same shape as GET /onboarding/session/{id}).
   * Returns null if no session exists yet (upstream 404).
   */
  assistantOnboardingState?: Maybe<Scalars['JSON']['output']>
  availableCampaigns?: Maybe<Array<Maybe<Campaign>>>
  billingAdminDetails?: Maybe<BillingAdminDetails>
  billingOnboardingDetails?: Maybe<BillingOnboardingDetails>
  billingSelfServicePortalDetails?: Maybe<BillingDetails>
  blockedLandingpagesSlugsForInvitation?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  bookableLandingpageTemplates?: Maybe<Array<Maybe<LandingpageTemplate>>>
  bookableSalesPlans?: Maybe<Array<Maybe<BookableSalesPlans>>>
  bookedCampaigns?: Maybe<Array<Maybe<Campaign>>>
  calendarSyncSettings: CalendarSyncSettings
  calendarSyncSettingsPerUser?: Maybe<Array<CalendarSyncSettingsPerUser>>
  campaign?: Maybe<Campaign>
  campaignJobCount?: Maybe<CampaignJobCount>
  campaignMaterialTemplates?: Maybe<Array<Maybe<MaterialTemplate>>>
  campaignMaterials?: Maybe<Array<Maybe<CampaignMaterial>>>
  campaignVideoDirectories?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  campaigns?: Maybe<Array<Maybe<Campaign>>>
  casaoneConfig?: Maybe<CasaoneConfig>
  childCompanies?: Maybe<Array<Maybe<Company>>>
  childCompaniesWithLocation?: Maybe<Array<Maybe<ChildCompanyLocation>>>
  clientAdvisors?: Maybe<Array<Maybe<ClientAdvisor>>>
  companies?: Maybe<Array<Maybe<Company>>>
  company?: Maybe<Company>
  companyContactPersons?: Maybe<Array<Maybe<CompanyContactPerson>>>
  componentPrice?: Maybe<ComponentPrice>
  contactGroups?: Maybe<Array<Maybe<PropstackGroup>>>
  contactStatuses?: Maybe<Array<Maybe<PropstackContactStatus>>>
  conversion?: Maybe<Conversion>
  countMaterialsInGeneration?: Maybe<Scalars['Int']['output']>
  customerGuide?: Maybe<CustomerGuide>
  customerGuideDraft: CustomerGuideDraft
  dailyAnalyticsImpressionForCompany?: Maybe<DailyAnalyticsImpressionForCompany>
  dailyAnalyticsImpressions?: Maybe<Array<Maybe<DailyAnalyticsImpressions>>>
  defaultLandingpageTemplates?: Maybe<Array<Maybe<LandingpageTemplate>>>
  emailChangeRequest?: Maybe<Scalars['String']['output']>
  emproConfig?: Maybe<EmproConfig>
  emproContactStatuses?: Maybe<Array<Maybe<EmproContactStatuses>>>
  emproContactTypes?: Maybe<Array<Maybe<EmproContactTypes>>>
  emproContactsCount?: Maybe<EmproContactCount>
  exportCampaign?: Maybe<Scalars['JSONObject']['output']>
  /** @deprecated No longer supported */
  featurePermission?: Maybe<FeaturePermission>
  /** @deprecated No longer supported */
  featurePermissions?: Maybe<Array<Maybe<FeaturePermission>>>
  features?: Maybe<Array<Maybe<Feature>>>
  featuresForCompany?: Maybe<Array<Maybe<Feature>>>
  flowfactConfig?: Maybe<FlowfactConfig>
  flowfactContactTags?: Maybe<Array<Maybe<FlowfactContactTag>>>
  flowfactContactsCount?: Maybe<FlowfactContactCount>
  generateCustomerConnectionCsv?: Maybe<Scalars['String']['output']>
  generateCustomerStatusCsv?: Maybe<Scalars['String']['output']>
  generatedTopicMaterialBundles: Array<GeneratedTopicMaterialBundle>
  getAcquisitionBoosterLeadIds?: Maybe<LeadIds>
  getActiveTopics?: Maybe<Array<Maybe<Topic>>>
  getAdMaterials?: Maybe<AdMaterialsResponse>
  getAllActivities?: Maybe<AllActivities>
  getAllLeadActivities?: Maybe<AllLeadActivities>
  getAllSavedContents?: Maybe<SavedContents>
  getCampaignList?: Maybe<Array<Maybe<Campaign>>>
  getChildCrmCompaniesWithProvider: Array<CrmChildCompanyConfig>
  getChildCrmCompanyConfig?: Maybe<CrmCompanyConfig>
  getCmsOrganization?: Maybe<CmsOrganization>
  getCompaniesPostingInfo?: Maybe<Array<Maybe<CompaniesPostingInfo>>>
  getCompanyAutoRepliedStatistics?: Maybe<CompanyEmailAutoReply>
  getCompanyDashboard?: Maybe<Scalars['String']['output']>
  getCompanyEmailFunnelsBounceStatistics?: Maybe<CompanyEmailFunnelsBounceStatistics>
  getCompanyEmailFunnelsSentCounts?: Maybe<CompanyEmailFunnelsSentCountsStatistics>
  getCompanyEmailFunnelsStatistics?: Maybe<CompanyEmailFunnelsStatistics>
  getCompanyScores?: Maybe<CompanyScores>
  getComponentSubscriptionsCountBySlug?: Maybe<Scalars['Int']['output']>
  getCreatedContentsStatistics?: Maybe<CreatedContentsStatistics>
  getCrmCompanyConfig?: Maybe<CrmCompanyConfig>
  getCurrentOnboardingStep?: Maybe<OnboardingStep>
  getCustomFields?: Maybe<Array<Maybe<CustomField>>>
  /** @deprecated use leadIds instead */
  getDeleteLeadsLeadIds?: Maybe<LeadIds>
  getDunningLevelForCompany?: Maybe<Scalars['Int']['output']>
  getFacebookPages?: Maybe<Array<Maybe<FacebookPage>>>
  getFailedSocialMediaPosts?: Maybe<FailedSocialMediaPosts>
  /** @deprecated No longer supported */
  getFilteredLeadIdsWithOutstandingPropertyTracker?: Maybe<GetFilteredLeadIdsWithOutstandingPropertyTrackerResult>
  getGeneratedImages?: Maybe<GeneratedImages>
  getGenerationStats?: Maybe<GenerationStats>
  getGoogleBusinessLocations?: Maybe<Array<Maybe<GoogleBusinessLocation>>>
  getGooglePlaceDetails?: Maybe<GooglePlaceDetails>
  getGooglePlaces?: Maybe<Array<Maybe<GooglePlace>>>
  getLandingpage?: Maybe<Landingpage>
  getLandingpageBySlug?: Maybe<Landingpage>
  getLandingpageByType?: Maybe<Landingpage>
  getLandingpageTemplate?: Maybe<LandingpageTemplate>
  getLastGeneratedText?: Maybe<GeneratedText>
  getLeadSuggestions?: Maybe<Array<Maybe<Lead>>>
  getLeadsPipelineStatuses?: Maybe<Array<Maybe<LeadsPipelineStatus>>>
  getLeadsStatusesStatistics?: Maybe<Array<Maybe<LeadsStatusesStatistics>>>
  /** Static campaign materials for LIGHT product. Returns empty for non-LIGHT users. */
  getLightCampaignMaterials: Array<LightCampaign>
  getLinkedinOrganizations?: Maybe<Array<Maybe<LinkedinOrganization>>>
  getMarketingPlan?: Maybe<MarketingPlan>
  /** Every open plan for the company, oldest start date first. */
  getMarketingPlans: Array<MarketingPlan>
  getMasterBatchPosts: Array<SavedContentPost>
  getNewsletterDeliveryDetails?: Maybe<NewsletterDeliveryDetails>
  getNewsletterOfficeDistribution?: Maybe<NewsletterOfficeDistribution>
  getNumberOfLandingpages?: Maybe<Scalars['Int']['output']>
  getNumberOfPosts?: Maybe<Scalars['Int']['output']>
  getOnboardingBillingData?: Maybe<OnboardingBillingData>
  getOrderForCompany?: Maybe<Order>
  getParentCrmCompanyConfig?: Maybe<CrmCompanyConfig>
  getPendingDowngrade?: Maybe<PendingDowngrade>
  getQuizPreConversion?: Maybe<QuizPreConversion>
  getQuizzardForLandingpageTemplate?: Maybe<Quizzard>
  getSavedContentById?: Maybe<SavedContent>
  getSavedContents?: Maybe<SavedContents>
  getScheduledContents?: Maybe<ScheduledContents>
  getSocialMediaActiveConnections?: Maybe<Array<Maybe<SocialMediaActiveConnections>>>
  getSocialMediaConnections?: Maybe<Array<Maybe<SocialMediaType>>>
  getStockPhotos?: Maybe<PhotoList>
  getToDos?: Maybe<Array<Maybe<ToDo>>>
  getTopTopicsCombinedUsage?: Maybe<Array<Maybe<TopicUsage>>>
  getTopic?: Maybe<Topic>
  getTopics?: Maybe<Array<Maybe<Topic>>>
  getUserImages?: Maybe<UserImages>
  getValuation?: Maybe<Valuation>
  getValuationInputLimits?: Maybe<ValuationInputLimits>
  getValuationsPaginated?: Maybe<ValuationsPaginated>
  googleBusinessConnectionStatus?: Maybe<GoogleBusinessConnectionStatus>
  hasChildCompany?: Maybe<Scalars['Boolean']['output']>
  hasImportedLeads?: Maybe<Scalars['Boolean']['output']>
  hasParentCompany?: Maybe<Scalars['Boolean']['output']>
  hoppermationDefaultSender?: Maybe<HoppermationSender>
  hoppermationDomain?: Maybe<HoppermationDomain>
  hoppermationOrganization?: Maybe<HoppermationOrganization>
  hoppermationSenders?: Maybe<Array<Maybe<HoppermationSender>>>
  hubspotUserIdentification?: Maybe<HubspotUserIdentification>
  identity?: Maybe<Identity>
  inactiveEmailUsers?: Maybe<Array<Maybe<User>>>
  invitationStatisticsForCompany?: Maybe<InvitationStatisitcsForCompany>
  isLastRegenerationFinished?: Maybe<Scalars['Boolean']['output']>
  isStockPhotoLicensed?: Maybe<LicensedStockPhoto>
  isSubscribedToNewsletter?: Maybe<Scalars['Boolean']['output']>
  konstantine: KonstantineQuery
  landingpageSlugsUsedForInvitation?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  landingpageTemplates?: Maybe<Array<Maybe<LandingpageTemplate>>>
  landingpageTemplatesForCompany?: Maybe<Array<Maybe<LandingpageTemplate>>>
  lead?: Maybe<Lead>
  leadIds?: Maybe<LeadIds>
  leadInteractivityStat?: Maybe<Array<Maybe<LeadInteractivityWeek>>>
  leadTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** @deprecated No longer supported */
  leadWithPropertyTrackerByAccessCode?: Maybe<Lead>
  /** @deprecated No longer supported */
  leadWithPropertyTrackerByTrackerId?: Maybe<Lead>
  leads?: Maybe<PaginatedLeads>
  leadsMaster?: Maybe<PaginatedLeads>
  leadsWithLocation?: Maybe<Array<Maybe<Lead>>>
  mainCompaniesForCorporate?: Maybe<Array<Maybe<Company>>>
  materialGenerationProgress: MaterialGenerationProgress
  materialMakerGenerationRecipes: Array<MaterialMakerGenerationRecipe>
  materialSet?: Maybe<MaterialSet>
  /** Internal, content-free provenance for one customer material. */
  materialTraceHistory: Array<MaterialTraceEvent>
  materials?: Maybe<Array<Maybe<Material>>>
  materialsFiltered?: Maybe<Array<Maybe<Material>>>
  materialsForContentCreator?: Maybe<Array<Maybe<Material>>>
  message?: Maybe<EmailMessage>
  nextMessage?: Maybe<EmailMessage>
  nextMessages?: Maybe<Array<Maybe<EmailMessage>>>
  onboardingDocuments?: Maybe<Array<Maybe<ContractDocument>>>
  onboardingMaterialPreview?: Maybe<Array<Maybe<MaterialPreview>>>
  onofficeConfig?: Maybe<OnofficeConfig>
  onofficeContactTypes?: Maybe<Array<Maybe<OnofficeContactType>>>
  onofficeContactsCount?: Maybe<Scalars['Int']['output']>
  onofficeContactsCountByType?: Maybe<OnofficeContactsCountByType>
  onofficeSharedConfigs?: Maybe<Array<Maybe<OnofficeSharedConfig>>>
  parseDataFromWebsite?: Maybe<ParsedWebsiteData>
  pendingChangesForRegeneration?: Maybe<Scalars['JSONObject']['output']>
  permissions?: Maybe<Array<Maybe<Permission>>>
  potentialMaterialGenerationCount?: Maybe<PotentialMaterialGenerationCount>
  pricesForCompany?: Maybe<Array<Maybe<CompanyPrice>>>
  productTemplates?: Maybe<Array<Maybe<ProductTemplate>>>
  products?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  propstackChildSyncStatus?: Maybe<PropstackChildSyncStatus>
  propstackChildrenMultiCompanyConfig?: Maybe<Array<Maybe<PropstackChildMultiCompanyConfig>>>
  propstackConfig?: Maybe<PropstackConfig>
  propstackContactsCount?: Maybe<PropstackContactCount>
  propstackGroupsCount?: Maybe<PropstackGroupCount>
  propstackTeamBrokers?: Maybe<Array<Maybe<PropstackBroker>>>
  propstackTeams?: Maybe<Array<Maybe<PropstackTeam>>>
  propstackUserBrokerMapping?: Maybe<Array<Maybe<PropstackUserBrokerEntry>>>
  regenerationConditions?: Maybe<RegenerationConditions>
  role?: Maybe<Role>
  roles?: Maybe<Array<Maybe<Role>>>
  salesPersons?: Maybe<Array<Maybe<SalesPerson>>>
  settings?: Maybe<Settings>
  socialMediaPostingStatus: SocialMediaPostingStatusResult
  statistics?: Maybe<Statistics>
  topicMaterialBundle?: Maybe<TopicMaterialBundle>
  totalTrafficBySourceForCompany?: Maybe<Array<Maybe<TrafficCount>>>
  totalTrafficByUtmSourceForCompany?: Maybe<Array<Maybe<UtmTrafficCount>>>
  userWithNotificationSettings?: Maybe<UserSettings>
  users?: Maybe<Array<Maybe<User>>>
  utmParameters?: Maybe<UtmParametersResponse>
  validatedFileImportData?: Maybe<ValidatedFileImportData>
  zipcodesForCompany?: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export type QueryAdMaterialsArgs = {
  input: GetAdMaterialsInput
}

export type QueryAnalyticsImpressionForCompanyArgs = {
  input: GetAnalyticsImpressionInput
}

export type QueryAssistantConversationArgs = {
  threadKey?: InputMaybe<Scalars['String']['input']>
}

export type QueryAssistantOnboardingStateArgs = {
  formFields?: InputMaybe<Scalars['JSON']['input']>
  waitForScrape?: InputMaybe<Scalars['Boolean']['input']>
}

export type QueryAvailableCampaignsArgs = {
  companyId: Scalars['ID']['input']
}

export type QueryBillingAdminDetailsArgs = {
  companyId: Scalars['ID']['input']
}

export type QueryBillingOnboardingDetailsArgs = {
  companyId: Scalars['ID']['input']
}

export type QueryBlockedLandingpagesSlugsForInvitationArgs = {
  input: BlockedLandingpageTemplatesForInvitationInput
}

export type QueryBookableLandingpageTemplatesArgs = {
  companyId: Scalars['ID']['input']
}

export type QueryBookableSalesPlansArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>
}

export type QueryBookedCampaignsArgs = {
  companyId: Scalars['ID']['input']
}

export type QueryCalendarSyncSettingsPerUserArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryCampaignArgs = {
  campaignId: Scalars['ID']['input']
}

export type QueryCampaignJobCountArgs = {
  campaignId: Scalars['ID']['input']
}

export type QueryCampaignMaterialTemplatesArgs = {
  campaignId: Scalars['ID']['input']
}

export type QueryCampaignMaterialsArgs = {
  campaignId: Scalars['ID']['input']
}

export type QueryCampaignVideoDirectoriesArgs = {
  campaignId: Scalars['ID']['input']
}

export type QueryCasaoneConfigArgs = {
  companyId: Scalars['ID']['input']
}

export type QueryChildCompaniesArgs = {
  parentId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryChildCompaniesWithLocationArgs = {
  parentId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryCompaniesArgs = {
  platform?: InputMaybe<Platform>
}

export type QueryCompanyArgs = {
  id?: InputMaybe<Scalars['String']['input']>
}

export type QueryCompanyContactPersonsArgs = {
  companyId: Scalars['ID']['input']
}

export type QueryComponentPriceArgs = {
  slug: Scalars['String']['input']
}

export type QueryContactGroupsArgs = {
  companyId: Scalars['ID']['input']
}

export type QueryContactStatusesArgs = {
  companyId: Scalars['ID']['input']
}

export type QueryConversionArgs = {
  conversionId: Scalars['ID']['input']
}

export type QueryCountMaterialsInGenerationArgs = {
  companyId: Scalars['ID']['input']
}

export type QueryCustomerGuideArgs = {
  materialId: Scalars['ID']['input']
}

export type QueryCustomerGuideDraftArgs = {
  materialId: Scalars['ID']['input']
}

export type QueryDailyAnalyticsImpressionForCompanyArgs = {
  input: GetDailyAnalyticsImpressionInput
}

export type QueryDailyAnalyticsImpressionsArgs = {
  input: GetDailyAnalyticsImpressionInput
}

export type QueryDefaultLandingpageTemplatesArgs = {
  companyId: Scalars['ID']['input']
}

export type QueryEmailChangeRequestArgs = {
  id: Scalars['ID']['input']
}

export type QueryEmproContactsCountArgs = {
  input: EmproSelectedContactStatusesInput
}

export type QueryExportCampaignArgs = {
  campaignId: Scalars['ID']['input']
}

export type QueryFeaturePermissionArgs = {
  name: FeatureName
}

export type QueryFeaturesForCompanyArgs = {
  companyId: Scalars['ID']['input']
}

export type QueryFlowfactConfigArgs = {
  companyId: Scalars['ID']['input']
}

export type QueryFlowfactContactTagsArgs = {
  companyId: Scalars['ID']['input']
}

export type QueryFlowfactContactsCountArgs = {
  input: FlowfactSelectedContactStatusesInput
}

export type QueryGenerateCustomerConnectionCsvArgs = {
  platform: Scalars['String']['input']
}

export type QueryGenerateCustomerStatusCsvArgs = {
  platform: Scalars['String']['input']
}

export type QueryGeneratedTopicMaterialBundlesArgs = {
  companyId: Scalars['ID']['input']
}

export type QueryGetAcquisitionBoosterLeadIdsArgs = {
  input: GetAcquisitionBoosterLeadIdsInput
}

export type QueryGetAdMaterialsArgs = {
  filter?: InputMaybe<AdMaterialsFilterInput>
}

export type QueryGetAllActivitiesArgs = {
  input: GetAllActivitiesInput
}

export type QueryGetAllLeadActivitiesArgs = {
  input: GetAllLeadActivitiesInput
}

export type QueryGetAllSavedContentsArgs = {
  input: GetAllSavedContentsInput
}

export type QueryGetChildCrmCompanyConfigArgs = {
  companyId: Scalars['ID']['input']
}

export type QueryGetCmsOrganizationArgs = {
  companyId: Scalars['ID']['input']
}

export type QueryGetCompaniesPostingInfoArgs = {
  input: CompaniesPostingInfoInput
}

export type QueryGetCompanyAutoRepliedStatisticsArgs = {
  input: CompanyEmailFunnelsBounceInput
}

export type QueryGetCompanyDashboardArgs = {
  companyId: Scalars['ID']['input']
}

export type QueryGetCompanyEmailFunnelsBounceStatisticsArgs = {
  input: CompanyEmailFunnelsBounceInput
}

export type QueryGetCompanyEmailFunnelsSentCountsArgs = {
  input: CompanyEmailFunnelsBounceInput
}

export type QueryGetCompanyEmailFunnelsStatisticsArgs = {
  input: GetEmailFunnelsStatisticsInput
}

export type QueryGetComponentSubscriptionsCountBySlugArgs = {
  input: GetComponentSubscriptionsCountBySlugInput
}

export type QueryGetCreatedContentsStatisticsArgs = {
  input: GetCreatedContentsStatisticsInput
}

export type QueryGetCrmCompanyConfigArgs = {
  companyId: Scalars['ID']['input']
}

export type QueryGetDeleteLeadsLeadIdsArgs = {
  input: GetDeleteLeadsLeadIdsInput
}

export type QueryGetDunningLevelForCompanyArgs = {
  companyId: Scalars['ID']['input']
}

export type QueryGetFacebookPagesArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryGetFailedSocialMediaPostsArgs = {
  input: GetFailedSocialMediaPostsInput
}

export type QueryGetFilteredLeadIdsWithOutstandingPropertyTrackerArgs = {
  input: GetFilteredLeadIdsWithOutstandingPropertyTrackerInput
}

export type QueryGetGeneratedImagesArgs = {
  input: GetGeneratedImagesInput
}

export type QueryGetGoogleBusinessLocationsArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryGetGooglePlaceDetailsArgs = {
  input: GooglePlaceDetailsInput
}

export type QueryGetGooglePlacesArgs = {
  input: GooglePlacesInput
}

export type QueryGetLandingpageArgs = {
  input: GetLandingpageInput
}

export type QueryGetLandingpageBySlugArgs = {
  input: GetLandingpageBySlugInput
}

export type QueryGetLandingpageByTypeArgs = {
  input: GetLandingpageByTypeInput
}

export type QueryGetLandingpageTemplateArgs = {
  input: GetLandingpageTemplateInput
}

export type QueryGetLastGeneratedTextArgs = {
  input: GetLastGeneratedTextInput
}

export type QueryGetLeadSuggestionsArgs = {
  input: GetLeadSuggestionsInput
}

export type QueryGetLeadsPipelineStatusesArgs = {
  input: GetLeadsPipelineStatusesInput
}

export type QueryGetLeadsStatusesStatisticsArgs = {
  input: GetLeadsStatusesStatisticsInput
}

export type QueryGetLinkedinOrganizationsArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryGetMarketingPlanArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type QueryGetMasterBatchPostsArgs = {
  input: GetMasterBatchPostsInput
}

export type QueryGetNewsletterDeliveryDetailsArgs = {
  input: GetNewsletterDeliveryDetailsInput
}

export type QueryGetNewsletterOfficeDistributionArgs = {
  input: NewsletterOfficeDistributionInput
}

export type QueryGetNumberOfLandingpagesArgs = {
  input: GetNumberOfLandingpagesInput
}

export type QueryGetOrderForCompanyArgs = {
  companyId: Scalars['ID']['input']
}

export type QueryGetPendingDowngradeArgs = {
  companyId: Scalars['ID']['input']
}

export type QueryGetQuizPreConversionArgs = {
  preConversionId: Scalars['ID']['input']
}

export type QueryGetQuizzardForLandingpageTemplateArgs = {
  landingpageTemplateId: Scalars['String']['input']
}

export type QueryGetSavedContentByIdArgs = {
  input: GetSavedContentInput
}

export type QueryGetSavedContentsArgs = {
  input: GetSavedContentsInput
}

export type QueryGetScheduledContentsArgs = {
  input: GetScheduledContentsInput
}

export type QueryGetSocialMediaActiveConnectionsArgs = {
  input?: InputMaybe<SocialMediaActiveConnectionsInput>
}

export type QueryGetSocialMediaConnectionsArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryGetStockPhotosArgs = {
  input: GetStockPhotosInput
}

export type QueryGetToDosArgs = {
  input: GetToDoInput
}

export type QueryGetTopicArgs = {
  id: Scalars['ID']['input']
}

export type QueryGetUserImagesArgs = {
  input: GetUserImagesInput
}

export type QueryGetValuationArgs = {
  input: GetValuationInput
}

export type QueryGetValuationInputLimitsArgs = {
  input: GetValuationInputLimitsInput
}

export type QueryGetValuationsPaginatedArgs = {
  input: GetValuationsPaginatedInput
}

export type QueryGoogleBusinessConnectionStatusArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryHoppermationDefaultSenderArgs = {
  companyId: Scalars['ID']['input']
}

export type QueryHoppermationDomainArgs = {
  companyId: Scalars['ID']['input']
}

export type QueryHoppermationOrganizationArgs = {
  companyId: Scalars['ID']['input']
}

export type QueryHoppermationSendersArgs = {
  companyId: Scalars['ID']['input']
}

export type QueryInvitationStatisticsForCompanyArgs = {
  input: GetInvitationStatisticsInput
}

export type QueryIsLastRegenerationFinishedArgs = {
  companyId: Scalars['ID']['input']
}

export type QueryIsStockPhotoLicensedArgs = {
  input: IsStockPhotoLicensedInput
}

export type QueryLandingpageTemplatesArgs = {
  input?: InputMaybe<GetLandingpageTemplatesInput>
}

export type QueryLandingpageTemplatesForCompanyArgs = {
  input: LandingpageTemplatesForCompanyInput
}

export type QueryLeadArgs = {
  id?: InputMaybe<Scalars['String']['input']>
}

export type QueryLeadIdsArgs = {
  input: LeadIdsInput
}

export type QueryLeadInteractivityStatArgs = {
  companyId: Scalars['String']['input']
}

export type QueryLeadWithPropertyTrackerByAccessCodeArgs = {
  accessCode: Scalars['String']['input']
  companyId: Scalars['ID']['input']
}

export type QueryLeadWithPropertyTrackerByTrackerIdArgs = {
  accessCode: Scalars['String']['input']
  companyId: Scalars['ID']['input']
}

export type QueryLeadsArgs = {
  input: LeadsInput
}

export type QueryLeadsMasterArgs = {
  input: LeadsInput
}

export type QueryLeadsWithLocationArgs = {
  input: GetLeadsWithLocationInput
}

export type QueryMainCompaniesForCorporateArgs = {
  companyId: Scalars['ID']['input']
}

export type QueryMaterialGenerationProgressArgs = {
  materialTemplateId: Scalars['ID']['input']
}

export type QueryMaterialMakerGenerationRecipesArgs = {
  type?: InputMaybe<Scalars['String']['input']>
}

export type QueryMaterialSetArgs = {
  companyId: Scalars['ID']['input']
  materialSetId: Scalars['String']['input']
}

export type QueryMaterialTraceHistoryArgs = {
  companyId: Scalars['ID']['input']
  materialId: Scalars['ID']['input']
}

export type QueryMaterialsArgs = {
  companyId: Scalars['ID']['input']
}

export type QueryMaterialsFilteredArgs = {
  input: MaterialsFilteredInput
}

export type QueryMaterialsForContentCreatorArgs = {
  input: MaterialsForContentCreatorInput
}

export type QueryMessageArgs = {
  id: Scalars['ID']['input']
}

export type QueryNextMessageArgs = {
  contactId: Scalars['ID']['input']
}

export type QueryNextMessagesArgs = {
  input: NextMessagesInput
}

export type QueryOnboardingDocumentsArgs = {
  companyId: Scalars['ID']['input']
}

export type QueryOnboardingMaterialPreviewArgs = {
  companySlug: Scalars['String']['input']
}

export type QueryOnofficeConfigArgs = {
  companyId: Scalars['ID']['input']
}

export type QueryOnofficeContactTypesArgs = {
  companyId: Scalars['ID']['input']
}

export type QueryOnofficeContactsCountArgs = {
  input: OnofficeSelectedContactTypesInput
}

export type QueryParseDataFromWebsiteArgs = {
  input: ParseDataFromWebsiteInput
}

export type QueryPendingChangesForRegenerationArgs = {
  companyId: Scalars['ID']['input']
}

export type QueryPotentialMaterialGenerationCountArgs = {
  input: GenerateCampaignInput
}

export type QueryPricesForCompanyArgs = {
  input?: InputMaybe<PricesForCompanyInput>
}

export type QueryProductsArgs = {
  companyId: Scalars['ID']['input']
}

export type QueryPropstackChildSyncStatusArgs = {
  companyId: Scalars['ID']['input']
}

export type QueryPropstackChildrenMultiCompanyConfigArgs = {
  companyId: Scalars['ID']['input']
}

export type QueryPropstackConfigArgs = {
  companyId: Scalars['ID']['input']
}

export type QueryPropstackContactsCountArgs = {
  input: PropstackSelectedContactStatusesInput
}

export type QueryPropstackGroupsCountArgs = {
  companyId: Scalars['ID']['input']
}

export type QueryPropstackTeamBrokersArgs = {
  companyId: Scalars['ID']['input']
  teamId: Scalars['String']['input']
}

export type QueryPropstackTeamsArgs = {
  companyId: Scalars['ID']['input']
}

export type QueryPropstackUserBrokerMappingArgs = {
  companyId: Scalars['ID']['input']
}

export type QueryRegenerationConditionsArgs = {
  companyId: Scalars['ID']['input']
}

export type QueryRoleArgs = {
  roleId: Scalars['ID']['input']
}

export type QuerySettingsArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>
}

export type QuerySocialMediaPostingStatusArgs = {
  postingOperationId: Scalars['ID']['input']
}

export type QueryStatisticsArgs = {
  input: StatisticsInput
}

export type QueryTopicMaterialBundleArgs = {
  companyId: Scalars['ID']['input']
  landingpageId: Scalars['ID']['input']
}

export type QueryTotalTrafficBySourceForCompanyArgs = {
  input?: InputMaybe<TrafficCountInput>
}

export type QueryTotalTrafficByUtmSourceForCompanyArgs = {
  input?: InputMaybe<TrafficCountInput>
}

export type QueryUserWithNotificationSettingsArgs = {
  id?: InputMaybe<Scalars['String']['input']>
}

export type QueryUsersArgs = {
  input: GetUsersInput
}

export type QueryValidatedFileImportDataArgs = {
  input: ValidatedFileImportDataInput
}

export type QueryZipcodesForCompanyArgs = {
  input?: InputMaybe<ZipcodesForCompanyInput>
}

export type QuestionAndAnswer = {
  __typename?: 'QuestionAndAnswer'
  answer?: Maybe<Scalars['String']['output']>
  question?: Maybe<Scalars['String']['output']>
  screenId?: Maybe<Scalars['String']['output']>
}

export type QuizPreConversion = {
  __typename?: 'QuizPreConversion'
  companyId?: Maybe<Scalars['ID']['output']>
  details?: Maybe<QuizPreConversionDetails>
  id?: Maybe<Scalars['ID']['output']>
  landingpage?: Maybe<Landingpage>
  landingpageId?: Maybe<Scalars['ID']['output']>
  type?: Maybe<PreConversionType>
}

export type QuizPreConversionDetails = {
  __typename?: 'QuizPreConversionDetails'
  answers?: Maybe<Array<Maybe<QuestionAndAnswer>>>
  result?: Maybe<Scalars['String']['output']>
}

export type Quizzard = {
  __typename?: 'Quizzard'
  formId?: Maybe<Scalars['ID']['output']>
  id?: Maybe<Scalars['ID']['output']>
  landingpageTemplateId?: Maybe<Scalars['ID']['output']>
  screens?: Maybe<Array<Maybe<QuizzardScreen>>>
  startScreenRef?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  type?: Maybe<Scalars['String']['output']>
}

export type QuizzardAction = {
  __typename?: 'QuizzardAction'
  action?: Maybe<QuizzardActionType>
  op?: Maybe<QuizzardOpType>
  to?: Maybe<QuizzardJumpTo>
  type?: Maybe<QuizzardVarType>
  value?: Maybe<Scalars['String']['output']>
  vars?: Maybe<Array<Maybe<QuizzardVar>>>
}

export enum QuizzardActionType {
  Jump = 'jump',
}

export type QuizzardChoice = {
  __typename?: 'QuizzardChoice'
  id?: Maybe<Scalars['ID']['output']>
  label?: Maybe<Scalars['String']['output']>
  ref?: Maybe<Scalars['String']['output']>
}

export type QuizzardJumpTo = {
  __typename?: 'QuizzardJumpTo'
  type?: Maybe<QuizzardJumpType>
  value?: Maybe<Scalars['String']['output']>
}

export enum QuizzardJumpType {
  Field = 'field',
  Thankyou = 'thankyou',
}

export enum QuizzardOpType {
  Always = 'always',
  BeginsWith = 'begins_with',
  Contains = 'contains',
  EarlierThan = 'earlier_than',
  EarlierThanOrOn = 'earlier_than_or_on',
  EndsWith = 'ends_with',
  Equal = 'equal',
  GreaterEqualThan = 'greater_equal_than',
  GreaterThan = 'greater_than',
  Is = 'is',
  IsNot = 'is_not',
  LaterThan = 'later_than',
  LaterThanOrOn = 'later_than_or_on',
  LowerEqualThan = 'lower_equal_than',
  LowerThan = 'lower_than',
  NotContains = 'not_contains',
  NotEqual = 'not_equal',
  NotOn = 'not_on',
  On = 'on',
  Or = 'or',
}

export type QuizzardProperties = {
  __typename?: 'QuizzardProperties'
  allowMultipleSelections?: Maybe<Scalars['Boolean']['output']>
  buttonText?: Maybe<Scalars['String']['output']>
  choices?: Maybe<Array<Maybe<QuizzardChoice>>>
  description?: Maybe<Scalars['String']['output']>
  landingpageSlug?: Maybe<Scalars['String']['output']>
  lpLinkList?: Maybe<Array<Maybe<LpLinkList>>>
  result?: Maybe<Scalars['String']['output']>
  steps?: Maybe<Scalars['Int']['output']>
}

export type QuizzardScreen = {
  __typename?: 'QuizzardScreen'
  actions?: Maybe<Array<Maybe<QuizzardAction>>>
  id?: Maybe<Scalars['ID']['output']>
  properties?: Maybe<QuizzardProperties>
  ref?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  type?: Maybe<QuizzardScreenType>
}

export enum QuizzardScreenType {
  Dropdown = 'dropdown',
  MultipleChoice = 'multiple_choice',
  OpinionScale = 'opinion_scale',
  Rating = 'rating',
  ShortText = 'short_text',
  ThankyouScreen = 'thankyou_screen',
}

export type QuizzardVar = {
  __typename?: 'QuizzardVar'
  op?: Maybe<QuizzardOpType>
  type?: Maybe<QuizzardVarType>
  value?: Maybe<Scalars['String']['output']>
}

export enum QuizzardVarType {
  Choice = 'choice',
}

export type RegenerationConditions = {
  __typename?: 'RegenerationConditions'
  included?: Maybe<Scalars['Boolean']['output']>
  price?: Maybe<ProductPrice>
}

export type RegisterUserInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>
  email: Scalars['String']['input']
  hasTrackingConsentGiven?: InputMaybe<Scalars['Boolean']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  password: Scalars['String']['input']
  utmParams?: InputMaybe<UtmParamsInput>
}

export enum RegistrationStep {
  Active = 'ACTIVE',
  Anamnesis = 'ANAMNESIS',
  Billing = 'BILLING',
}

export type RegistrationStepResult = {
  __typename?: 'RegistrationStepResult'
  companyId?: Maybe<Scalars['ID']['output']>
  errorCode?: Maybe<Scalars['String']['output']>
  message?: Maybe<Scalars['String']['output']>
  status: OnboardingStepStatus
  stepName: RegistrationStep
  userId?: Maybe<Scalars['ID']['output']>
}

export type RemoveOnofficeSharedConfigCompanyInput = {
  companyId: Scalars['ID']['input']
  sharedConfigId: Scalars['ID']['input']
}

export type RequestImageEditUploadUrlInput = {
  /** The ID of the image document to edit. */
  imageId: Scalars['ID']['input']
  /** Source type of the image (AI, USER, STOCK, MATERIAL). */
  imageType: ImageType
  /** MIME type of the replacement image (e.g. image/jpeg). */
  mimeType: Scalars['String']['input']
  /** Required when imageType is STOCK. */
  provider?: InputMaybe<Scalars['String']['input']>
  /** Required when imageType is STOCK. */
  topicId?: InputMaybe<Scalars['ID']['input']>
}

export type RequestMaterialUploadUrlInput = {
  /** Optional asset type override; inferred from mimeType if omitted. */
  assetType?: InputMaybe<AssetType>
  /** Optional; falls back to the authenticated user's company. */
  companyId?: InputMaybe<Scalars['ID']['input']>
  /** Optional display name; falls back to filename without extension. */
  displayName?: InputMaybe<Scalars['String']['input']>
  /** File size in bytes — validated against per-type limits before issuing the URL. */
  fileSize?: InputMaybe<Scalars['Int']['input']>
  /** Original filename — used for type validation and display name fallback. */
  filename: Scalars['String']['input']
  /** MIME type of the file to upload (e.g. image/jpeg, video/mp4). */
  mimeType: Scalars['String']['input']
  topicId: Scalars['ID']['input']
}

export type RequestMultipleMaterialUploadUrlsInput = {
  /** Optional; falls back to the authenticated user's company. */
  companyId?: InputMaybe<Scalars['ID']['input']>
  files: Array<RequestMaterialUploadUrlInput>
}

export type RequestUserImageUploadUrlInput = {
  /** MIME type of the image to upload (e.g. image/jpeg, image/png). */
  mimeType: Scalars['String']['input']
}

export type ResendPendingSubscriptionsInput = {
  channelId: Scalars['ID']['input']
  leadId: Scalars['ID']['input']
}

export enum ResidentialArea {
  Quiet = 'QUIET',
  Rural = 'RURAL',
  Urban = 'URBAN',
}

export type ResumeChannelForLeadInput = {
  channelId: Scalars['ID']['input']
  leadId: Scalars['ID']['input']
}

export type ReturnCall = {
  __typename?: 'ReturnCall'
  callbackTimeOfDay?: Maybe<Array<Maybe<ReturnCallTimeOfDay>>>
  topics?: Maybe<Array<Maybe<ReturnCallTopics>>>
  topicsOther?: Maybe<Scalars['String']['output']>
}

export enum ReturnCallTimeOfDay {
  Afternoon = 'AFTERNOON',
  Evening = 'EVENING',
  Forenoon = 'FORENOON',
  Noon = 'NOON',
}

export enum ReturnCallTopics {
  BuyingInterest = 'BUYING_INTEREST',
  Credit = 'CREDIT',
  Divorce = 'DIVORCE',
  HandoverTax = 'HANDOVER_TAX',
  Inheritance = 'INHERITANCE',
  LifeAnnuity = 'LIFE_ANNUITY',
  Other = 'OTHER',
  PartialSale = 'PARTIAL_SALE',
  Pricing = 'PRICING',
  PropertyGainTax = 'PROPERTY_GAIN_TAX',
  PropertyTax = 'PROPERTY_TAX',
  Rent = 'RENT',
  RentValue = 'RENT_VALUE',
  Replacement = 'REPLACEMENT',
  Sale = 'SALE',
}

/**
 * Input for the revertGeneratedImage mutation. It takes the ID of the generated image to
 * revert to its original version.
 */
export type RevertGeneratedImageInput = {
  /** The ID of the generated image document to revert. */
  imageId: Scalars['ID']['input']
}

/**
 * Input for the revertStockImage mutation. It takes the ID of the stock image to
 * revert to its original version.
 */
export type RevertStockImageInput = {
  /** The ID of the stock image document to revert. */
  imageId: Scalars['ID']['input']
}

/**
 * Input for the revertUserImage mutation. It takes the ID of the user image to
 * revert to its original version.
 */
export type RevertUserImageInput = {
  /** The ID of the user image document to revert. */
  imageId: Scalars['ID']['input']
}

export type RevokeProductCancellationInput = {
  comment?: InputMaybe<Scalars['String']['input']>
  contractId: Scalars['ID']['input']
  productId: Scalars['ID']['input']
}

export type Role = {
  __typename?: 'Role'
  description?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['ID']['output']>
  isAssignable?: Maybe<Scalars['Boolean']['output']>
  isDefault?: Maybe<Scalars['Boolean']['output']>
  isInitial?: Maybe<Scalars['Boolean']['output']>
  name?: Maybe<Scalars['String']['output']>
  permissions?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  slug?: Maybe<Scalars['String']['output']>
}

export type SalesPerson = {
  __typename?: 'SalesPerson'
  id?: Maybe<Scalars['String']['output']>
  isActive?: Maybe<Scalars['Boolean']['output']>
  name?: Maybe<Scalars['String']['output']>
}

export type SaveContentInput = {
  carouselImages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  downloaded?: InputMaybe<Scalars['Boolean']['input']>
  imagePath?: InputMaybe<Scalars['String']['input']>
  imageSource?: InputMaybe<ImageSource>
  publication?: InputMaybe<Scalars['String']['input']>
  recipientSegment?: InputMaybe<Scalars['String']['input']>
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>
  targetLink?: InputMaybe<Scalars['String']['input']>
  text?: InputMaybe<Scalars['String']['input']>
  textKind: Scalars['String']['input']
  topicId: Scalars['ID']['input']
  topicName?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type SaveOnofficeSharedConfigCompanyInput = {
  companyId: Scalars['ID']['input']
  defaultExportUserOnofficeId?: InputMaybe<Scalars['String']['input']>
  onofficeGroupId: Scalars['String']['input']
  sharedConfigId: Scalars['ID']['input']
}

export type SaveOnofficeSharedConfigInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  name: Scalars['String']['input']
  secret: Scalars['String']['input']
  token: Scalars['String']['input']
}

export type SavePropstackDefaultExportBrokerInput = {
  companyId: Scalars['ID']['input']
  defaultExportBrokerId: Scalars['Int']['input']
}

export type SavedContent = {
  __typename?: 'SavedContent'
  accountCount?: Maybe<Scalars['Int']['output']>
  carouselImages?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  company?: Maybe<Company>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  downloaded?: Maybe<Scalars['Boolean']['output']>
  id?: Maybe<Scalars['String']['output']>
  imagePath?: Maybe<Scalars['String']['output']>
  imageSource?: Maybe<ImageSource>
  invitationIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>
  invitations?: Maybe<Array<Maybe<Invitation>>>
  officeCount?: Maybe<Scalars['Int']['output']>
  platformTexts?: Maybe<PlatformTexts>
  postedAt?: Maybe<Scalars['DateTime']['output']>
  postingBatchId?: Maybe<Scalars['ID']['output']>
  posts?: Maybe<Array<Maybe<SavedContentPost>>>
  publication?: Maybe<Scalars['String']['output']>
  recipientSegment?: Maybe<Scalars['String']['output']>
  socialMediaPosts?: Maybe<Array<Maybe<SocialMediaPost>>>
  targetLink?: Maybe<Scalars['String']['output']>
  text?: Maybe<Scalars['String']['output']>
  textKind?: Maybe<Scalars['String']['output']>
  topicId?: Maybe<Scalars['ID']['output']>
  topicName?: Maybe<Scalars['String']['output']>
  totalOffices?: Maybe<Scalars['Int']['output']>
  totalRecipients?: Maybe<Scalars['Int']['output']>
  url?: Maybe<Scalars['String']['output']>
}

export type SavedContentPost = {
  __typename?: 'SavedContentPost'
  companyId?: Maybe<Scalars['ID']['output']>
  companyName?: Maybe<Scalars['String']['output']>
  hasActiveConnection?: Maybe<Scalars['Boolean']['output']>
  postingBatchId?: Maybe<Scalars['ID']['output']>
  socialMediaPosts?: Maybe<Array<Maybe<SocialMediaPost>>>
  textKind?: Maybe<Scalars['String']['output']>
  url?: Maybe<Scalars['String']['output']>
}

export type SavedContents = {
  __typename?: 'SavedContents'
  numberOfPosts?: Maybe<Scalars['Int']['output']>
  page?: Maybe<Scalars['Int']['output']>
  perPage?: Maybe<Scalars['Int']['output']>
  savedContents?: Maybe<Array<Maybe<SavedContent>>>
  total?: Maybe<Scalars['Int']['output']>
}

export enum SavedContentsFilterType {
  All = 'all',
  Month = 'month',
  Today = 'today',
  Week = 'week',
  Year = 'year',
}

export type ScheduledContent = {
  __typename?: 'ScheduledContent'
  accountCount?: Maybe<Scalars['Int']['output']>
  carouselImages?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  companyId?: Maybe<Scalars['ID']['output']>
  id?: Maybe<Scalars['ID']['output']>
  imagePath?: Maybe<Scalars['String']['output']>
  imageSource?: Maybe<ImageSource>
  invitations?: Maybe<Array<Maybe<Invitation>>>
  landingPageId?: Maybe<Scalars['String']['output']>
  officeCount?: Maybe<Scalars['Int']['output']>
  platformTexts?: Maybe<PlatformTexts>
  postingBatchId?: Maybe<Scalars['ID']['output']>
  posts?: Maybe<Array<Maybe<ScheduledContentPost>>>
  publication?: Maybe<Scalars['String']['output']>
  recipientSegment?: Maybe<Scalars['String']['output']>
  scheduledAt?: Maybe<Scalars['DateTime']['output']>
  slug?: Maybe<Scalars['String']['output']>
  socialMediaPosts?: Maybe<Array<Maybe<SocialMediaPost>>>
  targetLink?: Maybe<Scalars['String']['output']>
  text?: Maybe<Scalars['String']['output']>
  textKind?: Maybe<Scalars['String']['output']>
  topicId?: Maybe<Scalars['ID']['output']>
  topicName?: Maybe<Scalars['String']['output']>
  totalOffices?: Maybe<Scalars['Int']['output']>
  totalRecipients?: Maybe<Scalars['Int']['output']>
  url?: Maybe<Scalars['String']['output']>
}

export type ScheduledContentPost = {
  __typename?: 'ScheduledContentPost'
  companyId?: Maybe<Scalars['ID']['output']>
  companyName?: Maybe<Scalars['String']['output']>
  postingBatchId?: Maybe<Scalars['ID']['output']>
  socialMediaPosts?: Maybe<Array<Maybe<SocialMediaPost>>>
  textKind?: Maybe<Scalars['String']['output']>
  url?: Maybe<Scalars['String']['output']>
}

export type ScheduledContents = {
  __typename?: 'ScheduledContents'
  page?: Maybe<Scalars['Int']['output']>
  perPage?: Maybe<Scalars['Int']['output']>
  scheduledContents?: Maybe<Array<Maybe<ScheduledContent>>>
  total?: Maybe<Scalars['Int']['output']>
}

export enum SelfOnboardingStep {
  Billing = 'BILLING',
  CrmConfig = 'CRM_CONFIG',
  Finished = 'FINISHED',
  TargetAudience = 'TARGET_AUDIENCE',
  Website = 'WEBSITE',
}

export type SendInvitationPreviewInput = {
  landingpageSlug: Scalars['String']['input']
}

/** Input for sending a newsletter preview email to the current user. */
export type SendNewsletterPreviewInput = {
  /** HTML-formatted email content. */
  body: Scalars['String']['input']
  /** Custom link, used when targetLink is 'individualLink'. */
  individualLink?: InputMaybe<Scalars['String']['input']>
  /** Topic identifier (e.g., 'immobilienbewertung'). Not present for custom topics */
  landingpageSlug?: InputMaybe<Scalars['String']['input']>
  /** Email subject line. Nullable to match InviteLeadsToLandingpageInput.invitationSubject - the real send doesn't require one either. */
  subject?: InputMaybe<Scalars['String']['input']>
  /** Where the newsletter's CTA button should link to, same values as InviteLeadsToLandingpageInput.targetLink. */
  targetLink?: InputMaybe<Scalars['String']['input']>
}

export type SendNextEmailForLeadInput = {
  channelId: Scalars['ID']['input']
  leadId: Scalars['ID']['input']
}

export type SendResetOrVerificationMailInput = {
  email: Scalars['String']['input']
}

export type SendResetOrVerificationMailResponse = {
  __typename?: 'SendResetOrVerificationMailResponse'
  errorCode?: Maybe<Scalars['String']['output']>
  message?: Maybe<Scalars['String']['output']>
  status: Scalars['String']['output']
}

export type SetCompanyFeatureInput = {
  companyId: Scalars['ID']['input']
  config: Scalars['JSONObject']['input']
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  slug: Scalars['ID']['input']
}

export type SetComponentFeatureInput = {
  component: Scalars['String']['input']
  config: Scalars['JSONObject']['input']
  countryCode?: InputMaybe<CountryCode>
  isDefaultActive?: InputMaybe<Scalars['Boolean']['input']>
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>
  isUpsellingEnabled?: InputMaybe<Scalars['Boolean']['input']>
  platform?: InputMaybe<Scalars['String']['input']>
  product?: InputMaybe<CompanyProductType>
  slug: Scalars['ID']['input']
}

export type SetCountryFeatureInput = {
  config: Scalars['JSONObject']['input']
  countryCode: CountryCode
  isDefaultActive?: InputMaybe<Scalars['Boolean']['input']>
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>
  isUpsellingEnabled?: InputMaybe<Scalars['Boolean']['input']>
  platform?: InputMaybe<Scalars['String']['input']>
  slug: Scalars['ID']['input']
}

export type SetDueDateInput = {
  date: Scalars['DateTime']['input']
  leadId: Scalars['ID']['input']
}

export type SetGoogleBusinessLocationInput = {
  /** bundle.social channel id of the chosen Google Business location. */
  channelId: Scalars['String']['input']
}

export type SetPlatformFeatureInput = {
  config: Scalars['JSONObject']['input']
  isDefaultActive: Scalars['Boolean']['input']
  isEnabled: Scalars['Boolean']['input']
  isUpsellingEnabled: Scalars['Boolean']['input']
  name: Scalars['String']['input']
  platform?: InputMaybe<Scalars['String']['input']>
  slug: Scalars['ID']['input']
}

export type SetProductFeatureInput = {
  config: Scalars['JSONObject']['input']
  countryCode?: InputMaybe<CountryCode>
  isDefaultActive?: InputMaybe<Scalars['Boolean']['input']>
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>
  isUpsellingEnabled?: InputMaybe<Scalars['Boolean']['input']>
  platform?: InputMaybe<Scalars['String']['input']>
  product: CompanyProductType
  slug: Scalars['ID']['input']
}

export type SetRolePermissionsInput = {
  permissions: Array<Scalars['String']['input']>
  roleId: Scalars['ID']['input']
}

export type SetUserRoleInput = {
  roleId: Scalars['ID']['input']
  userId: Scalars['ID']['input']
}

export type Settings = {
  __typename?: 'Settings'
  company?: Maybe<CompanySettings>
  /** @deprecated use Settings.company */
  enabledPhoneVerification?: Maybe<EnabledPhoneVerification>
  lead?: Maybe<LeadSettings>
}

export type SignUpUser = {
  __typename?: 'SignUpUser'
  errorCode?: Maybe<Scalars['String']['output']>
  message?: Maybe<Scalars['String']['output']>
  status: SignUpUserStatus
}

export type SignUpUserInput = {
  email: Scalars['String']['input']
  firstname: Scalars['String']['input']
  lastname: Scalars['String']['input']
  locale?: InputMaybe<Scalars['String']['input']>
  password: Scalars['String']['input']
  phone?: InputMaybe<Scalars['String']['input']>
  termsAndConditionsAccepted?: InputMaybe<Scalars['Boolean']['input']>
  token?: InputMaybe<Scalars['String']['input']>
  utmParams?: InputMaybe<UtmParamsInput>
}

export enum SignUpUserStatus {
  Error = 'ERROR',
  Success = 'SUCCESS',
}

export type Signature = {
  __typename?: 'Signature'
  customTemplateSignature?: Maybe<Scalars['Boolean']['output']>
  extra?: Maybe<Scalars['String']['output']>
  html?: Maybe<Scalars['String']['output']>
  includeGoogleReview?: Maybe<Scalars['Boolean']['output']>
  includeProvenExpert?: Maybe<Scalars['Boolean']['output']>
  text?: Maybe<Scalars['String']['output']>
}

export type SignatureInput = {
  customTemplateSignature?: InputMaybe<Scalars['Boolean']['input']>
  html?: InputMaybe<Scalars['String']['input']>
  includeGoogleReview?: InputMaybe<Scalars['Boolean']['input']>
  includeProvenExpert?: InputMaybe<Scalars['Boolean']['input']>
  text?: InputMaybe<Scalars['String']['input']>
}

export type SingleFileAddInput = {
  file?: InputMaybe<Scalars['Upload']['input']>
}

export type SingleFileUpdateInput = {
  file?: InputMaybe<Scalars['Upload']['input']>
  id?: InputMaybe<Scalars['String']['input']>
}

export type Site = {
  __typename?: 'Site'
  adminUrl?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  tracking?: Maybe<Tracking>
  url?: Maybe<Scalars['String']['output']>
}

export type SlotOperationResult = {
  __typename?: 'SlotOperationResult'
  outcome: SlotOutcome
  reason?: Maybe<Scalars['String']['output']>
  slotId: Scalars['ID']['output']
}

export enum SlotOutcome {
  Approved = 'APPROVED',
  Skipped = 'SKIPPED',
}

export type SlotRefInput = {
  planId: Scalars['ID']['input']
  slotId: Scalars['ID']['input']
}

export type Social = {
  __typename?: 'Social'
  link?: Maybe<Scalars['String']['output']>
  type?: Maybe<SocialType>
}

export type SocialInput = {
  link: Scalars['String']['input']
  type: SocialType
}

export type SocialMediaAccountRef = {
  __typename?: 'SocialMediaAccountRef'
  accountId?: Maybe<Scalars['ID']['output']>
  displayName?: Maybe<Scalars['String']['output']>
  platform?: Maybe<SocialMediaType>
}

export type SocialMediaActiveConnections = {
  __typename?: 'SocialMediaActiveConnections'
  companyId?: Maybe<Scalars['ID']['output']>
  type?: Maybe<SocialMediaType>
}

export type SocialMediaActiveConnectionsInput = {
  childCompanyId?: InputMaybe<Scalars['ID']['input']>
  isMasterView?: InputMaybe<Scalars['Boolean']['input']>
}

export type SocialMediaConnections = {
  __typename?: 'SocialMediaConnections'
  facebook?: Maybe<Array<Maybe<FacebookPage>>>
  googleBusiness?: Maybe<GoogleBusinessConnectionStatus>
  linkedin?: Maybe<Array<Maybe<LinkedinOrganization>>>
}

export type SocialMediaPlatformStatus = {
  __typename?: 'SocialMediaPlatformStatus'
  failureReason?: Maybe<Scalars['String']['output']>
  hasFailed: Scalars['Boolean']['output']
  permalink?: Maybe<Scalars['String']['output']>
  platform: SocialMediaType
  status: SocialMediaPostingStatus
}

export type SocialMediaPost = {
  __typename?: 'SocialMediaPost'
  completedAt?: Maybe<Scalars['DateTime']['output']>
  externalPostId?: Maybe<Scalars['String']['output']>
  failureReason?: Maybe<Scalars['String']['output']>
  hasFailed?: Maybe<Scalars['Boolean']['output']>
  id?: Maybe<Scalars['ID']['output']>
  metrics?: Maybe<SocialMediaPostMetrics>
  permalink?: Maybe<Scalars['String']['output']>
  postId?: Maybe<Scalars['String']['output']>
  scheduledAt?: Maybe<Scalars['DateTime']['output']>
  type?: Maybe<SocialMediaType>
}

export type SocialMediaPostMetrics = {
  __typename?: 'SocialMediaPostMetrics'
  clicks?: Maybe<Scalars['Int']['output']>
  comments?: Maybe<Scalars['Int']['output']>
  engagementRate?: Maybe<Scalars['Float']['output']>
  fetchedAt?: Maybe<Scalars['DateTime']['output']>
  impressions?: Maybe<Scalars['Int']['output']>
  likes?: Maybe<Scalars['Int']['output']>
  reach?: Maybe<Scalars['Int']['output']>
  saved?: Maybe<Scalars['Int']['output']>
  shares?: Maybe<Scalars['Int']['output']>
}

export enum SocialMediaPostingStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
}

export type SocialMediaPostingStatusResult = {
  __typename?: 'SocialMediaPostingStatusResult'
  completed: Scalars['Int']['output']
  failed: Scalars['Int']['output']
  platforms: Array<SocialMediaPlatformStatus>
  status: SocialMediaPostingStatus
  total: Scalars['Int']['output']
}

export enum SocialMediaType {
  Facebook = 'FACEBOOK',
  GoogleBusiness = 'GOOGLE_BUSINESS',
  Instagram = 'INSTAGRAM',
  Linkedin = 'LINKEDIN',
  WhatsappStatus = 'WHATSAPP_STATUS',
}

export enum SocialType {
  Facebook = 'FACEBOOK',
  Instagram = 'INSTAGRAM',
  Linkedin = 'LINKEDIN',
  Other = 'OTHER',
  Twitter = 'TWITTER',
}

export type SsoProviders = {
  __typename?: 'SsoProviders'
  externalId?: Maybe<Scalars['String']['output']>
  issuer: Scalars['String']['output']
}

export type SsoProvidersInput = {
  externalId?: InputMaybe<Scalars['String']['input']>
  issuer: Scalars['String']['input']
}

export type StartFileImportResult = {
  __typename?: 'StartFileImportResult'
  error?: Maybe<Scalars['String']['output']>
}

export type StartToDoInput = {
  todoTemplateSlug: Scalars['String']['input']
}

export type State = {
  __typename?: 'State'
  stringValues?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  value?: Maybe<Scalars['JSON']['output']>
}

export type Statistics = {
  __typename?: 'Statistics'
  totalCommissionValue?: Maybe<TotalCommissionValue>
  totalLeadCount?: Maybe<TotalLeadCount>
  totalLeadCountByStatus?: Maybe<TotalLeadCountByStatus>
  totalLeadValue?: Maybe<Scalars['Int']['output']>
  totalTrafficSource?: Maybe<Array<Maybe<CountForSource>>>
  totalValuationCount?: Maybe<Scalars['Int']['output']>
}

export type StatisticsInput = {
  childCompanyId?: InputMaybe<Scalars['ID']['input']>
  companyId?: InputMaybe<Scalars['ID']['input']>
  filters?: InputMaybe<StatisticsInputFilters>
  isMasterView?: InputMaybe<Scalars['Boolean']['input']>
}

export type StatisticsInputFilters = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  startDate?: InputMaybe<Scalars['DateTime']['input']>
}

export type StatusHistory = {
  __typename?: 'StatusHistory'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  status?: Maybe<Scalars['String']['output']>
  userId?: Maybe<Scalars['String']['output']>
  userName?: Maybe<Scalars['String']['output']>
}

export type StatusesTotals = {
  __typename?: 'StatusesTotals'
  count?: Maybe<Scalars['Int']['output']>
  status?: Maybe<Scalars['String']['output']>
}

export type StockImage = ImageInterface & {
  __typename?: 'StockImage'
  companyId?: Maybe<Scalars['ID']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  externalId?: Maybe<Scalars['String']['output']>
  fileId: Scalars['ID']['output']
  fileSize?: Maybe<Scalars['Int']['output']>
  height?: Maybe<Scalars['Int']['output']>
  history?: Maybe<Array<Maybe<EditHistoryEntry>>>
  id: Scalars['ID']['output']
  license?: Maybe<Scalars['String']['output']>
  originalImageUrl?: Maybe<Scalars['String']['output']>
  provider?: Maybe<Scalars['String']['output']>
  topicId?: Maybe<Scalars['ID']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  url?: Maybe<Scalars['String']['output']>
  width?: Maybe<Scalars['Int']['output']>
}

/** Represents a stock photo that can be edited. */
export type StockPhoto = ImageInterface & {
  __typename?: 'StockPhoto'
  companyId?: Maybe<Scalars['ID']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  externalId?: Maybe<Scalars['String']['output']>
  fileId: Scalars['ID']['output']
  fileSize?: Maybe<Scalars['Int']['output']>
  height?: Maybe<Scalars['Int']['output']>
  history?: Maybe<Array<Maybe<EditHistoryEntry>>>
  id: Scalars['ID']['output']
  license?: Maybe<Scalars['String']['output']>
  originalImageUrl?: Maybe<Scalars['String']['output']>
  provider?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  url?: Maybe<Scalars['String']['output']>
  width?: Maybe<Scalars['Int']['output']>
}

export type StopAllCampaignsForLeadInput = {
  leadId: Scalars['String']['input']
}

export type StopChannelForLeadInput = {
  channelId: Scalars['ID']['input']
  leadId: Scalars['ID']['input']
}

export type SubscribeToNewsletterInput = {
  newsletter: Scalars['String']['input']
}

export type Subscription = {
  __typename?: 'Subscription'
  campaign?: Maybe<Campaign>
  id?: Maybe<Scalars['String']['output']>
  subscribedAt?: Maybe<Scalars['DateTime']['output']>
  unsubscribedAt?: Maybe<Scalars['DateTime']['output']>
}

export enum Surroundings {
  Education = 'EDUCATION',
  Gastronomy = 'GASTRONOMY',
  Healthcare = 'HEALTHCARE',
  PublicTransport = 'PUBLIC_TRANSPORT',
  Shopping = 'SHOPPING',
}

export enum TargetLink {
  CustomerMainWebsite = 'customerMainWebsite',
  IndividualLink = 'individualLink',
  Landingpage = 'landingpage',
  LandingpagePerOffice = 'landingpagePerOffice',
  NoLink = 'noLink',
  OfficeWebsite = 'officeWebsite',
}

export enum TargetLinkOption {
  CentralBottimmoLandingpage = 'CENTRAL_BOTTIMMO_LANDINGPAGE',
  Custom = 'CUSTOM',
  CustomerMainWebsite = 'CUSTOMER_MAIN_WEBSITE',
  GoogleReview = 'GOOGLE_REVIEW',
  NoLink = 'NO_LINK',
  OfficeBottimmoLandingpage = 'OFFICE_BOTTIMMO_LANDINGPAGE',
  OfficeWebsite = 'OFFICE_WEBSITE',
}

export type Theme = {
  __typename?: 'Theme'
  colors?: Maybe<Colors>
  layout?: Maybe<Scalars['String']['output']>
  styles?: Maybe<Scalars['String']['output']>
}

export type ToDo = {
  __typename?: 'ToDo'
  buttonText?: Maybe<Scalars['String']['output']>
  endConditionEvent?: Maybe<Scalars['String']['output']>
  endConditionManual?: Maybe<Scalars['Boolean']['output']>
  externalFlowId?: Maybe<Scalars['String']['output']>
  priority?: Maybe<Scalars['Int']['output']>
  slug?: Maybe<Scalars['String']['output']>
  startConditionEvent?: Maybe<Scalars['String']['output']>
  startConditionManual?: Maybe<Scalars['Boolean']['output']>
  state?: Maybe<ToDoState>
  text?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  user?: Maybe<User>
  userId?: Maybe<Scalars['ID']['output']>
}

export enum ToDoState {
  Finished = 'FINISHED',
  Open = 'OPEN',
  Pending = 'PENDING',
  Started = 'STARTED',
}

export type ToDoTemplate = {
  __typename?: 'ToDoTemplate'
  buttonText?: Maybe<Scalars['String']['output']>
  endConditionEvent?: Maybe<Scalars['String']['output']>
  endConditionManual?: Maybe<Scalars['Boolean']['output']>
  externalFlowId?: Maybe<Scalars['String']['output']>
  slug?: Maybe<Scalars['String']['output']>
  startConditionEvent?: Maybe<Scalars['String']['output']>
  startConditionManual?: Maybe<Scalars['Boolean']['output']>
  text?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
}

export enum Tonality {
  Casual = 'casual',
  Professional = 'professional',
}

export type Topic = {
  __typename?: 'Topic'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  description?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['ID']['output']>
  isModifiedByUser?: Maybe<Scalars['Boolean']['output']>
  isSystemGenerated?: Maybe<Scalars['Boolean']['output']>
  isUserEditable?: Maybe<Scalars['Boolean']['output']>
  landingpage?: Maybe<Landingpage>
  links?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  name?: Maybe<Scalars['String']['output']>
  status?: Maybe<TopicStatus>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  visibility?: Maybe<TopicVisibility>
}

export type TopicFilter = {
  __typename?: 'TopicFilter'
  count: Scalars['Int']['output']
  id: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
}

/**
 * One topic material bundle: the complete material product for one customer
 * workspace and one guide topic.
 *
 * A guide, a flyer, and five social images live in seven separate materials, so no
 * single row can say whether the topic is delivered. This is that answer, composed
 * from the rows bottimmo owns and the diagnostics Material Maker owns.
 *
 * Internal projection: it carries failure codes and the company fields blocking
 * generation, and is gated behind the landing-page-template admin permission.
 */
export type TopicMaterialBundle = {
  __typename?: 'TopicMaterialBundle'
  /** True when every member holds a reviewed candidate and none is missing or broken. */
  approvable: Scalars['Boolean']['output']
  blockedMembers: Array<Scalars['String']['output']>
  companyId: Scalars['ID']['output']
  /** True only when every expected member is live for the customer. */
  complete: Scalars['Boolean']['output']
  /** False when Material Maker answered for nothing; the members below are still correct. */
  diagnosticsAvailable: Scalars['Boolean']['output']
  /** Number of members a complete bundle expects. Always 7. */
  expectedCount: Scalars['Int']['output']
  failedMembers: Array<Scalars['String']['output']>
  incompleteMembers: Array<Scalars['String']['output']>
  landingpageId: Scalars['ID']['output']
  members: Array<TopicMaterialBundleMember>
  /** Union of the company fields blocking any member. */
  missingFields: Array<Scalars['String']['output']>
  missingMembers: Array<Scalars['String']['output']>
  pendingReviewMembers: Array<Scalars['String']['output']>
  publishedCount: Scalars['Int']['output']
  /** True while a replacement is being generated for an already published member. */
  replacementInFlight: Scalars['Boolean']['output']
  /** Stable identity: company and landing page together. */
  topicBundleId: Scalars['String']['output']
  topicName?: Maybe<Scalars['String']['output']>
}

/** One atomic initial publication decision for a complete topic material bundle. */
export type TopicMaterialBundleApproval = {
  __typename?: 'TopicMaterialBundleApproval'
  approvalId: Scalars['ID']['output']
  approvedAt: Scalars['DateTime']['output']
  approvedBy?: Maybe<Scalars['ID']['output']>
  candidates: Array<TopicMaterialBundleApprovalCandidate>
  companyId: Scalars['ID']['output']
  landingpageId: Scalars['ID']['output']
}

export type TopicMaterialBundleApprovalCandidate = {
  __typename?: 'TopicMaterialBundleApprovalCandidate'
  checksumSha256: Scalars['String']['output']
  materialId: Scalars['ID']['output']
  previousPublishedVersion?: Maybe<Scalars['Int']['output']>
  versionNumber: Scalars['Int']['output']
}

export type TopicMaterialBundleMember = {
  __typename?: 'TopicMaterialBundleMember'
  assetType: Scalars['String']['output']
  attemptCount: Scalars['Int']['output']
  candidateChecksum?: Maybe<Scalars['String']['output']>
  /** The exact candidate file the operator reviewed before publishing. */
  candidateFile?: Maybe<File>
  /** The newest stored rendition, which may be awaiting approval. */
  candidateVersion?: Maybe<Scalars['Int']['output']>
  diagnosticsAvailable: Scalars['Boolean']['output']
  displayName?: Maybe<Scalars['String']['output']>
  /** Stable member key: GUIDE, FLYER, or SOCIAL_IMAGE:1 to SOCIAL_IMAGE:5. */
  key: Scalars['String']['output']
  lastAttemptAt?: Maybe<Scalars['DateTime']['output']>
  lastFailureCode?: Maybe<Scalars['String']['output']>
  lastFailureMessage?: Maybe<Scalars['String']['output']>
  /** Null when no material record exists for this expected member. */
  materialId?: Maybe<Scalars['ID']['output']>
  /** Company fields that must be filled before generation can run. */
  missingFields: Array<Scalars['String']['output']>
  publishedChecksum?: Maybe<Scalars['String']['output']>
  /** The version the customer currently sees; unaffected by a replacement. */
  publishedVersion?: Maybe<Scalars['Int']['output']>
  quality?: Maybe<MaterialVersionQuality>
  replacementInFlight: Scalars['Boolean']['output']
  state: TopicMaterialBundleMemberState
  /** Stable position 1 to 5 for social images, null otherwise. */
  variantIndex?: Maybe<Scalars['Int']['output']>
}

export enum TopicMaterialBundleMemberState {
  /** Company data is absent; the sweep restarts it once filled in. */
  Blocked = 'BLOCKED',
  /** The last attempt failed and nothing is stored. */
  Failed = 'FAILED',
  /** An attempt is in flight. */
  Generating = 'GENERATING',
  /** No material record exists for this expected member at all. */
  Missing = 'MISSING',
  /** A rendition is stored, awaiting an internal approval decision. */
  PendingReview = 'PENDING_REVIEW',
  /** A version is live for the customer workspace. */
  Published = 'PUBLISHED',
}

export enum TopicStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
}

export type TopicUsage = {
  __typename?: 'TopicUsage'
  generatedTextCount?: Maybe<Scalars['Int']['output']>
  postedContentCount?: Maybe<Scalars['Int']['output']>
  topicId?: Maybe<Scalars['ID']['output']>
  topicName?: Maybe<Scalars['String']['output']>
}

export type TopicVisibility = {
  __typename?: 'TopicVisibility'
  acquisitionBooster?: Maybe<Scalars['Boolean']['output']>
  contentCreator?: Maybe<Scalars['Boolean']['output']>
  materialUploads?: Maybe<Scalars['Boolean']['output']>
  topics?: Maybe<Scalars['Boolean']['output']>
}

export type TopicVisibilityInput = {
  acquisitionBooster?: InputMaybe<Scalars['Boolean']['input']>
  contentCreator?: InputMaybe<Scalars['Boolean']['input']>
  materialUploads?: InputMaybe<Scalars['Boolean']['input']>
  topics?: InputMaybe<Scalars['Boolean']['input']>
}

export type TotalByStatus = {
  __typename?: 'TotalByStatus'
  status?: Maybe<Scalars['String']['output']>
  total?: Maybe<Scalars['Int']['output']>
}

export type TotalCommissionValue = {
  __typename?: 'TotalCommissionValue'
  commission?: Maybe<Scalars['String']['output']>
  value?: Maybe<Scalars['Int']['output']>
}

export type TotalLeadCount = {
  __typename?: 'TotalLeadCount'
  lastThirtyDays?: Maybe<Scalars['Int']['output']>
  total?: Maybe<Scalars['Int']['output']>
  withValuation?: Maybe<Scalars['Int']['output']>
}

export type TotalLeadCountByStatus = {
  __typename?: 'TotalLeadCountByStatus'
  new?: Maybe<Scalars['Int']['output']>
  newWithValuation?: Maybe<Scalars['Int']['output']>
  unreached?: Maybe<Scalars['Int']['output']>
}

export type TrackLandingpageImpressionInput = {
  cookieConsentChoice?: InputMaybe<Scalars['String']['input']>
  cookieConsentGiven?: InputMaybe<Scalars['Boolean']['input']>
  embedded?: InputMaybe<Scalars['Boolean']['input']>
  landingpageId: Scalars['ID']['input']
  queryString?: InputMaybe<Scalars['String']['input']>
  referrer?: InputMaybe<Scalars['String']['input']>
  trackingId?: InputMaybe<Scalars['ID']['input']>
}

export type Tracking = {
  __typename?: 'Tracking'
  gtm?: Maybe<Scalars['String']['output']>
}

export type TrafficCount = {
  __typename?: 'TrafficCount'
  count?: Maybe<Scalars['Int']['output']>
  source?: Maybe<Scalars['String']['output']>
}

export type TrafficCountFiltersInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  startDate?: InputMaybe<Scalars['DateTime']['input']>
}

export type TrafficCountInput = {
  childCompanyId?: InputMaybe<Scalars['ID']['input']>
  companyId?: InputMaybe<Scalars['ID']['input']>
  filters?: InputMaybe<TrafficCountFiltersInput>
  isMasterView?: InputMaybe<Scalars['Boolean']['input']>
  last30Days?: InputMaybe<Scalars['Boolean']['input']>
  specificDate?: InputMaybe<Scalars['String']['input']>
}

export type UpdateAmbassadorInput = {
  companyId: Scalars['String']['input']
  contactSlogan?: InputMaybe<Scalars['String']['input']>
  contactText?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  facebook?: InputMaybe<Scalars['String']['input']>
  firstname?: InputMaybe<Scalars['String']['input']>
  image?: InputMaybe<SingleFileUpdateInput>
  instagram?: InputMaybe<Scalars['String']['input']>
  lastname?: InputMaybe<Scalars['String']['input']>
  linkedin?: InputMaybe<Scalars['String']['input']>
  mobile?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  role?: InputMaybe<Scalars['String']['input']>
  salutation?: InputMaybe<Scalars['String']['input']>
  signature?: InputMaybe<SignatureInput>
  twitter?: InputMaybe<Scalars['String']['input']>
}

export type UpdateBookedLandingpagesInput = {
  bookedLandingpageSlugs: Array<Scalars['String']['input']>
  companyId: Scalars['ID']['input']
}

export type UpdateCalendarSyncSettingsInput = {
  followUpDelayDays?: InputMaybe<Scalars['Int']['input']>
  syncAiCalls?: InputMaybe<Scalars['Boolean']['input']>
  syncDueDates?: InputMaybe<Scalars['Boolean']['input']>
  syncFollowUpCalls?: InputMaybe<Scalars['Boolean']['input']>
  syncGoogleCalendar?: InputMaybe<Scalars['Boolean']['input']>
  syncScheduledPosts?: InputMaybe<Scalars['Boolean']['input']>
  syncTraditionalCalls?: InputMaybe<Scalars['Boolean']['input']>
}

export type UpdateCampaignInput = {
  id: Scalars['ID']['input']
  landingpages: Array<CampaignLandingpageInput>
  name: Scalars['String']['input']
  slug: Scalars['String']['input']
}

export type UpdateCampaignIsActiveInput = {
  id: Scalars['ID']['input']
  isActive: Scalars['Boolean']['input']
}

export type UpdateCompanyAddressInput = {
  address: CompanyAddressInput
  companyId: Scalars['ID']['input']
}

export type UpdateCompanyAmbassadorDataInput = {
  ambassador: AmbassadorBaseDataInput
  companyId: Scalars['ID']['input']
}

export type UpdateCompanyAmbassadorPortraitInput = {
  companyId: Scalars['ID']['input']
  image: SingleFileUpdateInput
}

export type UpdateCompanyAmbassadorSignatureCustomTemplateSignatureInput = {
  companyId: Scalars['String']['input']
  customTemplateSignature: Scalars['Boolean']['input']
}

export type UpdateCompanyAmbassadorSignatureExtraInput = {
  companyId: Scalars['String']['input']
  extra: Scalars['String']['input']
}

export type UpdateCompanyAmbassadorSignatureHtmlInput = {
  companyId: Scalars['String']['input']
  html: Scalars['String']['input']
}

export type UpdateCompanyAmbassadorSignatureIncludeGoogleReviewInput = {
  companyId: Scalars['String']['input']
  includeGoogleReview: Scalars['Boolean']['input']
}

export type UpdateCompanyAmbassadorSignatureIncludeProvenExpertInput = {
  companyId: Scalars['String']['input']
  includeProvenExpert: Scalars['Boolean']['input']
}

export type UpdateCompanyAmbassadorSignatureTextInput = {
  companyId: Scalars['String']['input']
  text: Scalars['String']['input']
}

export type UpdateCompanyBillingInput = {
  address?: InputMaybe<BillingAddressInput>
  bic?: InputMaybe<Scalars['String']['input']>
  companyId: Scalars['String']['input']
  contact?: InputMaybe<BillingContactInput>
  hasSeparateBillingAddress: Scalars['Boolean']['input']
  iban?: InputMaybe<Scalars['String']['input']>
  paymentMethod: PaymentMethod
  sepaValidAsOf?: InputMaybe<Scalars['DateTime']['input']>
  taxNumber?: InputMaybe<Scalars['String']['input']>
  vatId?: InputMaybe<Scalars['String']['input']>
  vatIdRequestDate?: InputMaybe<Scalars['DateTime']['input']>
}

export type UpdateCompanyCommissionInput = {
  commission?: InputMaybe<Scalars['String']['input']>
  companyId: Scalars['String']['input']
}

export type UpdateCompanyContactPersonInput = {
  address?: InputMaybe<OptionalAddressInput>
  companyId: Scalars['ID']['input']
  companyName?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  firstname?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  lastname?: InputMaybe<Scalars['String']['input']>
  mobile?: InputMaybe<Scalars['String']['input']>
  note?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  role?: InputMaybe<Scalars['String']['input']>
  salutation?: InputMaybe<Scalars['String']['input']>
  type: ContactPersonType
}

export type UpdateCompanyCustomWordingInput = {
  companyId: Scalars['ID']['input']
  farewell?: InputMaybe<Scalars['String']['input']>
  salutation?: InputMaybe<Scalars['String']['input']>
}

export type UpdateCompanyDetailsInput = {
  address?: InputMaybe<CompanyAddressInput>
  advertisementId?: InputMaybe<Scalars['String']['input']>
  brokerageName?: InputMaybe<Scalars['String']['input']>
  brokerageNameSameAsName?: InputMaybe<Scalars['Boolean']['input']>
  clientAdvisor?: InputMaybe<Scalars['String']['input']>
  commission?: InputMaybe<Scalars['String']['input']>
  customerNumber?: InputMaybe<Scalars['String']['input']>
  fbBusinessManagerId?: InputMaybe<Scalars['String']['input']>
  fbPixelId?: InputMaybe<Scalars['String']['input']>
  googleDriveFolderId?: InputMaybe<Scalars['String']['input']>
  googlePerformanceReportId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['String']['input']
  leadCorrespondenceBccEmail?: InputMaybe<Scalars['String']['input']>
  licenseNumber?: InputMaybe<Scalars['String']['input']>
  licenseStatus?: InputMaybe<Scalars['String']['input']>
  links?: InputMaybe<CompanyLinksInput>
  name?: InputMaybe<Scalars['String']['input']>
  performance?: InputMaybe<UpdateCompanyPerformanceInput>
  regionName?: InputMaybe<Scalars['String']['input']>
  salesPerson?: InputMaybe<Scalars['String']['input']>
  slogan?: InputMaybe<Scalars['String']['input']>
  socials?: InputMaybe<Array<InputMaybe<SocialInput>>>
  targetAudience?: InputMaybe<OnboardingTargetAudience>
}

export type UpdateCompanyFacebookInput = {
  customPixelEventSourceUrl?: InputMaybe<Scalars['String']['input']>
  pixelEventSourceUrlType?: InputMaybe<FbPixelEventSourceUrlType>
}

export type UpdateCompanyImageInput = {
  companyId: Scalars['String']['input']
  image: SingleFileUpdateInput
  type: Scalars['String']['input']
}

export type UpdateCompanyLinksInput = {
  companyId: Scalars['ID']['input']
  links: CompanyLinksInput
}

export type UpdateCompanyLocaleInput = {
  locale?: InputMaybe<Scalars['String']['input']>
}

export type UpdateCompanyLogoInput = {
  companyId: Scalars['ID']['input']
  image: SingleFileUpdateInput
}

export type UpdateCompanyMailProviderInput = {
  companyId: Scalars['ID']['input']
  mailProvider: MailProvider
}

export type UpdateCompanyMetaDataInput = {
  businessDescription?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  formality?: InputMaybe<Formality>
  industry?: InputMaybe<Scalars['String']['input']>
  markAiGeneratedImageContent?: InputMaybe<Scalars['Boolean']['input']>
  markAiGeneratedTextContent?: InputMaybe<Scalars['Boolean']['input']>
  perspective?: InputMaybe<Perspective>
  targetGroup?: InputMaybe<Scalars['String']['input']>
  tonality?: InputMaybe<Tonality>
  websiteUrl?: InputMaybe<Scalars['String']['input']>
}

export type UpdateCompanyNameInput = {
  companyId: Scalars['ID']['input']
  name: Scalars['String']['input']
}

export type UpdateCompanyPerformanceDataInput = {
  companyId: Scalars['String']['input']
  facebook?: InputMaybe<PerformanceFacebookInput>
  google?: InputMaybe<PerformanceGoogleInput>
}

export type UpdateCompanyPerformanceInput = {
  facebook?: InputMaybe<UpdateCompanyFacebookInput>
}

export type UpdateCompanyPhoneVerificationSettingsForValuationInput = {
  companyId: Scalars['ID']['input']
  enabled: Scalars['Boolean']['input']
}

export type UpdateCompanyRegionInput = {
  companyId: Scalars['String']['input']
  regionName?: InputMaybe<Scalars['String']['input']>
}

export type UpdateCompanySiteInput = {
  companyId?: InputMaybe<Scalars['String']['input']>
  tracking?: InputMaybe<CompanySiteTrackingInput>
}

export type UpdateCompanySloganInput = {
  companyId: Scalars['String']['input']
  slogan?: InputMaybe<Scalars['String']['input']>
}

export type UpdateCompanySlugInput = {
  companyId: Scalars['ID']['input']
  newSlug: Scalars['String']['input']
}

export type UpdateCompanyStateInput = {
  companyId: Scalars['String']['input']
  event: Scalars['String']['input']
}

export type UpdateCompanyThemeInput = {
  colors?: InputMaybe<CompanyThemeColorsInput>
  companyId: Scalars['String']['input']
  layout?: InputMaybe<Scalars['String']['input']>
  styles?: InputMaybe<Scalars['String']['input']>
}

export type UpdateContractNoteInput = {
  contractId: Scalars['ID']['input']
  note?: InputMaybe<Scalars['String']['input']>
}

export type UpdateCustomUrlInput = {
  customUrl: Scalars['String']['input']
  landingpageId: Scalars['ID']['input']
}

export type UpdateFbPixelAccessTokenInput = {
  accessToken: Scalars['String']['input']
  companyId: Scalars['ID']['input']
}

export type UpdateGoogleReviewLinkInput = {
  companyId: Scalars['ID']['input']
  googleReviewLink?: InputMaybe<Scalars['String']['input']>
}

export type UpdateGoogleReviewOnLandingpageInput = {
  companyId: Scalars['ID']['input']
  showGoogleReviewOnLandingpage: Scalars['Boolean']['input']
}

export type UpdateHoppermationSenderInput = {
  name?: InputMaybe<Scalars['String']['input']>
  replyToEmail?: InputMaybe<Scalars['String']['input']>
  senderId: Scalars['ID']['input']
}

export type UpdateIsPhoneOptionalSettingsInput = {
  companyId: Scalars['ID']['input']
  isPhoneOptional: Scalars['Boolean']['input']
}

export type UpdateLandingpageImpressionCookieConsentInput = {
  cookieConsentChoice: Scalars['String']['input']
  cookieConsentGiven: Scalars['Boolean']['input']
  landingpageImpressionId: Scalars['ID']['input']
}

export type UpdateLandingpageStatusInput = {
  landingpageId: Scalars['ID']['input']
  status: LandingpageStatus
}

export type UpdateLeadPersonalDataInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>
  firstname?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  lastname?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
}

export type UpdateLeadsPipelineStatusInput = {
  newStatusName: Scalars['String']['input']
  oldStatusName: Scalars['String']['input']
  statusId: Scalars['ID']['input']
}

export type UpdateLeadsPipelineStatusPositionInput = {
  oldStatusId: Scalars['ID']['input']
  swappedStatusId: Scalars['ID']['input']
}

export type UpdateLeadsToLandingpageInput = {
  invitedAt?: InputMaybe<Scalars['DateTime']['input']>
  savedContentId?: InputMaybe<Scalars['ID']['input']>
}

export type UpdateMarketingPlanSlotScheduleInput = {
  date: Scalars['String']['input']
  planId: Scalars['ID']['input']
  platform: SocialMediaType
  slotId: Scalars['ID']['input']
  time: Scalars['String']['input']
}

export type UpdateMaterialModeInput = {
  materialId: Scalars['ID']['input']
  mode: MaterialMode
}

export type UpdateNextMessageInput = {
  /** Email attachments. */
  attachments?: InputMaybe<Array<EmailAttachmentInput>>
  /** Automation ID for tracking. */
  automationId?: InputMaybe<Scalars['String']['input']>
  /** The contact ID for the message. */
  contactId: Scalars['ID']['input']
  /** Edited HTML body. */
  editedHtmlBody?: InputMaybe<Scalars['String']['input']>
  /** Edited MJML body. */
  editedMjmlBody?: InputMaybe<Scalars['String']['input']>
  /** Edited plain text body. */
  editedTextBody?: InputMaybe<Scalars['String']['input']>
  /** HTML email body. */
  htmlBody?: InputMaybe<Scalars['String']['input']>
  /** Original HTML body before editing. */
  originalHtmlBody?: InputMaybe<Scalars['String']['input']>
  /** Run ID for automation tracking. */
  runId?: InputMaybe<Scalars['String']['input']>
  /** Step ID for automation tracking. */
  stepId?: InputMaybe<Scalars['String']['input']>
  /** Email subject. */
  subject?: InputMaybe<Scalars['String']['input']>
  /** Plain text email body. */
  textBody?: InputMaybe<Scalars['String']['input']>
}

export type UpdateOnboardingCompanyAutomaticIntegrationInput = {
  automaticIntegration: Scalars['Boolean']['input']
  companyId: Scalars['String']['input']
}

export type UpdateOnboardingCompanyDetails = {
  address?: InputMaybe<CompanyAddressInput>
  brokerageName?: InputMaybe<Scalars['String']['input']>
  brokerageNameSameAsName?: InputMaybe<Scalars['Boolean']['input']>
  commission?: InputMaybe<Scalars['String']['input']>
  companyId: Scalars['String']['input']
  hasNoInitialWebsite?: InputMaybe<Scalars['Boolean']['input']>
  licenseNumber?: InputMaybe<Scalars['String']['input']>
  licenseStatus?: InputMaybe<Scalars['String']['input']>
  links?: InputMaybe<CompanyLinksInput>
  name?: InputMaybe<Scalars['String']['input']>
}

export type UpdateOnboardingCompanyImagesInput = {
  companyId: Scalars['String']['input']
  images: Array<InputMaybe<ImageWithType>>
}

export type UpdateOnboardingCompanyIsReferenceCustomer = {
  companyId: Scalars['String']['input']
  isReferenceCustomer?: InputMaybe<Scalars['Boolean']['input']>
}

export type UpdateOnboardingCompanySlogan = {
  companyId: Scalars['String']['input']
  slogan?: InputMaybe<Scalars['String']['input']>
}

export type UpdateOptionalFieldsInput = {
  optionalFields: Array<OptionalField>
}

export type UpdateProvenExpertLinkInput = {
  companyId: Scalars['ID']['input']
  provenExpertLink?: InputMaybe<Scalars['String']['input']>
}

export type UpdateProvenExpertOnLandingpageInput = {
  companyId: Scalars['ID']['input']
  showProvenExpertOnLandingpage: Scalars['Boolean']['input']
}

export type UpdateSavedContentBatchInput = {
  customSchedules?: InputMaybe<Array<CustomScheduleInput>>
  postingBatchId: Scalars['ID']['input']
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>
  text?: InputMaybe<Scalars['String']['input']>
}

export type UpdateSavedContentInput = {
  customSchedules?: InputMaybe<Array<CustomScheduleInput>>
  id: Scalars['ID']['input']
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>
  text?: InputMaybe<Scalars['String']['input']>
}

export type UpdateSlotTextInput = {
  planId: Scalars['ID']['input']
  slotId: Scalars['ID']['input']
  text: Scalars['String']['input']
}

export type UpdateSocialMediaPostInput = {
  exteranlPostId?: InputMaybe<Scalars['String']['input']>
  permalink?: InputMaybe<Scalars['String']['input']>
  postId: Scalars['ID']['input']
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type UpdateTopicInput = {
  description: Scalars['String']['input']
  id: Scalars['ID']['input']
  links?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  name: Scalars['String']['input']
  visibility?: InputMaybe<TopicVisibilityInput>
}

export type UpdateUserInput = {
  email?: InputMaybe<Scalars['String']['input']>
  firstname: Scalars['String']['input']
  id: Scalars['String']['input']
  lastname: Scalars['String']['input']
  phone?: InputMaybe<Scalars['String']['input']>
  receiveNotificationEmails?: InputMaybe<UserReceiveNotificationEmailsInput>
  role?: InputMaybe<Scalars['ID']['input']>
  salutation?: InputMaybe<Scalars['String']['input']>
}

export type UpdateUserLocaleInput = {
  appLocale?: InputMaybe<Scalars['String']['input']>
}

export type UpdateUserNameInput = {
  firstname: Scalars['String']['input']
  lastname: Scalars['String']['input']
}

export type UpdateUserNotificationSettingsInput = {
  enabled: Scalars['Boolean']['input']
  notification: Scalars['String']['input']
  source: Scalars['String']['input']
}

export type UpdateUserPhoneInput = {
  phone?: InputMaybe<Scalars['String']['input']>
}

export type UpdateUserUploadedMaterialInput = {
  /** The company ID (optional, will use authenticated user's company if not provided) */
  companyId?: InputMaybe<Scalars['ID']['input']>
  /** The new display name (optional) */
  displayName?: InputMaybe<Scalars['String']['input']>
  /** The material ID to update */
  materialId: Scalars['ID']['input']
  /** The new topic ID (optional) */
  topicId?: InputMaybe<Scalars['ID']['input']>
}

export type UpdateValuationProviderInput = {
  companyId: Scalars['ID']['input']
  enabledTypes: EnabledTypesInput
}

export type UpdateWidgetTypeInput = {
  companyId: Scalars['ID']['input']
  widgetType: CmsWidgetType
}

export type UpgradeToBasicInput = {
  companyId: Scalars['ID']['input']
  isYearly: Scalars['Boolean']['input']
}

export type UpgradeToExpertInput = {
  companyId: Scalars['ID']['input']
  isYearly: Scalars['Boolean']['input']
}

export type UploadAdMaterialInput = {
  /** The file to upload */
  file: Scalars['Upload']['input']
  /** The topic ID to associate with the file */
  topicId: Scalars['ID']['input']
}

export type UploadAdMaterialResponse = {
  __typename?: 'UploadAdMaterialResponse'
  error?: Maybe<Scalars['String']['output']>
  material?: Maybe<AdMaterial>
  success: Scalars['Boolean']['output']
}

export type UploadError = {
  __typename?: 'UploadError'
  error?: Maybe<Scalars['String']['output']>
  file?: Maybe<Scalars['String']['output']>
}

/** Input for the uploadUserTopicMaterial mutation */
export type UploadMaterialInput = {
  /** Optional asset type override (if not provided, will be determined from file type) */
  assetType?: InputMaybe<AssetType>
  /** The company ID (optional, will use authenticated user's company if not provided) */
  companyId?: InputMaybe<Scalars['ID']['input']>
  /** Optional display name for the uploaded material */
  displayName?: InputMaybe<Scalars['String']['input']>
  /** The file to upload */
  file: Scalars['Upload']['input']
  materialId: Scalars['ID']['input']
  /** Optional preview file (not needed, kept for compatibility) */
  previewFile: Scalars['Upload']['input']
  /** The topic ID to associate with the file */
  topicId?: InputMaybe<Scalars['ID']['input']>
}

export type UploadMultipleAdMaterialsInput = {
  /** The array of files to upload */
  files: Array<Scalars['Upload']['input']>
  /** The array of topic IDs to associate with each file (same order as files) */
  topicIds: Array<Scalars['ID']['input']>
}

export type UploadMultipleAdMaterialsResponse = {
  __typename?: 'UploadMultipleAdMaterialsResponse'
  errors: Array<UploadError>
  materials: Array<AdMaterial>
  success: Scalars['Boolean']['output']
}

export type UploadUserImageInput = {
  image: Scalars['Upload']['input']
  topicId: Scalars['ID']['input']
}

export type UploadUserMaterialInput = {
  /** The file to upload */
  file: Scalars['Upload']['input']
  /** The topic ID to associate with the file */
  topicId: Scalars['ID']['input']
}

export enum UseHashtags {
  Medium = 'medium',
  None = 'none',
}

export type User = {
  __typename?: 'User'
  appLocale?: Maybe<Scalars['String']['output']>
  company?: Maybe<CompanyName>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  email?: Maybe<Scalars['String']['output']>
  emailState?: Maybe<EmailState>
  firstname?: Maybe<Scalars['String']['output']>
  gender?: Maybe<Gender>
  id?: Maybe<Scalars['String']['output']>
  isBlocked?: Maybe<Scalars['Boolean']['output']>
  isContractOwner?: Maybe<Scalars['Boolean']['output']>
  isPassive?: Maybe<Scalars['Boolean']['output']>
  isSso?: Maybe<Scalars['Boolean']['output']>
  lastLoginAt?: Maybe<Scalars['DateTime']['output']>
  lastname?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
  /** @deprecated use notification.settings */
  receiveNotificationEmails?: Maybe<UserReceiveNotificationEmails>
  role?: Maybe<Role>
  salutation?: Maybe<Scalars['String']['output']>
}

export type UserImage = ImageInterface & {
  __typename?: 'UserImage'
  companyId?: Maybe<Scalars['ID']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  fileId: Scalars['ID']['output']
  fileSize?: Maybe<Scalars['Int']['output']>
  height?: Maybe<Scalars['Int']['output']>
  history?: Maybe<Array<Maybe<EditHistoryEntry>>>
  id: Scalars['ID']['output']
  originalImageUrl?: Maybe<Scalars['String']['output']>
  topicId?: Maybe<Scalars['ID']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  url?: Maybe<Scalars['String']['output']>
  width?: Maybe<Scalars['Int']['output']>
}

export type UserImages = {
  __typename?: 'UserImages'
  images?: Maybe<Array<Maybe<UserImage>>>
  page?: Maybe<Scalars['Int']['output']>
  perPage?: Maybe<Scalars['Int']['output']>
  total?: Maybe<Scalars['Int']['output']>
}

export type UserReceiveNotificationEmails = {
  __typename?: 'UserReceiveNotificationEmails'
  leadAction?: Maybe<Scalars['Boolean']['output']>
  newsletter?: Maybe<Scalars['Boolean']['output']>
}

export type UserReceiveNotificationEmailsInput = {
  leadAction: Scalars['Boolean']['input']
  newsletter?: InputMaybe<Scalars['Boolean']['input']>
}

export type UserSettings = {
  __typename?: 'UserSettings'
  id?: Maybe<Scalars['ID']['output']>
  notificationSettings?: Maybe<NotificationSettings>
  phone?: Maybe<Scalars['String']['output']>
}

export type UserUploadedMaterial = {
  __typename?: 'UserUploadedMaterial'
  assetType?: Maybe<AssetType>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  displayName?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  previewFile?: Maybe<PreviewFile>
  type?: Maybe<Scalars['String']['output']>
  url: Scalars['String']['output']
}

export type Utm = {
  __typename?: 'Utm'
  count?: Maybe<Scalars['Int']['output']>
  label?: Maybe<Scalars['String']['output']>
}

export type UtmParameterCount = {
  __typename?: 'UtmParameterCount'
  count?: Maybe<Scalars['Int']['output']>
  value?: Maybe<Scalars['String']['output']>
}

export type UtmParametersResponse = {
  __typename?: 'UtmParametersResponse'
  utmCampaign?: Maybe<Array<Maybe<UtmParameterCount>>>
  utmContent?: Maybe<Array<Maybe<UtmParameterCount>>>
  utmMedium?: Maybe<Array<Maybe<UtmParameterCount>>>
  utmSource?: Maybe<Array<Maybe<UtmParameterCount>>>
  utmTerm?: Maybe<Array<Maybe<UtmParameterCount>>>
}

export type UtmParams = {
  __typename?: 'UtmParams'
  campaign?: Maybe<Scalars['String']['output']>
  content?: Maybe<Scalars['String']['output']>
  medium?: Maybe<Scalars['String']['output']>
  source?: Maybe<Scalars['String']['output']>
  term?: Maybe<Scalars['String']['output']>
}

export type UtmParamsInput = {
  campaign?: InputMaybe<Scalars['String']['input']>
  content?: InputMaybe<Scalars['String']['input']>
  medium?: InputMaybe<Scalars['String']['input']>
  source?: InputMaybe<Scalars['String']['input']>
  term?: InputMaybe<Scalars['String']['input']>
}

export type UtmTrafficCount = {
  __typename?: 'UtmTrafficCount'
  utmKey?: Maybe<Scalars['String']['output']>
  values?: Maybe<Array<Maybe<Utm>>>
}

export type ValidateFileImportColumnNameInput = {
  mappedCol: Scalars['String']['input']
  targetCol: FileImportColumnNameType
}

export type ValidateFileImportDataInput = {
  columnNameMapping: Array<InputMaybe<ValidateFileImportColumnNameInput>>
  fileName: Scalars['String']['input']
  rawData: Array<InputMaybe<Scalars['JSONObject']['input']>>
}

export type ValidateFileImportResult = {
  __typename?: 'ValidateFileImportResult'
  importId?: Maybe<Scalars['String']['output']>
  invalidRows?: Maybe<Array<Maybe<ValidatedFileImportDataReturnType>>>
  invalidRowsCount?: Maybe<Scalars['Int']['output']>
  validRows?: Maybe<Array<Maybe<ValidateFileImportResultSuccess>>>
  validRowsCount?: Maybe<Scalars['Int']['output']>
}

export type ValidateFileImportResultSuccess = {
  __typename?: 'ValidateFileImportResultSuccess'
  data?: Maybe<FileImportValidColumnName>
}

export type ValidateSignUpTokenInput = {
  partner?: InputMaybe<CrmProvider>
  token: Scalars['String']['input']
}

export type ValidatedFileImportData = {
  __typename?: 'ValidatedFileImportData'
  entries: Array<Maybe<ValidatedFileImportDataReturnType>>
  hasMore: Scalars['Boolean']['output']
  total: Scalars['Int']['output']
}

export type ValidatedFileImportDataInput = {
  dataType: ValidatedFileImportDataType
  importId: Scalars['ID']['input']
  itemsPerPage: Scalars['Int']['input']
  page: Scalars['Int']['input']
}

export type ValidatedFileImportDataReturnType = {
  __typename?: 'ValidatedFileImportDataReturnType'
  data?: Maybe<FileImportValidColumnName>
  invalidColumns?: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export enum ValidatedFileImportDataType {
  Error = 'ERROR',
  Success = 'SUCCESS',
}

export type Valuation = {
  __typename?: 'Valuation'
  completedAt?: Maybe<Scalars['DateTime']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  createdByAgent?: Maybe<Scalars['Boolean']['output']>
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  id?: Maybe<Scalars['ID']['output']>
  inputs?: Maybe<ValuationInputs>
  lead?: Maybe<Lead>
  leadId?: Maybe<Scalars['ID']['output']>
  pdf?: Maybe<ValuationPdf>
  propertyId?: Maybe<Scalars['ID']['output']>
  provider?: Maybe<ValuationProvider>
  reason?: Maybe<ValuationReason>
  results?: Maybe<ValuationResults>
  status?: Maybe<ValuationStatus>
  user?: Maybe<User>
  userId?: Maybe<Scalars['ID']['output']>
}

export type ValuationAddress = {
  __typename?: 'ValuationAddress'
  city?: Maybe<Scalars['String']['output']>
  countryCode?: Maybe<CountryCode>
  houseNumber?: Maybe<Scalars['String']['output']>
  street?: Maybe<Scalars['String']['output']>
  zip?: Maybe<Scalars['String']['output']>
}

export type ValuationAddressInput = {
  city: Scalars['String']['input']
  countryCode: CountryCode
  houseNumber?: InputMaybe<Scalars['String']['input']>
  street: Scalars['String']['input']
  zip: Scalars['String']['input']
}

export enum ValuationCondition {
  NewOrRecentlyRenovated = 'NEW_OR_RECENTLY_RENOVATED',
  RenovationNeeded = 'RENOVATION_NEEDED',
  WellMaintained = 'WELL_MAINTAINED',
}

export type ValuationInputLimit = {
  __typename?: 'ValuationInputLimit'
  max?: Maybe<Scalars['Int']['output']>
  min?: Maybe<Scalars['Int']['output']>
}

export type ValuationInputLimits = {
  __typename?: 'ValuationInputLimits'
  annualRentIncome?: Maybe<ValuationInputLimit>
  balconyArea?: Maybe<ValuationInputLimit>
  buildingYear?: Maybe<ValuationInputLimit>
  floorNumber?: Maybe<ValuationInputLimit>
  landArea?: Maybe<ValuationInputLimit>
  livingArea?: Maybe<ValuationInputLimit>
  numberOfRooms?: Maybe<ValuationInputLimit>
  numberOfUnits?: Maybe<ValuationInputLimit>
}

export type ValuationInputs = {
  __typename?: 'ValuationInputs'
  address?: Maybe<ValuationAddress>
  annualRentIncome?: Maybe<Scalars['Int']['output']>
  balconyArea?: Maybe<Scalars['Int']['output']>
  buildingYear?: Maybe<Scalars['Int']['output']>
  condition?: Maybe<ValuationCondition>
  coordinates?: Maybe<PropertyCoordinates>
  floorNumber?: Maybe<Scalars['Int']['output']>
  landArea?: Maybe<Scalars['Int']['output']>
  livingArea?: Maybe<Scalars['Int']['output']>
  numberOfRooms?: Maybe<Scalars['Float']['output']>
  numberOfUnits?: Maybe<Scalars['Int']['output']>
  quality?: Maybe<ValuationQuality>
  subType?: Maybe<PropertySubType>
  type?: Maybe<PropertyType>
}

export type ValuationPdf = {
  __typename?: 'ValuationPdf'
  file?: Maybe<File>
  status?: Maybe<ValuationPdfStatus>
}

export enum ValuationPdfStatus {
  Completed = 'COMPLETED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
}

export enum ValuationProvider {
  Fpre = 'FPRE',
  Iazi = 'IAZI',
  Immosparrow = 'IMMOSPARROW',
  Manual = 'MANUAL',
  PriceHubble = 'PRICE_HUBBLE',
  Sprengnetter = 'SPRENGNETTER',
}

export enum ValuationQuality {
  High = 'HIGH',
  Luxury = 'LUXURY',
  Normal = 'NORMAL',
  Simple = 'SIMPLE',
}

export enum ValuationReason {
  BuyingInterest = 'BUYING_INTEREST',
  Heritage = 'HERITAGE',
  NeedPropertyBeforeSelling = 'NEED_PROPERTY_BEFORE_SELLING',
  PlanningToSell = 'PLANNING_TO_SELL',
  PriceTrend = 'PRICE_TREND',
}

export type ValuationResultProperty = {
  __typename?: 'ValuationResultProperty'
  value?: Maybe<Scalars['Int']['output']>
  valueConfidence?: Maybe<ValuationValueConfidence>
  valueRange?: Maybe<ValuationValueRange>
  valueTrend?: Maybe<Array<Maybe<ValuationValueTrend>>>
}

export type ValuationResultSurroundings = {
  __typename?: 'ValuationResultSurroundings'
  squareMeterPrice?: Maybe<ValuationSquareMeterPrice>
}

export type ValuationResults = {
  __typename?: 'ValuationResults'
  currency?: Maybe<Currency>
  property?: Maybe<ValuationResultProperty>
  surroundings?: Maybe<ValuationResultSurroundings>
}

export type ValuationSquareMeterPrice = {
  __typename?: 'ValuationSquareMeterPrice'
  cityLevel?: Maybe<ValuationSquareMeterPriceLevel>
  zipLevel?: Maybe<ValuationSquareMeterPriceLevel>
}

export type ValuationSquareMeterPriceLevel = {
  __typename?: 'ValuationSquareMeterPriceLevel'
  avg?: Maybe<Scalars['Int']['output']>
  max?: Maybe<Scalars['Int']['output']>
  min?: Maybe<Scalars['Int']['output']>
}

export enum ValuationStatus {
  Completed = 'COMPLETED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
}

export enum ValuationValueConfidence {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  Unknown = 'UNKNOWN',
}

export type ValuationValueRange = {
  __typename?: 'ValuationValueRange'
  max?: Maybe<Scalars['Int']['output']>
  min?: Maybe<Scalars['Int']['output']>
}

export type ValuationValueTrend = {
  __typename?: 'ValuationValueTrend'
  date?: Maybe<Scalars['DateTime']['output']>
  value?: Maybe<Scalars['Int']['output']>
  valueRange?: Maybe<ValuationValueRange>
}

export type ValuationsPaginated = {
  __typename?: 'ValuationsPaginated'
  hasMore?: Maybe<Scalars['Boolean']['output']>
  valuations?: Maybe<Array<Maybe<Valuation>>>
}

export enum Variant {
  Atv1 = 'ATV1',
  Chfr = 'CHFR',
  Chit = 'CHIT',
  Chv1 = 'CHV1',
  Chv2 = 'CHV2',
  Default = 'DEFAULT',
  Dv1 = 'DV1',
  Dv2 = 'DV2',
  Dv3 = 'DV3',
  Dv4 = 'DV4',
  Falc = 'FALC',
  Light = 'LIGHT',
  Remax = 'REMAX',
  Showcase = 'SHOWCASE',
  Test = 'TEST',
  Turkoglu = 'TURKOGLU',
  Tv1 = 'TV1',
  Usv1 = 'USV1',
  Volksbank = 'VOLKSBANK',
}

export type Voucher = {
  __typename?: 'Voucher'
  code?: Maybe<Scalars['String']['output']>
  company?: Maybe<Scalars['ID']['output']>
  expiresAt?: Maybe<Scalars['DateTime']['output']>
  type?: Maybe<VoucherType>
}

export enum VoucherType {
  Bewertungsloescher = 'BEWERTUNGSLOESCHER',
  Fify = 'FIFY',
  Maklersprechstunde = 'MAKLERSPRECHSTUNDE',
  Mecoa = 'MECOA',
  Multiphone = 'MULTIPHONE',
  Pixelmotion = 'PIXELMOTION',
  Pricehubble = 'PRICEHUBBLE',
  Redcup = 'REDCUP',
  Solowerk = 'SOLOWERK',
  VonFred = 'VON_FRED',
}

export type When = {
  __typename?: 'When'
  date?: Maybe<Scalars['String']['output']>
  timezone?: Maybe<Scalars['String']['output']>
}

export type ZipcodesForCompanyInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>
  filters?: InputMaybe<FilterInput>
}

export type AnalyticsImpressionForCompany = {
  __typename?: 'analyticsImpressionForCompany'
  last30DaysTotal?: Maybe<Scalars['Int']['output']>
  overallTotal?: Maybe<Scalars['Int']['output']>
  specificDateTotals?: Maybe<Array<Maybe<AnalyticsImpressionForCompanyDateTotal>>>
  utmTrafficCounts?: Maybe<Array<Maybe<UtmTrafficCount>>>
}

export type AnalyticsImpressionForCompanyDateTotal = {
  __typename?: 'analyticsImpressionForCompanyDateTotal'
  count?: Maybe<Scalars['Int']['output']>
  date?: Maybe<Scalars['DateTime']['output']>
}

export type DailyAnalyticsImpressionForCompany = {
  __typename?: 'dailyAnalyticsImpressionForCompany'
  impressions?: Maybe<Scalars['Int']['output']>
  utmTrafficCounts?: Maybe<Array<Maybe<UtmTrafficCount>>>
}

export type DailyAnalyticsImpressions = {
  __typename?: 'dailyAnalyticsImpressions'
  companyId?: Maybe<Scalars['ID']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  impressions?: Maybe<Scalars['Int']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  utmParameters?: Maybe<Array<Maybe<UtmTrafficCount>>>
}

export type OptionalField = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  name: Scalars['String']['input']
  optional?: InputMaybe<Scalars['Boolean']['input']>
}

export type TextKindStatistics = {
  __typename?: 'textKindStatistics'
  count?: Maybe<Scalars['Int']['output']>
  textKind?: Maybe<Scalars['String']['output']>
}

export type TopicStatistics = {
  __typename?: 'topicStatistics'
  count?: Maybe<Scalars['Int']['output']>
  topicName?: Maybe<Scalars['String']['output']>
}
